const actionTypes = {
	ACTIVITY_BANKS_ACTIVITY_SELECTED: 'ACTIVITY_BANKS/ACTIVITY_SELECTED',
	ACTIVITY_BANKS_ACTIVITY_SELECTED_CANCELLED: 'ACTIVITY_BANKS/ACTIVITY_SELECTED_CANCELLED',
	ACTIVITY_BANKS_ACTIVITY_SELECTED_CONFIRMED: 'ACTIVITY_BANKS/ACTIVITY_SELECTED_CONFIRMED',
	ACTIVITY_BANKS_ACTIVITY_SELECTED_STARTED: 'ACTIVITY_BANKS/ACTIVITY_SELECTED_STARTED',
	ACTIVITY_BANKS_ACTIVITY_UPDATE_FAILED: 'ACTIVITY_BANKS/ACTIVITY_UPDATE_FAILED',
	ACTIVITY_BANKS_ACTIVITY_UPDATED: 'ACTIVITY_BANKS/ACTIVITY_UPDATED',
	ACTIVITY_BANKS_CUSTOM_ACTIVITY_UPDATED: 'ACTIVITY_BANKS/CUSTOM_ACTIVITY_UPDATED',
	ACTIVITY_BANKS_MOUNTED: 'ACTIVITY_BANKS/MOUNTED',
	ACTIVITY_BANKS_UNMOUNTED: 'ACTIVITY_BANKS/UNMOUNTED',
	ACTIVITY_MCQ_MOUNTED: 'ACTIVITY/MCQ/MOUNTED',
	ACTIVITY_MCQ_STATUS_FETCHED: 'ACTIVITY/MCQ/STATUS_FETCHED',
	ACTIVITY_MCQ_STUDENT_MOUNTED: 'ACTIVITY/MCQ/STUDENT_MOUNTED',
	ACTIVITY_MCQ_UNMOUNTED: 'ACTIVITY/MCQ/UNMOUNTED',
	ACTIVITY_OEQ_MOUNTED: 'ACTIVITY/OEQ/MOUNTED',
	ACTIVITY_OEQ_STATUS_FETCHED: 'ACTIVITY/OEQ/STATUS_FETCHED',
	ACTIVITY_OEQ_STUDENT_MOUNTED: 'ACTIVITY/OEQ/STUDENT_MOUNTED',
	ACTIVITY_OEQ_UNMOUNTED: 'ACTIVITY/OEQ/UNMOUNTED',
	ADMIN_DASHBOARD_TOOLTIP_ACCEPTED: 'ADMIN_DASHBOARD/TOOLTIP_ACCEPTED',
	ADMIN_ONBOARDING_ACCEPT_WELCOME_INVITE: 'ADMIN_ONBOARDING/ACCEPT_WELCOME_INVITE',
	ADMIN_ONBOARDING_ACCEPT_WELCOME_INVITE_REDIRECT: 'ADMIN_ONBOARDING/ACCEPT_WELCOME_INVITE_REDIRECT',
	ADMIN_ONBOARDING_ADD_TEACHERS_INITIALIZE: 'ADMIN_ONBOARDING/ADD_TEACHERS/INITIALIZE',
	ADMIN_ONBOARDING_ADD_TEACHERS_INITIALIZE_VIEW: 'ADMIN_ONBOARDING/ADD_TEACHERS/INITIALIZE_VIEW',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_ACTION: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_ACTION',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CANCELED: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_CANCELED',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_COLLEAGUES',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_COLLEAGUES_SUCCESS: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_COLLEAGUES_SUCCESS',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMATION: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_CONFIRMATION',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_CONFIRMED: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_CONFIRMED',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_INITIALIZE: 'ADMIN_ONBOARDING/ADD_TEACHERS/INITIALIZE',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_METRICS_SUCCESS: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_METRICS_SUCCESS',
	ADMIN_ONBOARDING_ADD_TEACHERS_SHARE_REDIRECT: 'ADMIN_ONBOARDING/ADD_TEACHERS/SHARE_REDIRECT',
	ADMIN_ONBOARDING_ADD_USER: 'ADMIN_ONBOARDING/ADD_USER',
	ADMIN_ONBOARDING_ADD_USER_FAILED: 'ADMIN_ONBOARDING/ADD_USER_FAILED',
	ADMIN_ONBOARDING_ADD_USER_SUCCESS: 'ADMIN_ONBOARDING/ADD_USER_SUCCESS',
	ADMIN_ONBOARDING_ANIMATION_COMPLETED: 'ADMIN_ONBOARDING/ANIMATION_COMPLETED',
	ADMIN_ONBOARDING_CHANGE_STEP: 'ADMIN_ONBOARDING/CHANGE_STEP',
	ADMIN_ONBOARDING_CONGRATS_TO_NEARPOD_LIBRARY: 'ADMIN_ONBOARDING/CONGRATS_TO_NEARPOD_LIBRARY',
	ADMIN_ONBOARDING_CONGRATS_TO_NEARPOD_LIBRARY_REDIRECT: 'ADMIN_ONBOARDING/CONGRATS_TO_NEARPOD_LIBRARY_REDIRECT',
	ADMIN_ONBOARDING_GET_TRIAL_DATA_COMPLETED: 'ADMIN_ONBOARDING/GET_TRIAL_DATA/COMPLETED',
	ADMIN_ONBOARDING_GET_USERS_FETCHED: 'ADMIN_ONBOARDING/GET_USERS_FETCHED',
	ADMIN_ONBOARDING_INITIALIZE: 'ADMIN_ONBOARDING/INITIALIZE',
	ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_NO: 'ADMIN_ONBOARDING/INITIALIZE_CONFIRM_SCHOOL_NO',
	ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_VIEW: 'ADMIN_ONBOARDING/INITIALIZE_CONFIRM_SCHOOL_VIEW',
	ADMIN_ONBOARDING_INITIALIZE_CONFIRM_SCHOOL_YES: 'ADMIN_ONBOARDING/INITIALIZE_CONFIRM_SCHOOL_YES',
	ADMIN_ONBOARDING_INITIALIZE_INVITE_VIEW: 'ADMIN_ONBOARDING/INITIALIZE_INVITE_VIEW',
	ADMIN_ONBOARDING_INITIALIZE_SCHOOL_VIEW: 'ADMIN_ONBOARDING/INITIALIZE_SCHOOL_VIEW',
	ADMIN_ONBOARDING_INVITE_CANCELED: 'ADMIN_ONBOARDING/INVITE_CANCELED',
	ADMIN_ONBOARDING_INVITE_COLLEAGUE: 'ADMIN_ONBOARDING/INVITE_COLLEAGUE',
	ADMIN_ONBOARDING_INVITE_CONFIRMATION: 'ADMIN_ONBOARDING/INVITE_CONFIRMATION',
	ADMIN_ONBOARDING_INVITE_CONFIRMED: 'ADMIN_ONBOARDING/INVITE_CONFIRMED',
	ADMIN_ONBOARDING_INVITE_TEACHERS_INITIALIZE: 'ADMIN_ONBOARDING/INVITE_TEACHERS_INITIALIZE',
	ADMIN_ONBOARDING_INVITE_TEACHERS_REDIRECT: 'ADMIN_ONBOARDING/INVITE_TEACHERS_REDIRECT',
	ADMIN_ONBOARDING_INVITE_USERS: 'ADMIN_ONBOARDING/INVITE_USERS',
	ADMIN_ONBOARDING_INVITE_USERS_SUCCESS: 'ADMIN_ONBOARDING/INVITE_USERS_SUCCESS',
	ADMIN_ONBOARDING_JOIN_COLLEAGUES: 'ADMIN_ONBOARDING/JOIN_COLLEAGUES',
	ADMIN_ONBOARDING_JOIN_COLLEAGUES_SUCCESS: 'ADMIN_ONBOARDING/JOIN_COLLEAGUES_SUCCESS',
	ADMIN_ONBOARDING_NAVIGATE_TO_STEP: 'ADMIN_ONBOARDING/NAVIGATE_TO_STEP',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_GO_TO_MY_LIBRARY: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/GO_TO_MY_LIBRARY',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_INITIALIZE: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/INITIALIZE',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT_CLOSE',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_CLOSE_SUCCESS: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT_CLOSE_SUCCESS',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_METRICS_SUCCESS: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT_METRICS_SUCCESS',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT_SEND',
	ADMIN_ONBOARDING_NO_DM_INFORMATION_REFER_CONTACT_SEND_SUCCESS: 'ADMIN_ONBOARDING/NO_DM_INFORMATION/REFER_CONTACT_SEND_SUCCESS',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/EXPLORE_LESSONS',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS_METRICS_SUCCESS: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/EXPLORE_LESSONS_METRICS_SUCCESS',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_EXPLORE_LESSONS_SUCCESS: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/EXPLORE_LESSONS_SUCCESS',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_GO_TO_MY_LIBRARY: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/GO_TO_MY_LIBRARY',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_GO_TO_MY_LIBRARY_SUCCESS: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/GO_TO_MY_LIBRARY_SUCCESS',
	ADMIN_ONBOARDING_NO_STORE_DOWNLOADS_INITIALIZE: 'ADMIN_ONBOARDING/NO_STORE_DOWNLOADS/INITIALIZE',
	ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON: 'ADMIN_ONBOARDING/PREMIUM_ACTIVITIES/ADD_LESSON',
	ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_ADD_LESSON_COMPLETED: 'ADMIN_ONBOARDING/PREMIUM_ACTIVITIES/ADD_LESSON_COMPLETED',
	ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_GO_TO_MY_LIBRARY: 'ADMIN_ONBOARDING/PREMIUM_ACTIVITIES/GO_TO_MY_LIBRARY',
	ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_INITIALIZE: 'ADMIN_ONBOARDING/PREMIUM_ACTIVITIES/INITIALIZE',
	ADMIN_ONBOARDING_PREMIUM_ACTIVITIES_SHOW_MY_LIBRARY: 'ADMIN_ONBOARDING/PREMIUM_ACTIVITIES/SHOW_MY_LIBRARY',
	ADMIN_ONBOARDING_REDIRECT_AFTER_CONGRATS: 'ADMIN_ONBOARDING/REDIRECT_AFTER_CONGRATS',
	ADMIN_ONBOARDING_REFER_A_CONTACT: 'ADMIN_ONBOARDING/REFER_A_CONTACT',
	ADMIN_ONBOARDING_REFER_A_CONTACT_SENT: 'ADMIN_ONBOARDING/REFER_A_CONTACT_SENT',
	ADMIN_ONBOARDING_REFER_A_CONTACT_SENT_SUCCESS: 'ADMIN_ONBOARDING/REFER_A_CONTACT_SENT_SUCCESS',
	ADMIN_ONBOARDING_REFER_CONTACT_INITIALIZE: 'ADMIN_ONBOARDING/REFER_CONTACT_INITIALIZE',
	ADMIN_ONBOARDING_REFER_CONTACT_MODAL_CLOSE: 'ADMIN_ONBOARDING/REFER_CONTACT_MODAL_CLOSE',
	ADMIN_ONBOARDING_REFER_CONTACT_MODAL_OPEN: 'ADMIN_ONBOARDING/REFER_CONTACT_MODAL_OPEN',
	ADMIN_ONBOARDING_RESET_STEP_TRANSITION: 'ADMIN_ONBOARDING/RESET_STEP_TRANSITION',
	ADMIN_ONBOARDING_SCHOOL_CANCELED: 'ADMIN_ONBOARDING/SCHOOL_CANCELED',
	ADMIN_ONBOARDING_SCHOOL_CONFIRMED_SUCCESS: 'ADMIN_ONBOARDING/SCHOOL_CONFIRMED_SUCCESS',
	ADMIN_ONBOARDING_SCHOOL_CONFIRM_DO_REDIRECT_TO_MY_LIBRARY: 'ADMIN_ONBOARDING/SCHOOL_CONFIRM_DO_REDIRECT_TO_MY_LIBRARY',
	ADMIN_ONBOARDING_SCHOOL_CONFIRM_NO: 'ADMIN_ONBOARDING/SCHOOL_CONFIRM_NO',
	ADMIN_ONBOARDING_SCHOOL_CONFIRM_REDIRECT_TO_MY_LIBRARY: 'ADMIN_ONBOARDING/SCHOOL_CONFIRM_REDIRECT_TO_MY_LIBRARY',
	ADMIN_ONBOARDING_SCHOOL_CONFIRM_YES: 'ADMIN_ONBOARDING/SCHOOL_CONFIRM_YES',
	ADMIN_ONBOARDING_SCHOOL_NOT_CONFIRMED_SUCCESS: 'ADMIN_ONBOARDING/SCHOOL_NOT_CONFIRMED_SUCCESS',
	ADMIN_ONBOARDING_SELECT_USER: 'ADMIN_ONBOARDING/SELECT_USER',
	ADMIN_ONBOARDING_SKIP_FAILED: 'ADMIN_ONBOARDING/SKIP_FAILED',
	ADMIN_ONBOARDING_SKIP_INVITE_TEACHERS: 'ADMIN_ONBOARDING/SKIP_INVITE_TEACHERS',
	ADMIN_ONBOARDING_SKIP_TO_LAST_STEP: 'ADMIN_ONBOARDING/SKIP_TO_LAST_STEP',
	ADMIN_ONBOARDING_SKIP_TO_LAST_STEP_REDIRECT: 'ADMIN_ONBOARDING/SKIP_TO_LAST_STEP_REDIRECT',
	ADMIN_ONBOARDING_TRANSITION_STEP: 'ADMIN_ONBOARDING/TRANSITION_STEP',
	ADMIN_ONBOARDING_VALIDATE_STEP_FAILED: 'ADMIN_ONBOARDING/VALIDATE_STEP_FAILED',
	ADMIN_ONBOARDING_VALIDATE_STEP_SUCCESS: 'ADMIN_ONBOARDING/VALIDATE_STEP_SUCCESS',
	ADMIN_ONBOARDING_VALIDATE_STEP_WHITELIST_ERROR: 'ADMIN_ONBOARDING/VALIDATE_STEP_WHITELIST_ERROR',
	APP_INITIALIZE: 'APP/INITIALIZE',
	AUTO_LOGIN: 'AUTO_LOGIN',
	BINDERS_BINDER_CREATE: 'BINDERS/BINDER_CREATE',
	BINDERS_BINDER_CREATE_END: 'BINDERS/BINDER_CREATE_END',
	BINDERS_BINDER_CREATE_FAIL: 'BINDERS/BINDER_CREATE_FAIL',
	BINDERS_BINDER_CREATE_NEW: 'BINDERS/BINDER_CREATE_NEW',
	BINDERS_BINDER_CREATE_RESET: 'BINDERS/BINDER_CREATE_RESET',
	BINDERS_BINDER_CREATE_TEXT_UPDATE: 'BINDERS/BINDER_CREATE_TEXT_UPDATE',
	BINDERS_CANCEL_NOTES: 'BINDERS/CANCEL_NOTES',
	BINDERS_CLOSE_CODES_MODAL: 'BINDERS/CLOSE_CODES_MODAL',
	BINDERS_DELETED_BINDER: 'BINDERS/DELETED_BINDER',
	BINDERS_DELETED_LESSON: 'BINDERS/DELETED_LESSON',
	BINDERS_DELETE_BINDER: 'BINDERS/DELETE_BINDER',
	BINDERS_DELETE_LESSON: 'BINDERS/DELETE_LESSON',
	BINDERS_FOUND_BINDER_LESSONS: 'BINDERS/FOUND_BINDER_LESSONS',
	BINDERS_GET_ALL: 'BINDERS/GET_ALL',
	BINDERS_GET_BINDER_INFORMATION: 'BINDERS/GET_BINDER_INFORMATION',
	BINDERS_GET_BINDER_LESSONS: 'BINDERS/GET_BINDER_LESSONS',
	BINDERS_INITIALIZE: 'BINDERS/INITIALIZE',
	BINDERS_INITIALIZE_LIST: 'BINDERS/INITIALIZE_LIST',
	BINDERS_INIT_SEARCH_BINDER_LESSONS: 'BINDERS/INIT_SEARCH_BINDER_LESSONS',
	BINDERS_LESSONS_FETCHED: 'BINDERS/LESSONS_FETCHED',
	BINDERS_LESSON_CODES_SUCCESS: 'BINDERS/LESSON_CODES_SUCCESS',
	BINDERS_LOAD_VALIDATIONS: 'BINDERS/LOAD_VALIDATIONS',
	BINDERS_ONBOARDING_ANIMATION_COMPLETED: 'BINDERS/ONBOARDING/ANIMATION_COMPLETED',
	BINDERS_ONBOARDING_FAILED: 'BINDERS/ONBOARDING/FAILED',
	BINDERS_ONBOARDING_GO_TO_STEP: 'BINDERS/ONBOARDING/GO_TO_STEP',
	BINDERS_PICKER_CANCEL: 'BINDERS_PICKER/CANCEL',
	BINDERS_PICKER_PICKER_CLOSE: 'BINDERS_PICKER/CLOSE',
	BINDERS_RESET_BINDER_DATA: 'BINDERS/RESET_DATA',
	BINDERS_SAVED_LESSONS: 'BINDERS/SAVED_LESSONS',
	BINDERS_SAVED_NOTES: 'BINDERS/SAVED_NOTES',
	BINDERS_SAVE_FORM: 'BINDERS/SAVE_FORM',
	BINDERS_SAVE_FORM_FAIL: 'BINDERS/SAVE_FORM_FAIL',
	BINDERS_SAVE_FORM_SUCCESS: 'BINDERS/SAVE_FORM_SUCCESS',
	BINDERS_SAVE_FORM_UNCAUGHT: 'BINDERS/SAVE_FORM_UNCAUGHT',
	BINDERS_SAVE_LESSONS: 'BINDERS/SAVE_LESSONS',
	BINDERS_SAVE_LESSONS_SUCCESS: 'BINDERS/SAVE_LESSONS_SUCCESS',
	BINDERS_SAVE_NOTES: 'BINDERS/SAVE_NOTES',
	BINDERS_SAVE_SHARE_FORM: 'BINDERS/SAVE_SHARE_FORM',
	BINDERS_SEARCH_BINDER_LESSONS: 'BINDERS/SEARCH_BINDER_LESSONS',
	BINDERS_SELECT_LESSONS: 'BINDERS/SELECT_LESSONS',
	BINDERS_SET_ALL: 'BINDERS/SET_ALL',
	BINDERS_SET_BINDERS_SORT: 'BINDERS/SET_BINDERS_SORT',
	BINDERS_SET_BINDER_DATA: 'BINDERS/SET_DATA',
	BINDERS_SHARE_FORM: 'BINDERS/SHARE_FORM',
	BINDERS_SHARE_FORM_FAIL: 'BINDERS/SHARE_FORM_FAIL',
	BINDERS_SHARE_FORM_FROM_LESSONS: 'BINDERS/SHARE_FORM_FROM_LESSONS',
	BINDERS_SHARE_FORM_SUCCESS: 'BINDERS/SHARE_FORM_SUCCESS',
	BINDERS_SHARE_FORM_UNCAUGHT: 'BINDERS/SHARE_FORM_UNCAUGHT',
	BINDERS_SHOW_LESSONS_CODE: 'BINDERS/SHOW_LESSONS_CODE',
	BINDERS_SORT_BINDERS: 'BINDERS/SORT_BINDERS',
	BINDERS_STORE_ERRORS: 'BINDERS/STORE_ERRORS',
	BINDERS_TOGGLE_FORM_BOX: 'BINDERS/TOGGLE_FORM_BOX',
	BINDERS_UPDATE_BINDERS_SORT: 'BINDERS/UPDATE_BINDERS_SORT',
	BINDERS_UPLOAD_DOCUMENT: 'BINDERS/UPLOAD_DOCUMENT',
	BINDERS_UPLOAD_DOCUMENT_FAIL: 'BINDERS/UPLOAD_DOCUMENT_FAIL',
	BINDERS_UPLOAD_DOCUMENT_SUCCESS: 'BINDERS/UPLOAD_DOCUMENT_SUCCESS',
	CART_BUY_PRODUCT: 'CART/BUY_PRODUCT',
	CART_BUY_PRODUCT_SUCCESS: 'CART/BUY_PRODUCT_SUCCESS',
	CART_DATA_FETCHED: 'CART/DATA_FETCHED',
	CART_DOWNLOADING: 'CART/DOWNLOADING ',
	CART_GET_DATA: 'CART/GET_DATA',
	CART_GOTO: 'CART/GOTO',
	CART_ITEM_ADDED: 'CART/ITEM_ADDED',
	CART_ITEM_FAILED: 'CART/ITEM_FAILED',
	CART_ITEM_REMOVED: 'CART/ITEM_REMOVED',
	CART_RESET: 'CART/RESET',
	CART_SAVE: 'CART/SAVE',
	CART_TOGGLE: 'CART/TOGGLE',
	CLOSE_ALERT: 'CLOSE_ALERT',
	CLOSE_CENTER_INFORMATION: 'CLOSE_CENTER_INFORMATION',
	CLOSE_CONFIRM: 'CLOSE_CONFIRM',
	CLOSE_MODAL: 'CLOSE_MODAL',
	CLOSE_REFERENCE_MEDIA: 'CLOSE_REFERENCE_MEDIA',
	CLOSE_TOP_INFORMATION: 'CLOSE_TOP_INFORMATION',
	CODE_FORM_RESET: 'CODE_FORM/RESET',
	CODE_FORM_SEND_SUBMITTED_CODE: 'CODE_FORM/SEND_SUBMITTED_CODE',
	COOKIES_DISABLED_CLOSE_CONFIRM: 'COOKIES/DISABLED_CLOSE_CONFIRM',
	COOKIES_DISABLED_CONFIRM_RETRY: 'COOKIES/DISABLED_CONFIRM_RETRY',
	COUNTDOWN_TIMER_START: 'COUNTDOWN_TIMER/START',
	COUNTDOWN_TIMER_START_ERROR: 'COUNTDOWN_TIMER/COUNTDOWN_TIMER_START_ERROR',
	COUNTDOWN_TIMER_START_SUCCESS: 'COUNTDOWN_TIMER/COUNTDOWN_TIMER_START_SUCCESS',
	CREATION_TOOL_MCQ_ANSWER_ADD: 'CREATION_TOOL/MCQ/ANSWER_ADD',
	CREATION_TOOL_MCQ_ANSWER_AUTOSAVE: 'CREATION_TOOL/MCQ/ANSWER_AUTOSAVE',
	CREATION_TOOL_MCQ_ANSWER_CHANGE: 'CREATION_TOOL/MCQ/ANSWER_CHANGE',
	CREATION_TOOL_MCQ_ANSWER_CHECKBOX_CHANGE: 'CREATION_TOOL/MCQ/ANSWER_CHECKBOX_CHANGE',
	CREATION_TOOL_MCQ_ANSWER_DELETE: 'CREATION_TOOL/MCQ/ANSWER_DELETE',
	CREATION_TOOL_MCQ_ANSWER_DRAG: 'CREATION_TOOL/MCQ/ANSWER_DRAG',
	CREATION_TOOL_MCQ_ANSWER_DROP: 'CREATION_TOOL/MCQ/ANSWER_DROP',
	CREATION_TOOL_MCQ_INITIALIZE_ERROR: 'CREATION_TOOL/MCQ/INITIALIZE_ERROR',
	CREATION_TOOL_MCQ_INITIALIZE_SUCCESS: 'CREATION_TOOL/MCQ/INITIALIZE_SUCCESS',
	CREATION_TOOL_MCQ_QUESTION_AUTOSAVE: 'CREATION_TOOL/MCQ/QUESTION_AUTOSAVE',
	CREATION_TOOL_MCQ_QUESTION_CHANGE: 'CREATION_TOOL/MCQ/QUESTION_CHANGE',
	CREATION_TOOL_MCQ_QUESTION_GET_ERROR: 'CREATION_TOOL/MCQ/QUESTION_GET_ERROR',
	CREATION_TOOL_MCQ_QUESTION_GET_SUCCESS: 'CREATION_TOOL/MCQ/QUESTION_GET_SUCCESS',
	CREATION_TOOL_MCQ_QUESTION_UPDATE_ERROR: 'CREATION_TOOL/MCQ/QUESTION_UPDATE_ERROR',
	CREATION_TOOL_MCQ_QUESTION_UPDATE_SUCCESS: 'CREATION_TOOL/MCQ/QUESTION_UPDATE_SUCCESS',
	CREATION_TOOL_MCQ_VALIDATION_ERROR: 'CREATION_TOOL/MCQ/VALIDATION_ERROR',
	CREATION_TOOL_OEQ_INITIALIZE_ERROR: 'CREATION_TOOL/OEQ/INITIALIZE_ERROR',
	CREATION_TOOL_OEQ_INITIALIZE_SUCCESS: 'CREATION_TOOL/OEQ/INITIALIZE_SUCCESS',
	CREATION_TOOL_OEQ_QUESTION_AUTOSAVE: 'CREATION_TOOL/OEQ/QUESTION_AUTOSAVE',
	CREATION_TOOL_OEQ_QUESTION_CHANGE: 'CREATION_TOOL/OEQ/QUESTION_CHANGE',
	CREATION_TOOL_OEQ_QUESTION_GET_ERROR: 'CREATION_TOOL/OEQ/QUESTION_GET_ERROR',
	CREATION_TOOL_OEQ_QUESTION_GET_SUCCESS: 'CREATION_TOOL/OEQ/QUESTION_GET_SUCCESS',
	CREATION_TOOL_OEQ_QUESTION_UPDATE_ERROR: 'CREATION_TOOL/OEQ/QUESTION_UPDATE_ERROR',
	CREATION_TOOL_OEQ_QUESTION_UPDATE_SUCCESS: 'CREATION_TOOL/OEQ/QUESTION_UPDATE_SUCCESS',
	DESMOS_CANCEL_DESMOS: 'DESMOS/CANCEL_DESMOS',
	DESMOS_CANCEL_GRAPH_PREVIEW: 'DESMOS/CANCEL_GRAPH_PREVIEW',
	DESMOS_CATEGORY_DESMOS_SELECTED: 'DESMOS/CATEGORY_DESMOS_SELECTED',
	DESMOS_EDIT_DESMOS: 'DESMOS/EDIT_DESMOS',
	DESMOS_FINALIZE_CREATION_TOOL: 'DESMOS/FINALIZE_CREATION_TOOL',
	DESMOS_FINALIZE_CREATION_TOOL_STANDALONE: 'DESMOS/FINALIZE_CREATION_TOOL_STANDALONE',
	DESMOS_GET_RESULTS_ERROR: 'DESMOS/GET_RESULTS_ERROR',
	DESMOS_GET_RESULTS_SUCCESS: 'DESMOS/GET_RESULTS_SUCCESS',
	DESMOS_GRAPH_PREVIEW_SELECTED: 'DESMOS/GRAPH_PREVIEW_SELECTED',
	DESMOS_GRAPH_SELECTED: 'DESMOS/GRAPH_SELECTED',
	DESMOS_INITIALIZE_CREATION_TOOL: 'DESMOS/INITIALIZE_CREATION_TOOL',
	DESMOS_INITIALIZE_CREATION_TOOL_STANDALONE: 'DESMOS/INITIALIZE_CREATION_TOOL_STANDALONE',
	DESMOS_INITIALIZE_ERROR: 'DESMOS/INITIALIZE_ERROR',
	DESMOS_INITIALIZE_SUCCESS: 'DESMOS/INITIALIZE_SUCCESS',
	DESMOS_SAVE_DESMOS_ERROR: 'DESMOS/SAVE_DESMOS_ERROR',
	DESMOS_SAVE_DESMOS_SUCCESS: 'DESMOS/SAVE_DESMOS_SUCCESS',
	DESMOS_VALIDATION_ERROR: 'DESMOS/VALIDATION_ERROR',
	DESMOS_VALIDATION_SUCCESS: 'DESMOS/VALIDATION_SUCCESS',
	DEVICE_NOT_SUPPORTED_GO_TO_WEBSITE: 'DEVICE_NOT_SUPPORTED/GO_TO_WEBSITE',
	DEVICE_NOT_SUPPORTED_INITIALIZE: 'DEVICE_NOT_SUPPORTED/INITIALIZE',
	DISMISS_REDIRECTION: 'DISMISS_REDIRECTION',
	DM_STORAGE_EXPERIMENT_DOUBLE_STORAGE: 'DM_STORAGE_EXPERIMENT/DOUBLE_STORAGE',
	DM_STORAGE_EXPERIMENT_GO_TO_MY_LIBRARY: 'DM_STORAGE_EXPERIMENT/GO_TO_MY_LIBRARY',
	DM_STORAGE_EXPERIMENT_INITIALIZE: 'DM_STORAGE_EXPERIMENT/INITIALIZE',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_ANIMATION_COMPLETED: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_ANIMATION_COMPLETED',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_CLOSE',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_CLOSE_SUCCESS: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_CLOSE_SUCCESS',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_INITIALIZE: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT/INITIALIZE',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_METRICS_SUCCESS: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_METRICS_SUCCESS',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_SEND',
	DM_STORAGE_EXPERIMENT_REFER_CONTACT_SEND_SUCCESS: 'DM_STORAGE_EXPERIMENT/REFER_CONTACT_SEND_SUCCESS',
	DRAW_IT_ADD_REFERENCE_MEDIA_CLICK: 'DRAW_IT/ADD_REFERENCE_MEDIA_CLICK',
	DRAW_IT_ADD_TIMER: 'DRAW_IT/ADD_TIMER',
	DRAW_IT_AUDIO_PLAYER_DELETE_CANCELLED: 'DRAW_IT/AUDIO_PLAYER_DELETE_CANCELLED',
	DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRM: 'DRAW_IT/AUDIO_PLAYER_DELETE_CONFIRM',
	DRAW_IT_AUDIO_PLAYER_DELETE_CONFIRMED: 'DRAW_IT/AUDIO_PLAYER_DELETE_CONFIRMED',
	DRAW_IT_AUDIO_RECORDER_DELETE_CANCELLED: 'DRAW_IT/AUDIO_RECORDER_DELETE_CANCELLED',
	DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRM: 'DRAW_IT/AUDIO_RECORDER_DELETE_CONFIRM',
	DRAW_IT_AUDIO_RECORDER_DELETE_CONFIRMED: 'DRAW_IT/AUDIO_RECORDER_DELETE_CONFIRMED',
	DRAW_IT_CANCEL_BACKGROUND_IMAGE_PICKER: 'DRAW_IT/CANCEL_BACKGROUND_IMAGE_PICKER',
	DRAW_IT_CANCEL_DRAW_IT: 'DRAW_IT/CANCEL_DRAW_IT',
	DRAW_IT_CANCEL_DRAW_IT_CONFIRM: 'DRAW_IT/CANCEL_DRAW_IT_CONFIRM',
	DRAW_IT_CANCEL_DRAW_IT_CONFIRMED: 'DRAW_IT/CANCEL_DRAW_IT_CONFIRMED',
	DRAW_IT_CANCEL_DRAW_IT_REJECTED: 'DRAW_IT/CANCEL_DRAW_IT_REJECTED',
	DRAW_IT_CANCEL_REFERENCE_MEDIA_PICKER: 'DRAW_IT/CANCEL_REFERENCE_MEDIA_PICKER',
	DRAW_IT_CANCEL_TIMER: 'DRAW_IT/CANCEL_TIMER',
	DRAW_IT_CHANGE_IMAGE_OFFSET: 'DRAW_IT/CHANGE_IMAGE_OFFSET',
	DRAW_IT_CHANGE_INSTRUCTIONS: 'DRAW_IT/CHANGE_INSTRUCTIONS',
	DRAW_IT_DELETE_BACKGROUND_IMAGE: 'DRAW_IT/DELETE_BACKGROUND_IMAGE',
	DRAW_IT_DELETE_BACKGROUND_IMAGE_SUCCESS: 'DRAW_IT/DELETE_BACKGROUND_IMAGE_SUCCESS',
	DRAW_IT_DELETE_REFERENCE_MEDIA: 'DRAW_IT/DELETE_REFERENCE_MEDIA',
	DRAW_IT_DELETE_REFERENCE_MEDIA_SUCCESS: 'DRAW_IT/DELETE_REFERENCE_MEDIA_SUCCESS',
	DRAW_IT_DELETE_TIMER: 'DRAW_IT/DELETE_TIMER',
	DRAW_IT_EDIT_TIMER: 'DRAW_IT/EDIT_TIMER',
	DRAW_IT_FINALIZE_CREATION_TOOL: 'DRAW_IT/FINALIZE_CREATION_TOOL',
	DRAW_IT_FLIP_BACKGROUND_IMAGE_HORIZONTALLY: 'DRAW_IT/FLIP_BACKGROUND_IMAGE_HORIZONTALLY',
	DRAW_IT_FLIP_BACKGROUND_IMAGE_VERTICALLY: 'DRAW_IT/FLIP_BACKGROUND_IMAGE_VERTICALLY',
	DRAW_IT_INITIALIZE_CREATION_TOOL: 'DRAW_IT/INITIALIZE_CREATION_TOOL',
	DRAW_IT_INITIALIZE_ERROR: 'DRAW_IT/INITIALIZE_ERROR',
	DRAW_IT_INITIALIZE_STANDALONE: 'DRAW_IT/INITIALIZE_STANDALONE',
	DRAW_IT_INITIALIZE_SUCCESS: 'DRAW_IT/INITIALIZE_SUCCESS',
	DRAW_IT_REFERENCE_MEDIA_MENU_CLICK: 'DRAW_IT/REFERENCE_MEDIA_MENU/CLICK',
	DRAW_IT_RESET_BACKGROUND_IMAGE_PROPERTIES: 'DRAW_IT/RESET_BACKGROUND_IMAGE_PROPERTIES',
	DRAW_IT_ROTATE_BACKGROUND_IMAGE: 'DRAW_IT/DRAW_IT_ROTATE_BACKGROUND_IMAGE',
	DRAW_IT_SAVE_DRAW_IT: 'DRAW_IT/SAVE_DRAW_IT',
	DRAW_IT_SAVE_DRAW_IT_ERROR: 'DRAW_IT/SAVE_DRAW_IT_ERROR',
	DRAW_IT_SAVE_DRAW_IT_SUCCESS: 'DRAW_IT/SAVE_DRAW_IT_SUCCESS',
	DRAW_IT_SAVE_INSTRUCTIONS: 'DRAW_IT/SAVE_INSTRUCTIONS',
	DRAW_IT_SAVE_INSTRUCTIONS_ERROR: 'DRAW_IT/SAVE_INSTRUCTIONS_ERROR',
	DRAW_IT_SAVE_INSTRUCTIONS_SUCCESS: 'DRAW_IT/SAVE_INSTRUCTIONS_SUCCESS',
	DRAW_IT_SAVE_TIMER: 'DRAW_IT/SAVE_TIMER',
	DRAW_IT_SCALE_BACKGROUND_IMAGE: 'DRAW_IT/SCALE_BACKGROUND_IMAGE',
	DRAW_IT_SELECT_BACKGROUND_IMAGE: 'DRAW_IT/SELECT_BACKGROUND_IMAGE',
	DRAW_IT_TIMER_SAVE_ERROR: 'DRAW_IT/TIMER_SAVE_ERROR',
	DRAW_IT_TIMER_SAVE_SUCCESS: 'DRAW_IT/TIMER_SAVE_SUCCESS',
	DRAW_IT_TOGGLE_HEADER: 'DRAW_IT/TOGGLE_HEADER',
	DRAW_IT_UPDATE_CREATION_TOOL: 'DRAW_IT/UPDATE_CREATION_TOOL',
	DRAW_IT_UPDATE_CREATION_TOOL_SEARCH: 'DRAW_IT/UPDATE_CREATION_TOOL_SEARCH',
	DRAW_IT_UPLOAD_BACKGROUND_IMAGE: 'DRAW_IT/UPLOAD_BACKGROUND_IMAGE',
	DRAW_IT_UPLOAD_BACKGROUND_IMAGE_ERROR: 'DRAW_IT/UPLOAD_BACKGROUND_IMAGE_ERROR',
	DRAW_IT_UPLOAD_BACKGROUND_IMAGE_SUCCESS: 'DRAW_IT/UPLOAD_BACKGROUND_IMAGE_SUCCESS',
	DRAW_IT_UPLOAD_REFERENCE_MEDIA: 'DRAW_IT/UPLOAD_REFERENCE_MEDIA',
	DRAW_IT_UPLOAD_REFERENCE_MEDIA_ERROR: 'DRAW_IT/UPLOAD_REFERENCE_MEDIA_ERROR',
	DRAW_IT_UPLOAD_REQUIRE_CONFIRMATION: 'DRAW_IT/UPLOAD_REQUIRE_CONFIRMATION',
	DRAW_IT_UPLOADER_UPLOAD_ERROR: 'DRAW_IT/UPLOADER/UPLOAD_ERROR',
	DRAW_IT_UPLOADER_UPLOAD_SUCCESS: 'DRAW_IT/UPLOADER/UPLOAD_SUCCESS',
	DRAW_IT_UPLOADER_VALIDATE_CONTENT_ERROR: 'DRAW_IT/UPLOADER/VALIDATE_CONTENT_ERROR',
	DRAW_IT_UPLOADER_VALIDATE_ERROR: 'DRAW_IT/UPLOADER/VALIDATE_ERROR',
	DRAW_IT_UPLOADER_VALIDATE_SUCCESS: 'DRAW_IT/UPLOADER/VALIDATE_SUCCESS',
	DRAW_IT_VALIDATE_BACKGROUND_IMAGE_ERROR: 'DRAW_IT/VALIDATE_BACKGROUND_IMAGE_ERROR',
	DRAW_IT_VALIDATE_BACKGROUND_IMAGE_SUCCESS: 'DRAW_IT/VALIDATE_BACKGROUND_IMAGE_SUCCESS',
	DRAW_IT_VALIDATE_REFERENCE_MEDIA_SUCCESS: 'DRAW_IT/VALIDATE_REFERENCE_MEDIA_SUCCESS',
	DRAW_IT_VALIDATION_SUCCESS: 'DRAW_IT/VALIDATION_SUCCESS',
	FEATURE_FLAGS_GET_SUCCESS: 'FEATURE_FLAGS/GET_SUCCESS',
	FETCH_SHARE_DATA: 'FETCH_SHARE_DATA',
	FILL_IN_THE_BLANKS_SESSION_CONFIG_FAILED: 'FILL_IN_THE_BLANKS/SESSION/CONFIG_FAILED',
	FILL_IN_THE_BLANKS_SESSION_CONFIG_FETCHED: 'FILL_IN_THE_BLANKS/SESSION/CONFIG_FETCHED',
	FILL_IN_THE_BLANKS_SESSION_INITIALIZE_ROUTE: 'FILL_IN_THE_BLANKS/SESSION/INITIALIZE_ROUTE',
	FILL_IN_THE_BLANKS_SESSION_STUDENT_DATA_FETCHED: 'FILL_IN_THE_BLANKS/SESSION/STUDENT_DATA_FETCHED',
	FLIPGRID_CREATION_TOOL_CANCEL: 'FLIPGRID/CREATION_TOOL/CANCEL',
	FLIPGRID_CREATION_TOOL_FINALIZE: 'FLIPGRID/CREATION_TOOL/FINALIZE',
	FLIPGRID_CREATION_TOOL_INITIALIZE: 'FLIPGRID/CREATION_TOOL/INITIALIZE',
	FLIPGRID_CREATION_TOOL_INITIALIZE_SUCCESS: 'FLIPGRID/CREATION_TOOL/INITIALIZE_SUCCESS',
	FLIPGRID_CREATION_TOOL_INITIALIZE_ERROR: 'FLIPGRID/CREATION_TOOL/INITIALIZE_ERROR',
	FLIPGRID_CREATION_TOOL_SAVE: 'FLIPGRID/CREATION_TOOL/SAVE',
	FLIPGRID_CREATION_TOOL_SAVE_ERROR: 'FLIPGRID/CREATION_TOOL/SAVE_ERROR',
	FLIPGRID_CREATION_TOOL_SAVE_SUCCESS: 'FLIPGRID/CREATION_TOOL/SAVE_SUCCESS',
	FLIPGRID_CREATION_TOOL_UPDATE_INPUT: 'FLIPGRID/CREATION_TOOL/UPDATE_INPUT',
	FLIPGRID_HELP_SELECTED: 'FLIPGRID/HELP_SELECTED',
	FLIPGRID_INITIALIZE_STANDALONE: 'FLIPGRID/INITIALIZE_STANDALONE',
	FLOCABULARY_APPLY_SEARCH_SELECTED: 'FLOCABULARY/APPLY_SEARCH_SELECTED',
	FLOCABULARY_CANCEL_PREVIEW_FLOCABULARY: 'FLOCABULARY/CANCEL_PREVIEW_FLOCABULARY',
	FLOCABULARY_CATEGORIES_FETCHED: 'FLOCABULARY/CATEGORIES_FETCHED',
	FLOCABULARY_CATEGORIES_FETCHED_ERROR: 'FLOCABULARY/CATEGORIES_FETCHED_ERROR',
	FLOCABULARY_CATEGORY_FLOCABULARY_SELECTED: 'FLOCABULARY/CATEGORY_FLOCABULARY_SELECTED',
	FLOCABULARY_CLOSE_SELECTED: 'FLOCABULARY/CLOSE_SELECTED',
	FLOCABULARY_EDIT_FLOCABULARY: 'FLOCABULARY/EDIT_FLOCABULARY',
	FLOCABULARY_FINALIZE_CREATION_TOOL: 'FLOCABULARY/FINALIZE_CREATION_TOOL',
	FLOCABULARY_FINALIZE_CREATION_TOOL_STANDALONE: 'FLOCABULARY/FINALIZE_CREATION_TOOL_STANDALONE',
	FLOCABULARY_GET_RESULTS_ERROR: 'FLOCABULARY/GET_RESULTS_ERROR',
	FLOCABULARY_GET_RESULTS_SUCCESS: 'FLOCABULARY/GET_RESULTS_SUCCESS',
	FLOCABULARY_GET_VIDEO_SUCCESS: 'FLOCABULARY/GET_VIDEO_SUCCESS',
	FLOCABULARY_INITIALIZE_CREATION_TOOL: 'FLOCABULARY/INITIALIZE_CREATION_TOOL',
	FLOCABULARY_INITIALIZE_CREATION_TOOL_STANDALONE: 'FLOCABULARY/INITIALIZE_CREATION_TOOL_STANDALONE',
	FLOCABULARY_INITIALIZE_ERROR: 'FLOCABULARY/INITIALIZE_ERROR',
	FLOCABULARY_INITIALIZE_SESSION: 'FLOCABULARY/INITIALIZE_SESSION',
	FLOCABULARY_INITIALIZE_SUCCESS: 'FLOCABULARY/INITIALIZE_SUCCESS',
	FLOCABULARY_LIMIT_REACHED_OVERLAY_DISMISS_SELECTED: 'FLOCABULARY/LIMIT_REACHED_OVERLAY_DISMISS_SELECTED',
	FLOCABULARY_LIMIT_REACHED_OVERLAY_NUDGE_SELECTED: 'FLOCABULARY/LIMIT_REACHED_OVERLAY_NUDGE_SELECTED',
	FLOCABULARY_SAVE_ERROR: 'FLOCABULARY/SAVE_ERROR',
	FLOCABULARY_SAVE_SUCCESS: 'FLOCABULARY/SAVE_SUCCESS',
	FLOCABULARY_SCREENSHOT_INITIALIZE_ROUTE: 'FLOCABULARY/SCREENSHOT_INITIALIZE_ROUTE',
	FLOCABULARY_VIDEO_FETCHED: 'FLOCABULARY/VIDEO_FETCHED',
	FLOCABULARY_VIDEO_FETCHED_ERROR: 'FLOCABULARY/VIDEO_FETCHED_ERROR',
	FLOCABULARY_VIDEOS_NEXT_PAGE_REQUESTED: 'FLOCABULARY/VIDEOS_NEXT_PAGE_REQUESTED',
	FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED: 'FLOCABULARY/VIDEO_PREVIEW_DATA_FETCHED',
	FLOCABULARY_VIDEO_PREVIEW_DATA_FETCHED_ERROR: 'FLOCABULARY/VIDEO_PREVIEW_DATA_FETCHED_ERROR',
	FLOCABULARY_VIDEO_PREVIEW_SELECTED: 'FLOCABULARY/VIDEO_PREVIEW_SELECTED',
	FLOCABULARY_VIDEO_SELECTED: 'FLOCABULARY/VIDEO_SELECTED',
	FLOCABULARY_WARNING_OVERLAY_FINISHED: 'FLOCABULARY/WARNING_OVERLAY_FINISHED',
	FOLDERS_GET_COLORS: 'FOLDERS/GET_COLORS',
	FOLDERS_GET_COLORS_SUCCESS: 'FOLDERS/GET_COLORS_SUCCESS',
	FOLDERS_RESET_COLORS: 'FOLDERS/RESET_COLORS',
	GAME_ACTIVITY_CREATED_SUCCESS: 'GAME/ACTIVITY_CREATED_SUCCESS',
	GAME_ACTIVITY_FAILED: 'GAME/ACTIVITY_FAILED',
	GAME_ACTIVITY_SAVED: 'GAME/ACTIVITY_SAVED',
	GAME_ADD_QUESTION: 'GAME/ADD_QUESTION',
	GAME_CANCEL: 'GAME/CANCEL',
	GAME_CANCEL_CANCELLED: 'GAME/CANCEL_CANCELLED',
	GAME_CANCEL_CONFIRMED: 'GAME/CANCEL_CONFIRMED',
	GAME_COLLAPSE_ACTIVITY: 'GAME/COLLAPSE_ACTIVITY',
	GAME_COLLAPSE_ALL: 'GAME/COLLAPSE_ALL',
	GAME_DELETE_ACTIVITY: 'GAME/DELETE_ACTIVITY',
	GAME_DELETE_ACTIVITY_CANCEL: 'GAME/DELETE_ACTIVITY_CANCEL',
	GAME_DELETE_ACTIVITY_CONFIRMED: 'GAME/DELETE_ACTIVITY_CONFIRMED',
	GAME_DELETE_ACTIVITY_SUCCESS: 'GAME/DELETE_ACTIVITY_SUCCESS',
	GAME_DRAG_QUESTION: 'GAME/DRAG_QUESTION',
	GAME_DROP_QUESTION: 'GAME/DROP_QUESTION',
	GAME_EXPAND_ALL: 'GAME/EXPAND_ALL',
	GAME_FINALIZE_CREATION_TOOL: 'GAME/FINALIZE_CREATION_TOOL',
	GAME_INITIALIZE_CREATION_TOOL: 'GAME/INITIALIZE_CREATION_TOOL',
	GAME_INITIALIZE_DATA_SUCCESS: 'GAME/INITIALIZE_DATA_SUCCESS',
	GAME_INITIALIZE_SLIDE_DATA_SUCCESS: 'GAME/INITIALIZE_SLIDE_DATA_SUCCESS',
	GAME_INITIALIZE_STANDALONE: 'GAME/INITIALIZE_STANDALONE',
	GAME_QUESTION_ADD_ANSWER: 'GAME/QUESTION/ADD_ANSWER',
	GAME_QUESTION_ANSWER_CHANGE: 'GAME/QUESTION/ANSWER_CHANGE',
	GAME_QUESTION_ANSWER_CORRECT_TOGGLE: 'GAME/QUESTION/ANSWER_CORRECT_TOGGLE',
	GAME_QUESTION_ANSWER_DELETE: 'GAME/QUESTION/ANSWER_DELETE',
	GAME_QUESTION_ANSWER_DRAG: 'GAME/QUESTION/ANSWER_DRAG',
	GAME_QUESTION_ANSWER_DROP: 'GAME/QUESTION/ANSWER_DROP',
	GAME_QUESTION_ANSWER_FOCUS: 'GAME/QUESTION/ANSWER_FOCUS',
	GAME_QUESTION_ANSWER_SAVE: 'GAME/QUESTION/ANSWER_SAVE',
	GAME_QUESTION_DUPLICATE: 'GAME/QUESTION/DUPLICATE',
	GAME_QUESTION_DUPLICATE_SUCCESS: 'GAME/QUESTION/DUPLICATE/SUCCESS',
	GAME_QUESTION_CHANGE: 'GAME/QUESTION/CHANGE',
	GAME_QUESTION_SELECT_ANSWER_TYPE: 'GAME/QUESTION/SELECT_ANSWER_TYPE',
	GAME_QUESTION_SELECT_ANSWER_TYPE_CANCELLED: 'GAME/QUESTION/SELECT_ANSWER_TYPE_CANCELLED',
	GAME_QUESTION_TIMER_CANCEL: 'GAME/QUESTION/TIMER_CANCEL',
	GAME_QUESTION_TIMER_EDIT: 'GAME/QUESTION/TIMER_EDIT',
	GAME_QUESTION_TIMER_SAVE: 'GAME/QUESTION/TIMER_SAVE',
	GAME_SAVE: 'GAME/SAVE',
	GAME_SAVE_FAILED: 'GAME/SAVE_FAILED',
	GAME_SAVE_SUCCESS: 'GAME/SAVE_SUCCESS',
	GAME_SORT_FAILED: 'GAME/DROP_QUESTION_FAILED',
	GAME_SORT_SUCCESS: 'GAME/DROP_QUESTION_SUCCESS',
	GAME_UPDATE_CREATION_TOOL: 'GAME/UPDATE_CREATION_TOOL',
	GAME_UPDATE_CREATION_TOOL_SEARCH: 'GAME/UPDATE_CREATION_TOOL_SEARCH',
	GAME_UPLOAD_ANSWER_MEDIA_ADD: 'GAME/UPLOAD_ANSWER_MEDIA_ADD',
	GAME_UPLOAD_ANSWER_MEDIA_CANCELLED: 'GAME/UPLOAD_ANSWER_MEDIA_CANCELLED',
	GAME_UPLOAD_ANSWER_MEDIA_DELETE: 'GAME/UPLOAD_ANSWER_MEDIA_DELETE',
	GAME_UPLOAD_ANSWER_MEDIA_ERROR: 'GAME/UPLOAD_ANSWER_MEDIA_ERROR',
	GAME_UPLOAD_ANSWER_MEDIA_FAILED: 'GAME/UPLOAD_ANSWER_MEDIA_FAILED',
	GAME_UPLOAD_ANSWER_MEDIA_PREVIEW: 'GAME/UPLOAD_ANSWER_MEDIA_PREVIEW',
	GAME_UPLOAD_ANSWER_MEDIA_SELECTED: 'GAME/UPLOAD_ANSWER_MEDIA_SELECTED',
	GAME_UPLOAD_ANSWER_MEDIA_SUCCESS: 'GAME/UPLOAD_ANSWER_MEDIA_SUCCESS',
	GAME_UPLOAD_QUESTION_MEDIA_ADD: 'GAME/UPLOAD_QUESTION_MEDIA_ADD',
	GAME_UPLOAD_QUESTION_MEDIA_CANCELLED: 'GAME/UPLOAD_QUESTION_MEDIA_CANCELLED',
	GAME_UPLOAD_QUESTION_MEDIA_DELETE: 'GAME/UPLOAD_QUESTION_MEDIA_DELETE',
	GAME_UPLOAD_QUESTION_MEDIA_DELETE_FAILED: 'GAME/UPLOAD_QUESTION_MEDIA_DELETE_FAILED',
	GAME_UPLOAD_QUESTION_MEDIA_DELETE_SUCCESS: 'GAME/UPLOAD_QUESTION_MEDIA_DELETE_SUCCESS',
	GAME_UPLOAD_QUESTION_MEDIA_ERROR: 'GAME/UPLOAD_QUESTION_MEDIA_ERROR',
	GAME_UPLOAD_QUESTION_MEDIA_FAILED: 'GAME/UPLOAD_QUESTION_MEDIA_FAILED',
	GAME_UPLOAD_QUESTION_MEDIA_SELECTED: 'GAME/UPLOAD_QUESTION_MEDIA_SELECTED',
	GAME_UPLOAD_QUESTION_MEDIA_SUCCESS: 'GAME/UPLOAD_QUESTION_MEDIA_SUCCESS',
	GOALS_COLLABORATE_CARD_CREATE_LESSON: 'GOALS/COLLABORATE_CARD/CREATE_LESSON',
	GOALS_COLLABORATE_CARD_CREATE_LESSON_WITH_DEMO: 'GOALS/COLLABORATE_CARD/CREATE_LESSON_WITH_DEMO',
	GOALS_COLLABORATE_CARD_LAUNCH_LIVE_LESSON: 'GOALS/COLLABORATE_CARD/LAUNCH_LIVE_LESSON',
	GOALS_COLLABORATE_CARD_TOOLTIP_SELECTED: 'GOALS/COLLABORATE_CARD/TOOLTIP_SELECTED',
	GOALS_FAILED: 'GOALS/FAILED',
	GOALS_FETCHED: 'GOALS/FETCHED',
	GOALS_OEQ_CARD_CREATE_LESSON: 'GOALS/OEQ_CARD/CREATE_LESSON',
	GOALS_OEQ_CARD_CREATE_LESSON_FAILED: 'GOALS/OEQ_CARD/CREATE_LESSON/FAILED',
	GOALS_OEQ_CARD_CREATE_LESSON_SUCCESS: 'GOALS/OEQ_CARD/CREATE_LESSON/SUCCESS',
	GOALS_OEQ_CARD_ENABLE_LESSON_FAILED: 'GOALS/OEQ_CARD/ENABLE_LESSON/FAILED',
	GOALS_OEQ_CARD_ENABLE_LESSON_SUCCESS: 'GOALS/OEQ_CARD/ENABLE_LESSON/SUCCESS',
	GOALS_OEQ_CARD_LAUNCH_LIVE_LESSON: 'GOALS/OEQ_CARD/LAUNCH_LIVE_LESSON',
	GOALS_TIME_TO_CLIMB_CARD_CREATE_LESSON: 'GOALS/TIME_TO_CLIMB_CARD/CREATE_LESSON',
	GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_FAILED: 'GOALS/TIME_TO_CLIMB_CARD/ENABLE_LESSON/FAILED',
	GOALS_TIME_TO_CLIMB_CARD_ENABLE_LESSON_SUCCESS: 'GOALS/TIME_TO_CLIMB_CARD/ENABLE_LESSON/SUCCESS',
	GOALS_TIME_TO_CLIMB_CARD_LAUNCH_LIVE_LESSON: 'GOALS/TIME_TO_CLIMB_CARD/LAUNCH_LIVE_LESSON',
	GOOGLE_SLIDES_ACTIVITY_CANCEL: 'GOOGLE_SLIDES/ACTIVITY_CANCEL',
	GOOGLE_SLIDES_ACTIVITY_CREATE: 'GOOGLE_SLIDES/ACTIVITY_CREATE',
	GOOGLE_SLIDES_ACTIVITY_EDIT: 'GOOGLE_SLIDES/ACTIVITY_EDIT',
	GOOGLE_SLIDES_ACTIVITY_EDIT_EXTERNAL_ID_OBTAINED: 'GOOGLE_SLIDES/ACTIVITY_EDIT_EXTERNAL_ID_OBTAINED',
	GOOGLE_SLIDES_ACTIVITY_LOADED: 'GOOGLE_SLIDES/ACTIVITY_LOADED',
	GOOGLE_SLIDES_ACTIVITY_SAVE: 'GOOGLE_SLIDES/ACTIVITY_SAVE',
	GOOGLE_SLIDES_ACTIVITY_SAVE_FAILED: 'GOOGLE_SLIDES/ACTIVITY_SAVE_FAILED',
	GOOGLE_SLIDES_ACTIVITY_SAVED: 'GOOGLE_SLIDES/ACTIVITY_SAVED',
	GOOGLE_SLIDES_ACTIVITY_SAVED_FINISHED: 'GOOGLE_SLIDES/ACTIVITY_SAVED_FINISHED',
	GOOGLE_SLIDES_AUTHORIZE_USER_CANCEL: 'GOOGLE_SLIDES/AUTHORIZE_USER_CANCEL',
	GOOGLE_SLIDES_AUTHORIZE_USER_FAILED: 'GOOGLE_SLIDES/AUTHORIZE_USER_FAILED',
	GOOGLE_SLIDES_AUTHORIZE_USER_SUCCESS: 'GOOGLE_SLIDES/AUTHORIZE_USER_SUCCESS',
	GOOGLE_SLIDES_CHANGE_CURRENT_SLIDE: 'GOOGLE_SLIDES/CHANGE_CURRENT_SLIDE',
	GOOGLE_SLIDES_CHANGE_CURRENT_SLIDE_INDEX: 'GOOGLE_SLIDES/CHANGE_CURRENT_SLIDE_INDEX',
	GOOGLE_SLIDES_CHANGE_SLIDE_CONTENT: 'GOOGLE_SLIDES/CHANGE_SLIDE_CONTENT',
	GOOGLE_SLIDES_CLOSE_MODAL: 'GOOGLE_SLIDES/CLOSE_MODAL',
	GOOGLE_SLIDES_CONFIRM_VIEW_INITIALIZE: 'GOOGLE_SLIDES/CONFIRM_VIEW_INITIALIZE',
	GOOGLE_SLIDES_CONVERT_TO_DRAW_IT: 'GOOGLE_SLIDES/CONVERT_TO_DRAW_IT',
	GOOGLE_SLIDES_CONVERT_TO_DRAW_IT_FAILED: 'GOOGLE_SLIDES/CONVERT_TO_DRAW_IT_FAILED',
	GOOGLE_SLIDES_CONVERT_TO_DRAW_IT_GET_THUMBNAIL_SUCCESS: 'GOOGLE_SLIDES/CONVERT_TO_DRAW_IT_GET_THUMBNAIL_SUCCESS',
	GOOGLE_SLIDES_CREATE_AUTHORIZE_SUCCESS: 'GOOGLE_SLIDES/CREATE_AUTHORIZE_SUCCESS',
	GOOGLE_SLIDES_CURRENT_SLIDE_CHANGED: 'GOOGLE_SLIDES/CURRENT_SLIDE_CHANGED',
	GOOGLE_SLIDES_EDIT_LESSON: 'GOOGLE_SLIDES/EDIT_LESSON',
	GOOGLE_SLIDES_EDIT_LESSON_SUCCESS: 'GOOGLE_SLIDES/EDIT_LESSON_SUCCESS',
	GOOGLE_SLIDES_FORGOT_PASSWORD: 'GOOGLE_SLIDES/FORGOT_PASSWORD',
	GOOGLE_SLIDES_GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_FAILED: 'GOOGLE_SLIDES/GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_FAILED',
	GOOGLE_SLIDES_GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_SUCCESS: 'GOOGLE_SLIDES/GET_EXTERNAL_SLIDE_DATA_FOR_EDIT_SUCCESS',
	GOOGLE_SLIDES_GET_SLIDE_TYPE_SUCCESS: 'GOOGLE_SLIDES/GET_SLIDE_TYPE_SUCCESS',
	GOOGLE_SLIDES_GO_TO_MY_LIBRARY: 'GOOGLE_SLIDES/GO_TO_MY_LIBRARY',
	GOOGLE_SLIDES_INITIALIZE: 'GOOGLE_SLIDES/INITIALIZE',
	GOOGLE_SLIDES_INITIALIZE_ACTIVITY_CANCEL: 'GOOGLE_SLIDES/INITIALIZE_ACTIVITY_CANCEL',
	GOOGLE_SLIDES_INITIALIZE_ACTIVITY_SAVE: 'GOOGLE_SLIDES/INITIALIZE_ACTIVITY_SAVE',
	GOOGLE_SLIDES_INITIALIZE_SUCCESS: 'GOOGLE_SLIDES/INITIALIZE_SUCCESS',
	GOOGLE_SLIDES_INITIALIZE_UNKNOWN: 'GOOGLE_SLIDES/INITIALIZE_UNKNOWN',
	GOOGLE_SLIDES_INVALID_SLIDES: 'GOOGLE_SLIDES/INVALID_SLIDES',
	GOOGLE_SLIDES_LEARN_MORE: 'GOOGLE_SLIDES/LEARN_MORE',
	GOOGLE_SLIDES_LEARN_MORE_VIEW_INITIALIZE: 'GOOGLE_SLIDES/LEARN_MORE_VIEW_INITIALIZE',
	GOOGLE_SLIDES_LMS_OPEN_GOOGLE_CONFIRMED: 'GOOGLE_SLIDES/LMS_OPEN_GOOGLE_CONFIRMED',
	GOOGLE_SLIDES_LMS_REFRESH_CONFIRMED: 'GOOGLE_SLIDES/LMS_REFRESH_CONFIRMED',
	GOOGLE_SLIDES_OPEN_MODAL: 'GOOGLE_SLIDES/OPEN_MODAL',
	GOOGLE_SLIDES_PROCESS_SLIDES_FAILED: 'GOOGLE_SLIDES/PROCESS_SLIDES_FAILED',
	GOOGLE_SLIDES_SAVE_AND_GO_TO_NEARPOD: 'GOOGLE_SLIDES/SAVE_AND_GO_TO_NEARPOD',
	GOOGLE_SLIDES_SAVE_PRESENTATION_FAILED_CONFIRMED: 'GOOGLE_SLIDES/SAVE_PRESENTATION_FAILED_CONFIRMED',
	GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_FAILED: 'GOOGLE_SLIDES/SAVE_PRESENTATION_PROGRESSIVE_FAILED',
	GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START: 'GOOGLE_SLIDES/SAVE_PRESENTATION_PROGRESSIVE_START',
	GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_START_FAILED: 'GOOGLE_SLIDES/SAVE_PRESENTATION_PROGRESSIVE_START_FAILED',
	GOOGLE_SLIDES_SAVE_PRESENTATION_PROGRESSIVE_UPDATE: 'GOOGLE_SLIDES/SAVE_PRESENTATION_PROGRESSIVE_UPDATE',
	GOOGLE_SLIDES_SCREENSHOT_OBTAINED: 'GOOGLE_SLIDES/SCREENSHOT_OBTAINED',
	GOOGLE_SLIDES_SCREENSHOT_PROCCESSING: 'GOOGLE_SLIDES/SCREENSHOT_PROCCESSING',
	GOOGLE_SLIDES_SIDEBAR_LOADED: 'GOOGLE_SLIDES/SIDEBAR_LOADED',
	GOOGLE_SLIDES_SLIDE_EXTERNAL_ID_OBTAINED: 'GOOGLE_SLIDES/SLIDE_EXTERNAL_ID_OBTAINED',
	HELPBOX_SEND_HELP: 'HELPBOX/SEND_HELP',
	HELPBOX_SEND_HELP_ERROR: 'HELPBOX/SEND_HELP_ERROR',
	HELPBOX_SEND_HELP_SUCCESS: 'HELPBOX/SEND_HELP_SUCCESS',
	HIDE_INTERCOM: 'HIDE_INTERCOM',
	IMMERSIVE_READER_DRAW_IT_TRANSFORM: 'IMMERSIVE_READER/DRAW_IT_TRANSFORM',
	IMMERSIVE_READER_MATCHING_PAIRS_TRANSFORM: 'IMMERSIVE_READER/MATCHING_PAIRS_TRANSFORM',
	IMMERSIVE_READER_OEQ_TRANSFORM: 'IMMERSIVE_READER/OEQ_TRANSFORM',
	IMMERSIVE_READER_POLL_TRANSFORM: 'IMMERSIVE_READER/POLL_TRANSFORM',
	IMMERSIVE_READER_QUIZ_TRANSFORM: 'IMMERSIVE_READER/QUIZ_TRANSFORM',
	IMMERSIVE_READER_READ_ONLY_TRANSFORM: 'IMMERSIVE_READER/READ_ONLY_TRANSFORM',
	IMMERSIVE_READER_TRANSFORM_ERROR: 'IMMERSIVE_READER/TRANSFORM_ERROR',
	IMMERSIVE_READER_TRANSFORM_SUCCESS: 'IMMERSIVE_READER/TRANSFORM_SUCCESS',
	INTERACTIVE_VIDEO_ACTIVITY_CREATE: 'INTERACTIVE_VIDEO/ACTIVITY_CREATE',
	INTERACTIVE_VIDEO_ACTIVITY_CREATE_ERROR: 'INTERACTIVE_VIDEO/CREATE_ACTIVITY_ERROR',
	INTERACTIVE_VIDEO_ACTIVITY_CREATE_SUCCESS: 'INTERACTIVE_VIDEO/CREATE_ACTIVITY_SUCCESS',
	INTERACTIVE_VIDEO_ACTIVITY_PANEL_COLLAPSE_TOGGLE: 'INTERACTIVE_VIDEO/ACTIVITY_PANEL_COLLAPSE_TOGGLE',
	INTERACTIVE_VIDEO_CANCEL_NEW_ACTIVITY: 'INTERACTIVE_VIDEO/CANCEL_NEW_ACTIVITY',
	INTERACTIVE_VIDEO_ASSET_POSTER_FETCHED: 'INTERACTIVE_VIDEO/ASSET_POSTER_FETCHED',
	INTERACTIVE_VIDEO_ASSET_POSTER_FETCHED_FAILED: 'INTERACTIVE_VIDEO/ASSET_POSTER_FETCHED_FAILED',
	INTERACTIVE_VIDEO_ASSET_VIDEO_FETCHED: 'INTERACTIVE_VIDEO/ASSET_VIDEO_FETCHED',
	INTERACTIVE_VIDEO_ASSET_VIDEO_FETCHED_FAILED: 'INTERACTIVE_VIDEO/ASSET_VIDEO_FETCHED_FAILED',
	INTERACTIVE_VIDEO_ASSET_VIDEO_UNLINK_FAILED: 'INTERACTIVE_VIDEO/ASSET_VIDEO_UNLINK_FAILED',
	INTERACTIVE_VIDEO_ASSET_VIDEO_UNLINK_SUCCESS: 'INTERACTIVE_VIDEO/ASSET_VIDEO_UNLINK_SUCCESS',
	INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_CONFIRMED: 'INTERACTIVE_VIDEO/BREAKPOINT_ACTIVITY_CONFIRMED',
	INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_DISMISSED: 'INTERACTIVE_VIDEO/BREAKPOINT_ACTIVITY_DISMISSED',
	INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_REACHED: 'INTERACTIVE_VIDEO/BREAKPOINT_ACTIVITY_REACHED',
	INTERACTIVE_VIDEO_BREAKPOINT_ACTIVITY_SELECTED: 'INTERACTIVE_VIDEO/BREAKPOINT_ACTIVITY_SELECTED',
	INTERACTIVE_VIDEO_TOOLTIP_CHECK_PROGRESS_DISMISSED: 'INTERACTIVE_VIDEO/TOOLTIP_CHECK_PROGRESS_DISMISSED',
	INTERACTIVE_VIDEO_CAPTIONS_FETCH_FAILED: 'INTERACTIVE_VIDEO/CAPTIONS_FETCH_FAILED',
	INTERACTIVE_VIDEO_CAPTIONS_FETCH_SUCCESS: 'INTERACTIVE_VIDEO/CAPTIONS_FETCH_SUCCESS',
	INTERACTIVE_VIDEO_CAPTIONS_LANGUAGE_SELECTED: 'INTERACTIVE_VIDEO/CAPTIONS_LANGUAGE_SELECTED',
	INTERACTIVE_VIDEO_CLOSE_BLANK_RESPONSE_PROMPT_MCQ: 'INTERACTIVE_VIDEO/CLOSE_BLANK_RESPONSE_PROMPT_MCQ',
	INTERACTIVE_VIDEO_CLOSE_BLANK_RESPONSE_PROMPT_OEQ: 'INTERACTIVE_VIDEO/CLOSE_BLANK_RESPONSE_PROMPT_OEQ',
	INTERACTIVE_VIDEO_CLOSE_PREVENT_SKIPPING_PROMPT: 'INTERACTIVE_VIDEO/CLOSE_PREVENT_SKIPPING_PROMPT',
	INTERACTIVE_VIDEO_CLOSE_SUBMISSIONS_REQUIRED: 'INTERACTIVE_VIDEO/CLOSE_SUBMISSIONS_REQUIRED',
	INTERACTIVE_VIDEO_CONTINUE_POST_SESSION_REPORT: 'INTERACTIVE_VIDEO_CONTINUE/POST_SESSION_REPORT',
	INTERACTIVE_VIDEO_CREATE_FAILED: 'INTERACTIVE_VIDEO/CREATE_FAILED',
	INTERACTIVE_VIDEO_CREATE_PLAY_SELECTED: 'INTERACTIVE_VIDEO/CREATE_PLAY_SELECTED',
	INTERACTIVE_VIDEO_CREATE_SUCCESS: 'INTERACTIVE_VIDEO/CREATE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/CANCEL',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_CONFIRMED: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/CANCEL_CONFIRMED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_CANCEL_REJECTED: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/CANCEL_REJECTED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_CANCELED: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE_CANCELED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_CONFIRMED: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE_CONFIRMED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_FAILED: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE_FAILED',
	INTERACTIVE_VIDEO_CREATION_ACTIVITY_DELETE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/ACTIVITY/DELETE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_ADD_NEW_ACTIVITY: 'INTERACTIVE_VIDEO_CREATION/ADD_NEW_ACTIVITY',
	INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION: 'INTERACTIVE_VIDEO_CREATION/BREAKPOINT/SAVE_POSITION',
	INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION_ERROR: 'INTERACTIVE_VIDEO_CREATION/BREAKPOINT/SAVE_POSITION_ERROR',
	INTERACTIVE_VIDEO_CREATION_BREAKPOINT_SAVE_POSITION_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/BREAKPOINT/SAVE_POSITION_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_BREAKPOINT_UPDATE_POSITION: 'INTERACTIVE_VIDEO_CREATION/BREAKPOINT/UPDATE_POSITION',
	INTERACTIVE_VIDEO_CREATION_CANCEL: 'INTERACTIVE_VIDEO_CREATION/CANCEL',
	INTERACTIVE_VIDEO_CREATION_CANCEL_CONFIRMED: 'INTERACTIVE_VIDEO_CREATION/CANCEL_CONFIRMED',
	INTERACTIVE_VIDEO_CREATION_CANCEL_REJECTED: 'INTERACTIVE_VIDEO_CREATION/CANCEL_REJECTED',
	INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY: 'INTERACTIVE_VIDEO_CREATION/EDIT_ACTIVITY',
	INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY_ERROR: 'INTERACTIVE_VIDEO_CREATION/EDIT_ACTIVITY/ERROR',
	INTERACTIVE_VIDEO_CREATION_EDIT_ACTIVITY_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/EDIT_ACTIVITY/SUCCESS',
	INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_LETS_DO_IT: 'INTERACTIVE_VIDEO_CREATION/EDITOR_WELCOME_TOUR/LETS_DO_IT',
	INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_SKIP_TOUR: 'INTERACTIVE_VIDEO_CREATION/EDITOR_WELCOME_TOUR/SKIP_TOUR',
	INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_1_GOT_IT: 'INTERACTIVE_VIDEO_CREATION/EDITOR_WELCOME_TOUR/STEP_1_GOT_IT',
	INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_2_GOT_IT: 'INTERACTIVE_VIDEO_CREATION/EDITOR_WELCOME_TOUR/STEP_2_GOT_IT',
	INTERACTIVE_VIDEO_CREATION_EDITOR_WELCOME_TOUR_STEP_3_GOT_IT: 'INTERACTIVE_VIDEO_CREATION/EDITOR_WELCOME_TOUR/STEP_3_GOT_IT',
	INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE: 'INTERACTIVE_VIDEO_CREATION/EMBED_IN_SLIDE',
	INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_FAILED: 'INTERACTIVE_VIDEO_CREATION/EMBED_IN_SLIDE/SAVE_FAILED',
	INTERACTIVE_VIDEO_CREATION_EMBED_IN_SLIDE_SAVE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/EMBED_IN_SLIDE/SAVE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_MCQ_ANSWER_FOCUS: 'INTERACTIVE_VIDEO_CREATION/MCQ/ANSWER_FOCUS',
	INTERACTIVE_VIDEO_CREATION_MCQ_CANCEL: 'INTERACTIVE_VIDEO_CREATION/MCQ/CANCEL',
	INTERACTIVE_VIDEO_CREATION_MCQ_CANCEL_CONFIRMED: 'INTERACTIVE_VIDEO_CREATION/MCQ/CANCEL_CONFIRMED',
	INTERACTIVE_VIDEO_CREATION_MCQ_CANCEL_REJECTED: 'INTERACTIVE_VIDEO_CREATION/MCQ/CANCEL_REJECTED',
	INTERACTIVE_VIDEO_CREATION_MCQ_CREATE_ERROR: 'INTERACTIVE_VIDEO_CREATION/MCQ/CREATE_ERROR',
	INTERACTIVE_VIDEO_CREATION_MCQ_CREATE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/MCQ/CREATE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_MCQ_FINALIZE: 'INTERACTIVE_VIDEO_CREATION/MCQ/FINALIZE',
	INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE: 'INTERACTIVE_VIDEO_CREATION/MCQ/INITIALIZE',
	INTERACTIVE_VIDEO_CREATION_MCQ_QUESTION_FOCUS: 'INTERACTIVE_VIDEO_CREATION/MCQ/QUESTION_FOCUS',
	INTERACTIVE_VIDEO_CREATION_MCQ_QUESTION_UPDATE_ERROR: 'INTERACTIVE_VIDEO_CREATION/MCQ/QUESTION_UPDATE_ERROR',
	INTERACTIVE_VIDEO_CREATION_MCQ_QUESTION_UPDATE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/MCQ/QUESTION_UPDATE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_MCQ_SAVE: 'INTERACTIVE_VIDEO_CREATION/MCQ/SAVE',
	INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_ERROR: 'INTERACTIVE_VIDEO_CREATION/MCQ/SAVE_ERROR',
	INTERACTIVE_VIDEO_CREATION_MCQ_SAVE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/MCQ/SAVE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_ERROR: 'INTERACTIVE_VIDEO_CREATION/OEQ/CREATE_ERROR',
	INTERACTIVE_VIDEO_CREATION_OEQ_CREATE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/OEQ/CREATE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_OEQ_FINALIZE: 'INTERACTIVE_VIDEO_CREATION/OEQ/FINALIZE',
	INTERACTIVE_VIDEO_CREATION_OEQ_INITIALIZE: 'INTERACTIVE_VIDEO_CREATION/OEQ/INITIALIZE',
	INTERACTIVE_VIDEO_CREATION_OEQ_QUESTION_UPDATE_ERROR: 'INTERACTIVE_VIDEO_CREATION/OEQ/QUESTION_UPDATE_ERROR',
	INTERACTIVE_VIDEO_CREATION_OEQ_QUESTION_UPDATE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/OEQ/QUESTION_UPDATE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_OEQ_SAVE: 'INTERACTIVE_VIDEO_CREATION/OEQ/SAVE',
	INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_ERROR: 'INTERACTIVE_VIDEO_CREATION/OEQ/SAVE_ERROR',
	INTERACTIVE_VIDEO_CREATION_OEQ_SAVE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/OEQ/SAVE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_CLOSE: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/CLOSE',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_GET_FAILED: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/GET_FAILED',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_GET_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/GET_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_OPEN: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/OPEN',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/SAVE',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE_FAILED: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/SAVE_FAILED',
	INTERACTIVE_VIDEO_CREATION_SETTINGS_SAVE_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/SETTINGS/SAVE_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_CANCEL: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/CANCEL',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_ON_DRAG_TRIM_END: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/ON_DRAG_TRIM_END',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_ON_DRAG_TRIM_START: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/ON_DRAG_TRIM_START',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_OPEN: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/OPEN',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/SAVE_TRIM',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM_FAILED: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/SAVE_TRIM_FAILED',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_SAVE_TRIM_SUCCESS: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/SAVE_TRIM_SUCCESS',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_TRIM_TOOLTIP_GOT_IT: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/TRIM_TOOLTIP_GOT_IT',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_UNSAVED_BACK: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/UNSAVED/BACK',
	INTERACTIVE_VIDEO_CREATION_TRIM_TOOL_UNSAVED_TRIM_AND_SAVE: 'INTERACTIVE_VIDEO_CREATION/TRIM_TOOL/UNSAVED/TRIM_AND_SAVE',
	INTERACTIVE_VIDEO_CREATION_WELCOME_MODAL_LETS_DO_IT: 'INTERACTIVE_VIDEO_CREATION/WELCOME_MODAL/LETS_DO_IT',
	INTERACTIVE_VIDEO_ENABLE_CURRENT_ACTIVITY_DRAFT: 'INTERACTIVE_VIDEO/ENABLE_CURRENT_ACTIVITY_DRAFT',
	INTERACTIVE_VIDEO_END_OF_VIDEO_REACHED: 'INTERACTIVE_VIDEO/INTERACTIVE_VIDEO_END_OF_VIDEO_REACHED',
	INTERACTIVE_VIDEO_EXIT_SELECTED: 'INTERACTIVE_VIDEO/EXIT_SELECTED',
	INTERACTIVE_VIDEO_EXIT_SELECTED_CONFIRM_ACCEPTED: 'INTERACTIVE_VIDEO/EXIT_SELECTED_CONFIRM_ACCEPTED',
	INTERACTIVE_VIDEO_EXIT_SELECTED_CONFIRM_REJECTED: 'INTERACTIVE_VIDEO/EXIT_SELECTED_CONFIRM_REJECTED',
	INTERACTIVE_VIDEO_FINALIZE_CREATION_TOOL: 'INTERACTIVE_VIDEO/FINALIZE_CREATION_TOOL',
	INTERACTIVE_VIDEO_GOTO_PICKER: 'INTERACTIVE_VIDEO/GOTO_PICKER',
	INTERACTIVE_VIDEO_HANDOUTS_FETCHED: 'INTERACTIVE_VIDEO/HANDOUTS_FETCHED',
	INTERACTIVE_VIDEO_IMMERSIVE_READER_MCQ_TRANSFORM: 'INTERACTIVE_VIDEO/IMMERSIVE_READER/MCQ_TRANSFORM',
	INTERACTIVE_VIDEO_IMMERSIVE_READER_OEQ_TRANSFORM: 'INTERACTIVE_VIDEO/IMMERSIVE_READER/OEQ_TRANSFORM',
	INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL: 'INTERACTIVE_VIDEO/INITIALIZE_CREATION_TOOL',
	INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_BASE: 'INTERACTIVE_VIDEO/INITIALIZE_CREATION_TOOL_BASE',
	INTERACTIVE_VIDEO_INITIALIZE_CREATION_TOOL_EDIT: 'INTERACTIVE_VIDEO/INITIALIZE_CREATION_TOOL_EDIT',
	INTERACTIVE_VIDEO_INITIALIZE_SCREENSHOT_ROUTE: 'INTERACTIVE_VIDEO/INITIALIZE_SCREENSHOT_ROUTE',
	INTERACTIVE_VIDEO_INITIALIZE_SELECT_ROUTE: 'INTERACTIVE_VIDEO/INITIALIZE_SELECT_ROUTE',
	INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE: 'INTERACTIVE_VIDEO/INTERACTIVE_MODE_TOGGLE',
	INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_ACCEPTED: 'INTERACTIVE_VIDEO/INTERACTIVE_MODE_TOGGLE/CONFIRM_ACCEPTED',
	INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_DISMISSED_FAILED: 'INTERACTIVE_VIDEO/INTERACTIVE_MODE_TOGGLE/CONFIRM_DISMISSED_FAILED',
	INTERACTIVE_VIDEO_INTERACTIVE_MODE_TOGGLE_CONFIRM_REJECTED: 'INTERACTIVE_VIDEO/INTERACTIVE_MODE_TOGGLE/CONFIRM_REJECTED',
	INTERACTIVE_VIDEO_LESSON_FETCHED: 'INTERACTIVE_VIDEO/LESSON_FETCHED',
	INTERACTIVE_VIDEO_LESSON_FETCH_FAILED: 'INTERACTIVE_VIDEO/LESSON_FETCH_FAILED',
	INTERACTIVE_VIDEO_MCQ_COMPONENT_UNMOUNTED: 'INTERACTIVE_VIDEO/MCQ_COMPONENT_UNMOUNTED',
	INTERACTIVE_VIDEO_MAX_TIME_REACHED: 'INTERACTIVE_VIDEO/MAX_TIME_REACHED',
	INTERACTIVE_VIDEO_MEDIA_DATA_FAILED: 'INTERACTIVE_VIDEO/MEDIA_DATA_FAILED',
	INTERACTIVE_VIDEO_MEDIA_DATA_FETCHED: 'INTERACTIVE_VIDEO/MEDIA_DATA_FETCHED',
	INTERACTIVE_VIDEO_MEDIA_RANGE_EXITED: 'INTERACTIVE_VIDEO/MEDIA_RANGE_EXITED',
	INTERACTIVE_VIDEO_NOTIFICATIONS_FETCH_FAILED: 'INTERACTIVE_VIDEO/NOTIFICATIONS_FETCH_FAILED',
	INTERACTIVE_VIDEO_NOTIFICATIONS_FETCH_SUCCESS: 'INTERACTIVE_VIDEO/NOTIFICATIONS_FETCH_SUCCESS',
	INTERACTIVE_VIDEO_OEQ_COMPONENT_UNMOUNTED: 'INTERACTIVE_VIDEO/OEQ_COMPONENT_UNMOUNTED',
	INTERACTIVE_VIDEO_OPEN_BLANK_RESPONSE_PROMPT_MCQ: 'INTERACTIVE_VIDEO/OPEN_BLANK_RESPONSE_PROMPT_MCQ',
	INTERACTIVE_VIDEO_OPEN_BLANK_RESPONSE_PROMPT_OEQ: 'INTERACTIVE_VIDEO/OPEN_BLANK_RESPONSE_PROMPT_OEQ',
	INTERACTIVE_VIDEO_PARTICIPANT_JOINED_SESSION: 'INTERACTIVE_VIDEO/PARTICIPANT_JOINED_SESSION',
	INTERACTIVE_VIDEO_PARTICIPANT_LIMIT_REACHED: 'INTERACTIVE_VIDEO/PARTICIPANT_LIMIT_REACHED',
	INTERACTIVE_VIDEO_PARTICIPANT_STATE_FETCHED: 'INTERACTIVE_VIDEO/PARTICIPANT_STATE_FETCHED',
	INTERACTIVE_VIDEO_PARTICIPANT_SUBMISSIONS_FETCHED: 'INTERACTIVE_VIDEO/PARTICIPANT_SUBMISSIONS_FETCHED',
	INTERACTIVE_VIDEO_PARTICIPANT_SUBMISSIONS_FETCHED_FAILED: 'INTERACTIVE_VIDEO/PARTICIPANT_SUBMISSIONS_FETCHED_FAILED',
	INTERACTIVE_VIDEO_PREVIEW_SESSION_EXIT: 'INTERACTIVE_VIDEO/PREVIEW_SESSION_EXIT',
	INTERACTIVE_VIDEO_PAUSE_SELECTED: 'INTERACTIVE_VIDEO/PAUSE_SELECTED',
	INTERACTIVE_VIDEO_PLAY_SELECTED: 'INTERACTIVE_VIDEO/PLAY_SELECTED',
	INTERACTIVE_VIDEO_PLAYBACK_SPEED_SELECTED: 'INTERACTIVE_VIDEO/PLAYBACK_SPEED_SELECTED',
	INTERACTIVE_VIDEO_PLAYER_INITIALIZED: 'INTERACTIVE_VIDEO/PLAYER_INITIALIZED',
	INTERACTIVE_VIDEO_PREVIEW_FETCH_FAILED: 'INTERACTIVE_VIDEO/PREVIEW_FETCH_FAILED',
	INTERACTIVE_VIDEO_PREVIEW_FETCH_SUCCESS: 'INTERACTIVE_VIDEO/PREVIEW_FETCH_SUCCESS',
	INTERACTIVE_VIDEO_PREVIEW_FINALIZE: 'INTERACTIVE_VIDEO/PREVIEW_FINALIZE',
	INTERACTIVE_VIDEO_PREVIEW_INITIALIZE: 'INTERACTIVE_VIDEO/PREVIEW_INITIALIZE',
	INTERACTIVE_VIDEO_PUBLISH_ERROR: 'INTERACTIVE_VIDEO/PUBLISH_ERROR',
	INTERACTIVE_VIDEO_PUBLISH_SUCCESS: 'INTERACTIVE_VIDEO/PUBLISH_SUCCESS',
	INTERACTIVE_VIDEO_QUALITY_SELECTED: 'INTERACTIVE_VIDEO/QUALITY_SELECTED',
	INTERACTIVE_VIDEO_SAVE: 'INTERACTIVE_VIDEO/SAVE',
	INTERACTIVE_VIDEO_SAVE_ACTIVITY_DRAFT: 'INTERACTIVE_VIDEO/SAVE_ACTIVITY_DRAFT',
	INTERACTIVE_VIDEO_SAVE_FAILED: 'INTERACTIVE_VIDEO/SAVE_FAILED',
	INTERACTIVE_VIDEO_SAVE_SUCCESS: 'INTERACTIVE_VIDEO/SAVE_SUCCESS',
	INTERACTIVE_VIDEO_SAVE_STORE_PARENT_ID_ERROR: 'INTERACTIVE_VIDEO/SAVE_STORE_PARENT_ID_ERROR',
	INTERACTIVE_VIDEO_SEEK_ENDED: 'INTERACTIVE_VIDEO/SEEK_ENDED',
	INTERACTIVE_VIDEO_SEEK_SELECTED: 'INTERACTIVE_VIDEO/SEEK_SELECTED',
	INTERACTIVE_VIDEO_SESSION_DATA_FAILED: 'INTERACTIVE_VIDEO/SESSION/DATA_FAILED',
	INTERACTIVE_VIDEO_SESSION_DATA_SUCCESS: 'INTERACTIVE_VIDEO/SESSION/DATA_SUCCESS',
	INTERACTIVE_VIDEO_SESSION_INITIALIZE: 'INTERACTIVE_VIDEO/SESSION/INITIALIZE',
	INTERACTIVE_VIDEO_SESSION_INITIALIZED_CONTAINER: 'INTERACTIVE_VIDEO/SESSION/INITIALIZED_CONTAINER',
	INTERACTIVE_VIDEO_SESSION_FINALIZE: 'INTERACTIVE_VIDEO/SESSION/FINALIZE',
	INTERACTIVE_VIDEO_SESSION_STATUS_FETCHED: 'INTERACTIVE_VIDEO/SESSION/STATUS_FETCHED',
	INTERACTIVE_VIDEO_SESSION_USER_LEFT: 'INTERACTIVE_VIDEO/SESSION/USER_LEFT',
	INTERACTIVE_VIDEO_STANDALONE_INITIALIZE: 'INTERACTIVE_VIDEO/STANDALONE_INITIALIZE',
	INTERACTIVE_VIDEO_MCQ_UNSHARE_SOLUTION: 'INTERACTIVE_VIDEO/MCQ_UNSHARE_SOLUTION',
	INTERACTIVE_VIDEO_MCQ_UNSHARE_SOLUTION_FAILED: 'INTERACTIVE_VIDEO/MCQ_UNSHARE_SOLUTION_FAILED',
	INTERACTIVE_VIDEO_MCQ_SHARE_SOLUTION: 'INTERACTIVE_VIDEO/MCQ_SHARE_SOLUTION',
	INTERACTIVE_VIDEO_MCQ_SHARE_SOLUTION_FAILED: 'INTERACTIVE_VIDEO/MCQ_SHARE_SOLUTION_FAILED',
	INTERACTIVE_VIDEO_OEQ_SHARE_PARTICIPANT_SUBMISSION: 'INTERACTIVE_VIDEO/OEQ_SHARE_PARTICIPANT_SUBMISSION',
	INTERACTIVE_VIDEO_OEQ_SHARE_PARTICIPANT_SUBMISSION_FAILED: 'INTERACTIVE_VIDEO/OEQ_SHARE_PARTICIPANT_SUBMISSION_FAILED',
	INTERACTIVE_VIDEO_OEQ_UNSHARE_PARTICIPANT_SUBMISSION: 'INTERACTIVE_VIDEO/OEQ_UNSHARE_PARTICIPANT_SUBMISSION',
	INTERACTIVE_VIDEO_OEQ_UNSHARE_PARTICIPANT_SUBMISSION_FAILED: 'INTERACTIVE_VIDEO/OEQ_UNSHARE_PARTICIPANT_SUBMISSION_FAILED',
	INTERACTIVE_VIDEO_SLIDE_CHANGED: 'INTERACTIVE_VIDEO/SLIDE_CHANGED',
	INTERACTIVE_VIDEO_SUBMIT_BLANK_ANSWER_MCQ: 'INTERACTIVE_VIDEO/OPEN_BLANK_RESPONSE_PROMPT_MCQ',
	INTERACTIVE_VIDEO_SUBMIT_BLANK_ANSWER_OEQ: 'INTERACTIVE_VIDEO/OPEN_BLANK_RESPONSE_PROMPT_OEQ',
	INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER: 'INTERACTIVE_VIDEO/SUBMIT_MCQ_ANSWER',
	INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_CANCELLED: 'INTERACTIVE_VIDEO/SUBMIT_MCQ_ANSWER_CANCELLED',
	INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_FAILED: 'INTERACTIVE_VIDEO/SUBMIT_MCQ_ANSWER_FAILED',
	INTERACTIVE_VIDEO_SUBMIT_MCQ_ANSWER_SUCCESS: 'INTERACTIVE_VIDEO/SUBMIT_MCQ_ANSWER_SUCCESS',
	INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER: 'INTERACTIVE_VIDEO/SUBMIT_OEQ_ANSWER',
	INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_CANCELLED: 'INTERACTIVE_VIDEO/SUBMIT_OEQ_ANSWER_CANCELLED',
	INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_FAILED: 'INTERACTIVE_VIDEO/SUBMIT_OEQ_ANSWER_FAILED',
	INTERACTIVE_VIDEO_SUBMIT_OEQ_ANSWER_SUCCESS: 'INTERACTIVE_VIDEO/SUBMIT_OEQ_ANSWER_SUCCESS',
	INTERACTIVE_VIDEO_SUBMIT_SELECT_FORM: 'INTERACTIVE_VIDEO/SUBMIT_SELECT_FORM',
	INTERACTIVE_VIDEO_TOGGLE_MUTE_SELECTED: 'INTERACTIVE_VIDEO/TOGGLE_MUTE_SELECTED',
	INTERACTIVE_VIDEO_UPDATE_CREATION_TOOL: 'INTERACTIVE_VIDEO/UPDATE_CREATION_TOOL',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_ERROR: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_QUESTION_ERROR',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_QUESTION_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_PICKED: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_QUESTION_PICKED',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_QUESTION_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_QUESTION_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_ERROR: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_TRANSCRIPT_ERROR',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_TRANSCRIPT_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_PICKED: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_TRANSCRIPT_PICKED',
	INTERACTIVE_VIDEO_UPLOAD_HANDOUT_TRANSCRIPT_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_HANDOUT_TRANSCRIPT_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_POSTER_ERROR: 'INTERACTIVE_VIDEO/UPLOAD_POSTER_ERROR',
	INTERACTIVE_VIDEO_UPLOAD_POSTER_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_POSTER_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_POSTER_PICKED: 'INTERACTIVE_VIDEO/UPLOAD_POSTER_PICKED',
	INTERACTIVE_VIDEO_UPLOAD_POSTER_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_POSTER_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_CANCEL: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_CANCEL',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_CANCEL_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_CANCEL_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_ERROR: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_ERROR',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_PICKED: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_PICKED',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_PROGRESS: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_PROGRESS',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_STATUS_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_VIDEO_STATUS_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_VIDEO_STATUS_SUCCESS',
	INTERACTIVE_VIDEO_UPLOAD_CREDITS: 'INTERACTIVE_VIDEO/UPLOAD_CREDITS',
	INTERACTIVE_VIDEO_UPLOAD_CREDITS_FAILED: 'INTERACTIVE_VIDEO/UPLOAD_CREDITS_FAILED',
	INTERACTIVE_VIDEO_UPLOAD_CREDITS_SUCCESS: 'INTERACTIVE_VIDEO/UPLOAD_CREDITS_SUCCESS',
	INTERACTIVE_VIDEO_UPDATE_VIDEO_FAILED: 'INTERACTIVE_VIDEO/UPDATE_VIDEO_FAILED',
	INTERACTIVE_VIDEO_UPDATE_VIDEO_SUCCESS: 'INTERACTIVE_VIDEO/UPDATE_VIDEO_SUCCESS',
	INTERACTIVE_VIDEO_VOLUME_SELECTED: 'INTERACTIVE_VIDEO/VOLUME_SELECTED',
	JOIN_ERROR: 'JOIN/ERROR',
	JOIN_SUCCESS: 'JOIN/SUCCESS',
	LESSON_SESSION_METADATA_SUCCESS: 'LESSON_SESSION/METADATA_SUCCESS',
	LESSONS_SET_ALL: 'LESSONS/SET_ALL',
	LIBRARY_LOAD: 'LIBRARY_LOAD',
	LMS_MODAL_CONFIRMED: 'LMS_MODAL_CONFIRMED',
	LOGIN_AUTHENTICATION_FAILED: 'LOGIN/AUTHENTICATION_FAILED',
	LOGIN_FINALIZE: 'LOGIN/FINALIZE',
	LOGIN_INITIALIZE: 'LOGIN/LOGIN_INITIALIZE',
	LOGIN_NAVIGATE_TO_LOGIN: 'LOGIN/NAVIGATE_TO_LOGIN',
	LOGIN_NAVIGATE_TO_SIGNUP: 'LOGIN/NAVIGATE_TO_SIGNUP',
	LOGIN_RESET_AUTHENTICATION: 'LOGIN/RESET_AUTHENTICATION',
	LOGIN_SAVE_RECOVERY_KEY: 'LOGIN/SAVE_RECOVERY_KEY',
	LOGIN_SEND_FORGOT_PASSWORD_FORM: 'LOGIN/SEND_FORGOT_PASSWORD_FORM',
	LOGIN_SEND_FORM: 'LOGIN/SEND_FORM',
	LOGIN_SEND_NEW_PASSWORD_FORM: 'LOGIN/SEND_NEW_PASSWORD_FORM',
	LOGIN_SSO_ERROR_CONFIRM_CONFIRMED: 'LOGIN/SSO_ERROR_CONFIRM_CONFIRMED',
	LOGIN_SSO_REDIRECT: 'LOGIN/SSO_REDIRECT',
	LOGIN_SSO_REDIRECT_METRICS_SUCCESS: 'LOGIN/SSO_REDIRECT/METRICS_SUCCESS',
	LOGIN_STUDENT_GOOGLE_LOGIN_FAILED: 'LOGIN/STUDENT/GOOGLE_LOGIN_FAILED',
	LOGIN_STUDENT_GOOGLE_LOGIN_SUCCESS: 'LOGIN/STUDENT/GOOGLE_LOGIN_SUCCESS',
	LOGIN_STUDENT_OFFICE_365_LOGIN_FAILED: 'LOGIN/STUDENT/OFFICE_365_LOGIN_FAILED',
	LOGIN_STUDENT_OFFICE_365_LOGIN_SUCCESS: 'LOGIN/STUDENT/OFFICE_365_LOGIN_SUCCESS',
	LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_FAILED: 'LOGIN/STUDENT/SUBMIT_LOGIN_GOOGLE_TOKEN_FAILED',
	LOGIN_STUDENT_SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS: 'LOGIN/STUDENT/SUBMIT_LOGIN_GOOGLE_TOKEN_SUCCESS',
	LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_FAILED: 'LOGIN/STUDENT/SUBMIT_LOGIN_OFFICE_365_TOKEN_FAILED',
	LOGIN_STUDENT_SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS: 'LOGIN/STUDENT/SUBMIT_LOGIN_OFFICE_365_TOKEN_SUCCESS',
	LOGIN_VALIDATE_RECOVERY_KEY: 'LOGIN/VALIDATE_RECOVERY_KEY',
	LOGIN_VALID_RECOVERY_KEY: 'LOGIN/VALID_RECOVERY_KEY',
	LOGIN_VERIFY_ACCOUNT: 'LOGIN/VERIFY_ACCOUNT',
	MAIN_SIDEBAR_CONNECTOR_INITIALIZE: 'MAIN_SIDEBAR/CONNECTOR_INITIALIZE',
	MAIN_TOPBAR_CONNECTOR_FINALIZE: 'MAIN_TOPBAR/CONNECTOR_FINALIZE',
	MAIN_TOPBAR_CONNECTOR_INITIALIZE: 'MAIN_TOPBAR/CONNECTOR_INITIALIZE',
	MAIN_TOPBAR_CONNECTOR_VIEW_UPDATE: 'MAIN_TOPBAR/CONNECTOR_VIEW_UPDATE',
	MAIN_TOPBAR_CREATE_GOOGLE_DRIVE_LESSON: 'MAIN_TOPBAR/CREATE_GOOGLE_DRIVE_LESSON',
	MAIN_TOPBAR_CREATE_INTERACTIVE_VIDEO: 'MAIN_TOPBAR/CREATE_INTERACTIVE_VIDEO',
	MAIN_TOPBAR_CREATE_LESSON: 'MAIN_TOPBAR/CREATE_LESSON',
	MAIN_TOPBAR_HOME_SELECTED: 'MAIN_TOPBAR/HOME_SELECTED',
	MAIN_TOPBAR_HOME_SELECTED_FAILED: 'MAIN_TOPBAR/HOME_SELECTED_FAILED',
	MAIN_TOPBAR_INITIALIZE: 'MAIN_TOPBAR/INITIALIZE',
	MAIN_TOPBAR_LOGO_SELECTED: 'MAIN_TOPBAR/LOGO_SELECTED',
	MAIN_TOPBAR_PLUS_ICON_TOGGLED: 'MAIN_TOPBAR/PLUS_ICON_TOGGLED',
	MAIN_TOPBAR_QUICK_LAUNCH_ICON_TOGGLED: 'MAIN_TOPBAR/QUICK_LAUNCH_ICON_TOGGLED',
	MATCHING_PAIRS_CT_ADD_NEW_CARD_ERROR: 'MATCHING_PAIRS_CT/ADD_NEW_CARD_ERROR',
	MATCHING_PAIRS_CT_ADD_NEW_CARD_SUCCESS: 'MATCHING_PAIRS_CT/ADD_NEW_CARD_SUCCESS',
	MATCHING_PAIRS_CT_ADD_PAIR: 'MATCHING_PAIRS_CT/ADD_PAIR',
	MATCHING_PAIRS_CT_ADD_TIMER: 'MATCHING_PAIRS_CT/ADD_TIMER',
	MATCHING_PAIRS_CT_CANCEL_MP: 'MATCHING_PAIRS_CT/CANCEL_MP',
	MATCHING_PAIRS_CT_CANCEL_MP_CONFIRM: 'MATCHING_PAIRS_CT/CANCEL_MP_CONFIRM',
	MATCHING_PAIRS_CT_CANCEL_MP_CONFIRMED: 'MATCHING_PAIRS_CT/CANCEL_MP_CONFIRMED',
	MATCHING_PAIRS_CT_CANCEL_MP_REJECTED: 'MATCHING_PAIRS_CT/CANCEL_MP_REJECTED',
	MATCHING_PAIRS_CT_CANCEL_TIMER: 'MATCHING_PAIRS_CT/CANCEL_TIMER',
	MATCHING_PAIRS_CT_CARD_NEW_TEXT: 'MATCHING_PAIRS_CT/CARD_NEW_TEXT',
	MATCHING_PAIRS_CT_CLOSE_EDIT_PAIR: 'MATCHING_PAIRS_CT/CLOSE_EDIT_PAIR',
	MATCHING_PAIRS_CT_CLOSE_PREVIEW: 'MATCHING_PAIRS_CT/CLOSE_PREVIEW',
	MATCHING_PAIRS_CT_DELETE_PAIR: 'MATCHING_PAIRS_CT/DELETE_PAIR',
	MATCHING_PAIRS_CT_DELETE_PAIR_CONFIRMED: 'MATCHING_PAIRS_CT/DELETE_PAIR_CONFIRMED',
	MATCHING_PAIRS_CT_DELETE_PAIR_ERROR: 'MATCHING_PAIRS_CT/DELETE_PAIR_ERROR',
	MATCHING_PAIRS_CT_DELETE_PAIR_SUCCESS: 'MATCHING_PAIRS_CT/DELETE_PAIR_SUCCESS',
	MATCHING_PAIRS_CT_DELETE_TIMER: 'MATCHING_PAIRS_CT/DELETE_TIMER',
	MATCHING_PAIRS_CT_EDIT_PAIR: 'MATCHING_PAIRS_CT/EDIT_PAIR',
	MATCHING_PAIRS_CT_EDIT_TIMER: 'MATCHING_PAIRS_CT/EDIT_TIMER',
	MATCHING_PAIRS_CT_INITIALIZE_ERROR: 'MATCHING_PAIRS_CT/INITIALIZE_ERROR',
	MATCHING_PAIRS_CT_INITIALIZE_ROUTE: 'MATCHING_PAIRS_CT/INITIALIZE_ROUTE',
	MATCHING_PAIRS_CT_INITIALIZE_SUCCESS: 'MATCHING_PAIRS_CT/INITIALIZE_SUCCESS',
	MATCHING_PAIRS_CT_INSTRUCTIONS_BLUR: 'MATCHING_PAIRS_CT/INSTRUCTIONS_BLUR',
	MATCHING_PAIRS_CT_INSTRUCTIONS_CHANGE: 'MATCHING_PAIRS_CT/INSTRUCTIONS_CHANGE',
	MATCHING_PAIRS_CT_OPEN_PREVIEW: 'MATCHING_PAIRS_CT/OPEN_PREVIEW',
	MATCHING_PAIRS_CT_OPEN_SETTINGS: 'MATCHING_PAIRS_CT/OPEN_SETTINGS',
	MATCHING_PAIRS_CT_PAIR_ADD_AN_IMAGE: 'MATCHING_PAIRS_CT/PAIR_ADD_AN_IMAGE',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER: 'MATCHING_PAIRS_CT/PAIR_ADD_ANOTHER',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_ADD_SUCCESS: 'MATCHING_PAIRS_CT/PAIR_ADD_ANOTHER_ADD_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_SAVE_ERROR: 'MATCHING_PAIRS_CT_PAIR/ADD_ANOTHER_SAVE_ERROR',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_SAVE_SUCCESS: 'MATCHING_PAIRS_CT/PAIR_ADD_ANOTHER_SAVE_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_SUCCESS: 'MATCHING_PAIRS_CT/PAIR_ADD_ANOTHER_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER_VALIDATE_SUCCESS: 'MATCHING_PAIRS_CT/PAIR_ADD_ANOTHER_VALIDATE_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_CHANGE_IMAGE_MATRIX: 'MATCHING_PAIRS_CT/PAIR_CHANGE_IMAGE_MATRIX',
	MATCHING_PAIRS_CT_PAIR_CHANGE_TEXT: 'MATCHING_PAIRS_CT/PAIR_CHANGE_TEXT',
	MATCHING_PAIRS_CT_PAIR_DELETE_CONFIRM: 'MATCHING_PAIRS_CT/PAIR_DELETE_CONFIRM',
	MATCHING_PAIRS_CT_PAIR_DELETE_CONFIRMED: 'MATCHING_PAIRS_CT/PAIR_DELETE_CONFIRMED',
	MATCHING_PAIRS_CT_PAIR_DELETE_REJECTED: 'MATCHING_PAIRS_CT/PAIR_DELETE_REJECTED',
	MATCHING_PAIRS_CT_PAIR_DISCARD_CONTENT: 'MATCHING_PAIRS_CT/PAIR_DISCARD_CONTENT',
	MATCHING_PAIRS_CT_PAIR_IMAGE_LOAD: 'MATCHING_PAIRS_CT/PAIR_IMAGE_LOAD',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_ERROR: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICK_ERROR',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_SUCCESS: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICK_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_UPLOAD_ERROR: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICK_UPLOAD_ERROR',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_VALIDATE_ERROR: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICK_VALIDATE_ERROR',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICKED: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICKED',
	MATCHING_PAIRS_CT_PAIR_IMAGE_PICKER_CLOSE: 'MATCHING_PAIRS_CT/PAIR_IMAGE_PICKER_CLOSE',
	MATCHING_PAIRS_CT_PAIR_SAVE: 'MATCHING_PAIRS_CT/PAIR_SAVE',
	MATCHING_PAIRS_CT_PAIR_SAVE_ERROR: 'MATCHING_PAIRS_CT/PAIR_SAVE_ERROR',
	MATCHING_PAIRS_CT_PAIR_SAVE_SUCCESS: 'MATCHING_PAIRS/PAIR_SAVE_SUCCESS',
	MATCHING_PAIRS_CT_PAIR_SAVE_VALIDATE_ERROR: 'MATCHING_PAIRS/PAIR_SAVE_VALIDATE_ERROR',
	MATCHING_PAIRS_CT_PAIR_SAVE_VALIDATE_SUCCESS: 'MATCHING_PAIRS/PAIR_SAVE_VALIDATE_SUCCESS',
	MATCHING_PAIRS_CT_SAVE: 'MATCHING_PAIRS_CT/SAVE',
	MATCHING_PAIRS_CT_SAVE_ACTIVITY: 'MATCHING_PAIRS_CT/SAVE_ACTIVITY',
	MATCHING_PAIRS_CT_SAVE_ACTIVITY_ERROR: 'MATCHING_PAIRS_CT/SAVE_ACTIVITY_ERROR',
	MATCHING_PAIRS_CT_SAVE_ACTIVITY_SUCCESS: 'MATCHING_PAIRS_CT/SAVE_ACTIVITY_SUCCESS',
	MATCHING_PAIRS_CT_SAVE_ACTIVITY_VALIDATE_ERROR: 'MATCHING_PAIRS_CT/SAVE_ACTIVITY_VALIDATE_ERROR',
	MATCHING_PAIRS_CT_SAVE_ACTIVITY_VALIDATE_SUCCESS: 'MATCHING_PAIRS_CT/SAVE_ACTIVITY_VALIDATE_SUCCESS',
	MATCHING_PAIRS_CT_SAVE_ERROR: 'MATCHING_PAIRS_CT/SAVE_ERROR',
	MATCHING_PAIRS_CT_SAVE_SUCCESS: 'MATCHING_PAIRS_CT/SAVE_SUCCESS',
	MATCHING_PAIRS_CT_SAVE_TIMER: 'MATCHING_PAIRS_CT/SAVE_TIMER',
	MATCHING_PAIRS_CT_TITLE_SAVE_ERROR: 'MATCHING_PAIRS_CT/TITLE_SAVE_ERROR',
	MATCHING_PAIRS_CT_TITLE_SAVE_SUCCESS: 'MATCHING_PAIRS_CT/TITLE_SAVE_SUCCESS',
	MATCHING_PAIRS_CT_TOGGLE_HEADER: 'MATCHING_PAIRS_CT/TOGGLE_HEADER',
	MATCHING_PAIRS_CT_UPLOADER_VALIDATE_SUCCESS: 'MATCHING_PAIRS_CT/UPLOADER/VALIDATE_SUCCESS',
	MATCHING_PAIRS_FINALIZE_ROUTE: 'MATCHING_PAIRS/FINALIZE_ROUTE',
	MATCHING_PAIRS_INITIALIZE_STANDALONE: 'MATCHING_PAIRS/INITIALIZE_STANDALONE',
	MATCHING_PAIRS_SCREENSHOT_INITIALIZE_ROUTE: 'MATCHING_PAIRS_SCREENSHOT/INITIALIZE_ROUTE',
	MATCHING_PAIRS_STUDENT_ENDED: 'MATCHING_PAIRS_STUDENT/ENDED',
	MATCHING_PAIRS_STUDENT_INITIALIZE: 'MATCHING_PAIRS_STUDENT/INITIALIZE',
	MATCHING_PAIRS_STUDENT_INITIALIZE_STANDALONE_VIEW: 'MATCHING_PAIRS_STUDENT/INITIALIZE_STANDALONE_VIEW',
	MATCHING_PAIRS_STUDENT_SUBMIT_FAILED: 'MATCHING_PAIRS_STUDENT/SUBMIT_FAILED',
	MATCHING_PAIRS_STUDENT_UPDATE: 'MATCHING_PAIRS_STUDENT/UPDATE',
	MATCHING_PAIRS_TEACHER_INITIALIZE_STANDALONE_VIEW: 'MATCHING_PAIRS_TEACHER/INITIALIZE_STANDALONE_VIEW',
	MATCHING_PAIRS_UPDATE_CREATION_TOOL: 'MATCHING_PAIRS/UPDATE_CREATION_TOOL',
	MATCHING_PAIRS_UPDATE_CREATION_TOOL_SEARCH: 'MATCHING_PAIRS/UPDATE_CREATION_TOOL_SEARCH',
	MEDIA_PREVIEW: 'MEDIA_PREVIEW',
	MEDIA_SEARCH_GET_RESULTS: 'MEDIA_SEARCH/GET_RESULTS',
	MEDIA_SLIDE_FETCH_FAILED: 'MEDIA_SLIDE/FETCH_FAILED',
	MEDIA_SLIDE_FETCH_SUCCESS: 'MEDIA_SLIDE/FETCH_SUCCESS',
	MEDIA_SLIDE_MY_LIBRARY_SLIDE_FETCH_FAILED: 'MEDIA_SLIDE/MY_LIBRARY_SLIDE_FETCH_FAILED',
	MEDIA_SLIDE_PRIVATE_LIBRARY_SLIDE_FETCH_FAILED: 'MEDIA_SLIDE/PRIVATE_LIBRARY_SLIDE_FETCH_FAILED',
	MEDIA_SLIDE_STORE_SLIDE_FETCH_FAILED: 'MEDIA_SLIDE/STORE_SLIDE_FETCH_FAILED',
	MEDIA_SLIDE_VIDEO_PREVIEW_SLIDE_FETCH_SUCCESS: 'MEDIA_SLIDE/VIDEO_PREVIEW_SLIDE_FETCH_SUCCESS',
	MEDIA_SLIDE_VIDEO_PREVIEW_SLIDE_FETCH_FAILED: 'MEDIA_SLIDE/VIDEO_PREVIEW_SLIDE_FETCH_FAILED',
	METRICS_GET_LESSON_ERROR: 'METRICS/GET_LESSON_ERROR',
	MY_ACCOUNT_AVATAR_CLICK: 'MY_ACCOUNT/AVATAR_CLICK',
	MY_ACCOUNT_CHANGE_COUNTRY: 'MY_ACCOUNT/CHANGE_COUNTRY',
	MY_ACCOUNT_CHANGE_PASSWORD: 'MY_ACCOUNT/CHANGE_PASSWORD',
	MY_ACCOUNT_CHANGE_PASSWORD_FAILED: 'MY_ACCOUNT/CHANGE_PASSWORD_FAILED',
	MY_ACCOUNT_CHANGE_PASSWORD_SUCCESS: 'MY_ACCOUNT/CHANGE_PASSWORD_SUCCESS',
	MY_ACCOUNT_CHANGE_STATE: 'MY_ACCOUNT/CHANGE_STATE',
	MY_ACCOUNT_CLOSE_PASSWORD_FORM: 'MY_ACCOUNT/CLOSE_PASSWORD_FORM',
	MY_ACCOUNT_DATA_FETCHED: 'MY_ACCOUNT/DATA_FETCHED',
	MY_ACCOUNT_FINALIZE_BASE: 'MY_ACCOUNT/FINALIZE_BASE',
	MY_ACCOUNT_GET_ADVANCED_SETTINGS_FAILED: 'MY_ACCOUNT/GET_ADVANCED_SETTINGS_FAILED',
	MY_ACCOUNT_GET_ADVANCED_SETTINGS_SUCCESS: 'MY_ACCOUNT/GET_ADVANCED_SETTINGS_SUCCESS',
	MY_ACCOUNT_GET_DATA: 'MY_ACCOUNT/GET_DATA',
	MY_ACCOUNT_INITIALIZE_ADVANCED_SETTINGS: 'MY_ACCOUNT/INITIALIZE_ADVANCED_SETTINGS',
	MY_ACCOUNT_INITIALIZE_BASE: 'MY_ACCOUNT/INITIALIZE_BASE',
	MY_ACCOUNT_INITIALIZE_NOTIFICATIONS: 'MY_ACCOUNT/INITIALIZE_NOTIFICATIONS',
	MY_ACCOUNT_MENU_FREE_UPGRADE: 'MY_ACCOUNT/MENU_FREE_UPGRADE',
	MY_ACCOUNT_MENU_UPGRADE: 'MY_ACCOUNT/MENU_UPGRADE',
	MY_ACCOUNT_NEARPOD_PICKER_CANCEL: 'MY_ACCOUNT/NEARPOD_PICKER/CANCEL',
	MY_ACCOUNT_NEARPOD_PICKER_FILE_PREVIEW: 'MY_ACCOUNT/NEARPOD_PICKER_FILE_PREVIEW',
	MY_ACCOUNT_PAYMENT_DETAILS_SELECTED: 'MY_ACCOUNT/PAYMENT_DETAILS_SELECTED',
	MY_ACCOUNT_SAVE_ADVANCED_SETTINGS: 'MY_ACCOUNT/SAVE_ADVANCED_SETTINGS',
	MY_ACCOUNT_SAVE_ADVANCED_SETTINGS_FAILED: 'MY_ACCOUNT/SAVE_ADVANCED_SETTINGS_FAILED',
	MY_ACCOUNT_SAVE_ADVANCED_SETTINGS_SUCCESS: 'MY_ACCOUNT/SAVE_ADVANCED_SETTINGS_SUCCESS',
	MY_ACCOUNT_SAVE_ICON_SUCCESS: 'MY_ACCOUNT/SAVE_ICON_SUCCESS',
	MY_ACCOUNT_SAVE_PERSONAL_INFO: 'MY_ACCOUNT/SAVE_PERSONAL_INFO',
	MY_ACCOUNT_SAVE_PERSONAL_INFO_FAILED: 'MY_ACCOUNT/SAVE_PERSONAL_INFO_FAILED',
	MY_ACCOUNT_SAVE_PERSONAL_INFO_SUCCESS: 'MY_ACCOUNT/SAVE_PERSONAL_INFO_SUCCESS',
	MY_ACCOUNT_SAVE_SCHOOL_INFO: 'MY_ACCOUNT/SAVE_SCHOOL_INFO',
	MY_ACCOUNT_SAVE_SCHOOL_INFO_FAILED: 'MY_ACCOUNT/SAVE_SCHOOL_INFO_FAILED',
	MY_ACCOUNT_SAVE_SCHOOL_INFO_SUCCESS: 'MY_ACCOUNT/SAVE_SCHOOL_INFO_SUCCESS',
	MY_ACCOUNT_SAVE_TEACHER_INFO: 'MY_ACCOUNT/SAVE_TEACHER_INFO',
	MY_ACCOUNT_SAVE_TEACHER_INFO_FAILED: 'MY_ACCOUNT/SAVE_TEACHER_INFO_FAILED',
	MY_ACCOUNT_SAVE_TEACHER_INFO_SUCCESS: 'MY_ACCOUNT/SAVE_TEACHER_INFO_SUCCESS',
	MY_ACCOUNT_SCHOOLS_FETCHED: 'MY_ACCOUNT/SCHOOLS_FETCHED',
	MY_ACCOUNT_SEARCH_SCHOOLS: 'MY_ACCOUNT/SEARCH_SCHOOLS',
	MY_ACCOUNT_SHOW_PASSWORD_FORM: 'MY_ACCOUNT/SHOW_PASSWORD_FORM',
	MY_ACCOUNT_SHOW_SCHOOL_BUTTONS: 'MY_ACCOUNT/SHOW_SCHOOL_BUTTONS',
	MY_ACCOUNT_SHOW_TEACHER_BUTTONS: 'MY_ACCOUNT/SHOW_TEACHER_BUTTONS',
	MY_ACCOUNT_UPLOAD_PROFILE_IMAGE: 'MY_ACCOUNT/UPLOAD_PROFILE_IMAGE',
	MY_ACCOUNT_UPLOAD_PROFILE_IMAGE_ERROR: 'MY_ACCOUNT/UPLOAD_PROFILE_IMAGE_ERROR',
	MY_ACCOUNT_UPLOADER_UPLOAD_ERROR: 'MY_ACCOUNT/UPLOADER/UPLOAD_ERROR',
	MY_ACCOUNT_UPLOADER_UPLOAD_SUCCESS: 'MY_ACCOUNT/UPLOADER/UPLOAD_SUCCESS',
	MY_ACCOUNT_UPLOADER_VALIDATE_ERROR: 'MY_ACCOUNT/UPLOADER/VALIDATE_ERROR',
	MY_ACCOUNT_UPLOADER_VALIDATE_SUCCESS: 'MY_ACCOUNT/UPLOADER/VALIDATE_SUCCESS',
	MY_ACTIVITIES_INITIALIZE: 'MY_ACTIVITIES/INITIALIZE',
	MY_LIBRARY_ADD_FOLDER: 'MY_LIBRARY/ADD_FOLDER',
	MY_LIBRARY_ADD_LESSON_TO_FOLDER: 'MY_LIBRARY/ADD_LESSON_TO_FOLDER',
	MY_LIBRARY_ADD_LESSON_TO_FOLDER_CANCELLED: 'MY_LIBRARY/ADD_LESSON_TO_FOLDER_CANCELLED',
	MY_LIBRARY_ADD_LESSON_TO_FOLDER_FAILED: 'MY_LIBRARY/ADD_LESSON_TO_FOLDER_FAILED',
	MY_LIBRARY_ADD_LESSON_TO_FOLDER_SELECTED: 'MY_LIBRARY/ADD_LESSON_TO_FOLDER_SELECTED',
	MY_LIBRARY_ADD_LESSON_TO_FOLDER_SUCCESS: 'MY_LIBRARY/ADD_LESSON_TO_FOLDER_SUCCESS',
	MY_LIBRARY_ADD_LESSON_TO_NEW_FOLDER: 'MY_LIBRARY/ADD_LESSON_TO_NEW_FOLDER',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_ADD_SELECTED: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL/ADD_SELECTED',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_CLOSE_SELECTED: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL/CLOSE_SELECTED',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL_FOLDER_ID_UPDATED: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_MODAL/FOLDER_ID_UPDATED',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_STARTED: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_STARTED',
	MY_LIBRARY_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS: 'MY_LIBRARY/ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS',
	MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY: 'MY_LIBRARY/ADD_LESSON_TO_PUBLIC_LIBRARY',
	MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY_FAILED: 'MY_LIBRARY/ADD_LESSON_TO_PUBLIC_LIBRARY_FAILED',
	MY_LIBRARY_ADD_LESSON_TO_PUBLIC_LIBRARY_SUCCESS: 'MY_LIBRARY/ADD_LESSON_TO_PUBLIC_LIBRARY_SUCCESS',
	MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER: 'MY_LIBRARY/ADD_MULTIPLE_LESSONS_TO_FOLDER',
	MY_LIBRARY_ADD_MULTIPLE_LESSONS_TO_FOLDER_CANCELLED: 'MY_LIBRARY/ADD_MULTIPLE_LESSONS_TO_FOLDER_CANCELLED',
	MY_LIBRARY_ADD_OR_UPDATE_FOLDER: 'MY_LIBRARY/ADD_OR_UPDATE_FOLDER',
	MY_LIBRARY_ADD_OR_UPDATE_FOLDER_CANCELLED: 'MY_LIBRARY/ADD_OR_UPDATE_FOLDER_CANCELLED',
	MY_LIBRARY_ADD_OR_UPDATE_FOLDER_FAILED: 'MY_LIBRARY/ADD_OR_UPDATE_FOLDER_FAILED',
	MY_LIBRARY_ADD_OR_UPDATE_FOLDER_SUCCESS: 'MY_LIBRARY/ADD_OR_UPDATE_FOLDER_SUCCESS',
	MY_LIBRARY_ADDED_LESSON_TO_PRIVATE_LIBRARY_CLOSE: 'MY_LIBRARY/ADDED_LESSON_TO_PRIVATE_LIBRARY_CLOSE',
	MY_LIBRARY_CANCEL_SESSION_LAUNCH: 'MY_LIBRARY/CANCEL_SESSION_LAUNCH',
	MY_LIBRARY_CHANGE_FOLDER_COLOR: 'MY_LIBRARY/CHANGE_FOLDER_COLOR',
	MY_LIBRARY_CHANGE_FOLDER_COLOR_ERROR: 'MY_LIBRARY/CHANGE_FOLDER_COLOR_ERROR',
	MY_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS: 'MY_LIBRARY/CHANGE_FOLDER_COLOR_SUCCESS',
	MY_LIBRARY_CLOSE_AYCE_DOWNGRADE_ACCOUNT: 'MY_LIBRARY/CLOSE_AYCE_DOWNGRADE_ACCOUNT',
	MY_LIBRARY_CLOSE_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM: 'MY_LIBRARY/CLOSE_EDIT_LESSON_IN_PUBLIC_LIBRARY_CONFIRM',
	MY_LIBRARY_CLOSE_EDIT_RUNNING_LESSON_CONFIRM: 'MY_LIBRARY/CLOSE_EDIT_RUNNING_LESSON_CONFIRM',
	MY_LIBRARY_CLOSE_EDIT_STORE_LESSON_CONFIRM: 'MY_LIBRARY/CLOSE_EDIT_STORE_LESSON_CONFIRM',
	MY_LIBRARY_CLOSE_EXPORT_TO_PDF_CONFIRM: 'MY_LIBRARY/CLOSE_EXPORT_TO_PDF_CONFIRM',
	MY_LIBRARY_CLOSE_FEATURE_DOWNGRADE_ACCOUNT: 'MY_LIBRARY/CLOSE_FEATURE_DOWNGRADE_ACCOUNT',
	MY_LIBRARY_CLOSE_LAUNCH_SESSION_TEAMS: 'MY_LIBRARY/CLOSE_LAUNCH_SESSION_TEAMS',
	MY_LIBRARY_CLOSE_NO_LESSONS_LTI_CONFIRM: 'MY_LIBRARY/CLOSE_NO_LESSONS_LTI_CONFIRM',
	MY_LIBRARY_CLOSE_PLATINUM_DOWNGRADE_ACCOUNT: 'MY_LIBRARY/CLOSE_PLATINUM_DOWNGRADE_ACCOUNT',
	MY_LIBRARY_CLOSE_REMOVE_FOLDER_CONFIRM: 'MY_LIBRARY/CLOSE_REMOVE_FOLDER_CONFIRM',
	MY_LIBRARY_CLOSE_SAVE_CHANGES_MODAL: 'MY_LIBRARY/CLOSE_SAVE_CHANGES_MODAL',
	MY_LIBRARY_CLOSE_SAVE_CONFIRM: 'MY_LIBRARY/CLOSE_SAVE_CONFIRM',
	MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON: 'MY_LIBRARY/CREATE_GOOGLE_DRIVE_LESSON',
	MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_FAILED: 'MY_LIBRARY/CREATE_GOOGLE_DRIVE_LESSON_FAILED',
	MY_LIBRARY_CREATE_GOOGLE_DRIVE_LESSON_SUCCESS: 'MY_LIBRARY/CREATE_GOOGLE_DRIVE_LESSON_SUCCESS',
	MY_LIBRARY_CREATE_GOOGLE_SLIDES_IN_NEARPOD: 'MY_LIBRARY/CREATE_GOOGLE_SLIDES_IN_NEARPOD',
	MY_LIBRARY_CREATE_INTERACTIVE_VIDEO: 'MY_LIBRARY/CREATE_INTERACTIVE_VIDEO',
	MY_LIBRARY_CREATE_LESSON: 'MY_LIBRARY/CREATE_LESSON',
	MY_LIBRARY_CREATE_LESSON_THUMBNAIL: 'MY_LIBRARY/CREATE_LESSON_THUMBNAIL',
	MY_LIBRARY_CREATION_MENU_CREATE_LESSON_SELECTED: 'MY_LIBRARY/CREATION_MENU_CREATE_LESSON_SELECTED',
	MY_LIBRARY_DELETE_FOLDER_CONFIRMED: 'MY_LIBRARY/DELETE_FOLDER_CONFIRMED',
	MY_LIBRARY_DELETE_FOLDER_RESPONSE_FAILED: 'MY_LIBRARY/DELETE_FOLDER_RESPONSE_FAILED',
	MY_LIBRARY_DELETE_FOLDER_RESPONSE_SUCCESS: 'MY_LIBRARY/DELETE_FOLDER_RESPONSE_SUCCESS',
	MY_LIBRARY_DELETE_LESSON: 'MY_LIBRARY/DELETE_LESSON',
	MY_LIBRARY_DELETE_LESSON_CANCELLED: 'MY_LIBRARY/DELETE_LESSON_CANCELLED',
	MY_LIBRARY_DELETE_LESSON_CONFIRMED: 'MY_LIBRARY/DELETE_LESSON_CONFIRMED',
	MY_LIBRARY_DELETE_LESSON_FAILED: 'MY_LIBRARY/DELETE_LESSON_FAILED',
	MY_LIBRARY_DELETE_LESSON_SUCCESS: 'MY_LIBRARY/DELETE_LESSON_SUCCESS',
	MY_LIBRARY_DOWNLOAD_AND_LAUNCH_STARTED: 'MY_LIBRARY/DOWNLOAD_AND_LAUNCH_STARTED',
	MY_LIBRARY_DOWNLOAD_FINISHED_AND_LAUNCH_STARTED: 'MY_LIBRARY/DOWNLOAD_FINISHED_AND_LAUNCH_STARTED',
	MY_LIBRARY_DUPLICATE_LESSON: 'MY_LIBRARY/DUPLICATE_LESSON',
	MY_LIBRARY_DUPLICATE_LESSON_CONFIRMED: 'MY_LIBRARY/DUPLICATE_LESSON_CONFIRMED',
	MY_LIBRARY_DUPLICATE_LESSON_CONFIRM_DISMISS: 'MY_LIBRARY/DUPLICATE_LESSON_CONFIRM_DISMISS',
	MY_LIBRARY_DUPLICATE_LESSON_FAILED: 'MY_LIBRARY/DUPLICATE_LESSON_FAILED',
	MY_LIBRARY_DUPLICATE_LESSON_SUCCESS: 'MY_LIBRARY/DUPLICATE_LESSON_SUCCESS',
	MY_LIBRARY_EDIT_GOOGLE_SLIDES_IN_NEARPOD: 'MY_LIBRARY/EDIT_GOOGLE_SLIDES_IN_NEARPOD',
	MY_LIBRARY_EDIT_LESSON: 'MY_LIBRARY/EDIT_LESSON',
	MY_LIBRARY_EDIT_LESSON_FAILED: 'MY_LIBRARY/EDIT_LESSON_FAILED',
	MY_LIBRARY_EDIT_LESSON_IN_PUBLIC_LIBRARY: 'MY_LIBRARY/EDIT_LESSON_IN_PUBLIC_LIBRARY',
	MY_LIBRARY_EDIT_LESSON_INIT: 'MY_LIBRARY/EDIT_LESSON_INIT',
	MY_LIBRARY_EDIT_LESSON_SUCCESS: 'MY_LIBRARY/EDIT_LESSON_SUCCESS',
	MY_LIBRARY_EDIT_RUNNING_LESSON: 'MY_LIBRARY/EDIT_RUNNING_LESSON',
	MY_LIBRARY_EDIT_STORE_LESSON: 'MY_LIBRARY/EDIT_STORE_LESSON',
	MY_LIBRARY_EXPLORE_STORE: 'MY_LIBRARY/EXPLORE_STORE',
	MY_LIBRARY_EXPORT_TO_GOOGLE_DRIVE: 'MY_LIBRARY/EXPORT_TO_GOOGLE_DRIVE',
	MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE: 'MY_LIBRARY/EXPORT_TO_LOCAL_DRIVE',
	MY_LIBRARY_EXPORT_TO_LOCAL_DRIVE_FETCHED: 'MY_LIBRARY/EXPORT_TO_LOCAL_DRIVE_FETCHED',
	MY_LIBRARY_EXPORT_TO_PDF: 'MY_LIBRARY/EXPORT_TO_PDF',
	MY_LIBRARY_EXTENSION_LESSON_LAUNCHED_SUCCESS: 'MY_LIBRARY/EXTENSION_LESSON_LAUNCHED_SUCCESS',
	MY_LIBRARY_EXTENSION_PREMIUM_FEATURE_UPGRADE: 'MY_LIBRARY/EXTENSION_PREMIUM_FEATURE_UPGRADE',
	MY_LIBRARY_EXTENSION_SESSION_FAILED: 'MY_LIBRARY/EXTENSION_SESSION_FAILED',
	MY_LIBRARY_EXTENSION_SESSION_FETCHED: 'MY_LIBRARY/EXTENSION_SESSION_FETCHED',
	MY_LIBRARY_FEATURE_REDEEM_FAIL_CONFIRM: 'MY_LIBRARY/FEATURE_REDEEM_FAIL_CONFIRM',
	MY_LIBRARY_FINALIZE: 'MY_LIBRARY/FINALIZE',
	MY_LIBRARY_FIRST_LESSON_ANIMATION_LOADING_COMPLETED: 'MY_LIBRARY/FIRST_LESSON/ANIMATION_LOADING_COMPLETED',
	MY_LIBRARY_FIRST_LESSON_CLOSED: 'MY_LIBRARY/FIRST_LESSON/CLOSED',
	MY_LIBRARY_FIRST_LESSON_COMPLETED: 'MY_LIBRARY/FIRST_LESSON/COMPLETED',
	MY_LIBRARY_FIRST_LESSON_FILE_PICKED: 'MY_LIBRARY/FIRST_LESSON/FILE_PICKED',
	MY_LIBRARY_FIRST_LESSON_FILE_PICKED_ERROR: 'MY_LIBRARY/FIRST_LESSON/FILE_PICKED_ERROR',
	MY_LIBRARY_FIRST_LESSON_FILE_UPLOADED_ERROR: 'MY_LIBRARY/FIRST_LESSON/FILE_UPLOADED_ERROR',
	MY_LIBRARY_FIRST_LESSON_INITIALIZE: 'MY_LIBRARY/FIRST_LESSON/INITIALIZE',
	MY_LIBRARY_FIRST_LESSON_PRESENTATION_PUBLISHED: 'MY_LIBRARY/FIRST_LESSON/PRESENTATION_PUBLISHED',
	MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED: 'MY_LIBRARY/FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED',
	MY_LIBRARY_FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED_FAILED: 'MY_LIBRARY/FLOCABULARY_ANNOUNCEMENT_CONTINUE_SELECTED_FAILED',
	MY_LIBRARY_FOLDERS_FETCHED: 'MY_LIBRARY/FOLDERS_FETCHED',
	MY_LIBRARY_FOLDER_RENAME: 'MY_LIBRARY/FOLDER_RENAME',
	MY_LIBRARY_FOLDER_SELECTED: 'MY_LIBRARY/FOLDER_SELECTED',
	MY_LIBRARY_FRONT_OF_THE_CLASSROOM_SESSION_FAILED: 'MY_LIBRARY/FRONT_OF_THE_CLASSROOM_SESSION_FAILED',
	MY_LIBRARY_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED: 'MY_LIBRARY/FRONT_OF_THE_CLASSROOM_SESSION_FETCHED',
	MY_LIBRARY_GET_ACTIVE_PINCODES_FAILED: 'MY_LIBRARY/GET_ACTIVE_PINCODES_FAILED',
	MY_LIBRARY_GET_ACTIVE_PINCODES_SUCCESS: 'MY_LIBRARY/GET_ACTIVE_PINCODES_SUCCESS',
	MY_LIBRARY_GET_LESSONS_NEXT_PAGE: 'MY_LIBRARY/GET_LESSONS_NEXT_PAGE',
	MY_LIBRARY_GO_TO_REPORTS: 'MY_LIBRARY/GO_TO_REPORTS',
	MY_LIBRARY_GRADES_SUBJECTS_DISMISS: 'MY_LIBRARY/GRADES_SUBJECTS/DISMISS',
	MY_LIBRARY_GRADES_SUBJECTS_INITIALIZE: 'MY_LIBRARY/GRADES_SUBJECTS/INITIALIZE',
	MY_LIBRARY_GRADES_SUBJECTS_SUBMIT: 'MY_LIBRARY/GRADES_SUBJECTS/SUBMIT',
	MY_LIBRARY_HAS_MULTIPLE_LIVE_SESSIONS: 'MY_LIBRARY/HAS_MULTIPLE_LIVE_SESSIONS',
	MY_LIBRARY_HOMEWORK_FAILED: 'MY_LIBRARY/HOMEWORK_FAILED',
	MY_LIBRARY_HOMEWORK_FETCHED: 'MY_LIBRARY/HOMEWORK_FETCHED',
	MY_LIBRARY_HOMEWORK_UPGRADE_ACTION_SELECTED: 'MY_LIBRARY/HOMEWORK_UPGRADE_ACTION_SELECTED',
	MY_LIBRARY_IMMERSIVE_READER_CANCELLED: 'MY_LIBRARY/IMMERSIVE_READER_CANCELLED',
	MY_LIBRARY_IMMERSIVE_READER_CONFIRMED: 'MY_LIBRARY/IMMERSIVE_READER_CONFIRMED',
	MY_LIBRARY_IMMERSIVE_READER_SUCCESS: 'MY_LIBRARY/IMMERSIVE_READER_SUCCESS',
	MY_LIBRARY_INITIALIZE: 'MY_LIBRARY/INITIALIZE',
	MY_LIBRARY_INITIALIZE_VIDEO_PREVIEW: 'MY_LIBRARY/INITIALIZE_VIDEO_PREVIEW',
	MY_LIBRARY_INVALID_LTI_SESSION_LAUNCHED: 'MY_LIBRARY/INVALID_LTI_SESSION_LAUNCHED',
	MY_LIBRARY_LAUNCH_FRONT_OF_THE_CLASSROOM: 'MY_LIBRARY/LAUNCH_FRONT_OF_THE_CLASSROOM',
	MY_LIBRARY_LAUNCH_HOMEWORK: 'MY_LIBRARY/LAUNCH_HOMEWORK',
	MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_LAUNCH: 'MY_LIBRARY/LAUNCH_HOMEWORK_COLLABORATE_DISABLED_LAUNCH',
	MY_LIBRARY_LAUNCH_HOMEWORK_COLLABORATE_DISABLED_OPEN_SETTINGS: 'MY_LIBRARY/LAUNCH_HOMEWORK_COLLABORATE_DISABLED_OPEN_SETTINGS',
	MY_LIBRARY_LAUNCH_HOMEWORK_INITIALIZE: 'MY_LIBRARY/LAUNCH_HOMEWORK/INITIALIZE',
	MY_LIBRARY_LAUNCH_HOMEWORK_UNMOUNT: 'MY_LIBRARY/LAUNCH_HOMEWORK/UNMOUNT',
	MY_LIBRARY_LAUNCH_LIVE_LESSON: 'MY_LIBRARY/LAUNCH_LIVE_LESSON',
	MY_LIBRARY_LAUNCH_NEW_HOMEWORK: 'MY_LIBRARY/LAUNCH_NEW_HOMEWORK',
	MY_LIBRARY_LAUNCH_NEW_LIVE_SESSION: 'MY_LIBRARY/LAUNCH_NEW_LIVE_SESSION',
	MY_LIBRARY_LAUNCH_VIDEO_PREVIEW: 'MY_LIBRARY/LAUNCH_VIDEO_PREVIEW',
	MY_LIBRARY_LESSON_DATA_SAVED: 'MY_LIBRARY/LESSON_DATA_SAVED',
	MY_LIBRARY_LESSON_LAUNCH_FAILED_CONFIRM_CLOSE: 'MY_LIBRARY/LESSON_LAUNCH_FAILED_CONFIRM_CLOSE',
	MY_LIBRARY_LESSONS_FAILED: 'MY_LIBRARY/LESSONS_FAILED',
	MY_LIBRARY_LESSONS_FETCHED: 'MY_LIBRARY/LESSONS_FETCHED',
	MY_LIBRARY_LESSONS_PICKER_INIT: 'MY_LIBRARY/LESSONS_PICKER_INIT',
	MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS: 'MY_LIBRARY/LESSONS_PICKER_SAVE_LESSONS',
	MY_LIBRARY_LESSONS_PICKER_SAVE_LESSONS_SUCCESS: 'MY_LIBRARY/LESSONS_PICKER_SAVE_LESSONS_SUCCESS',
	MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS: 'MY_LIBRARY/LESSONS_PICKER_SEARCH_LESSONS',
	MY_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS_FETCHED: 'MY_LIBRARY/LESSONS_PICKER_SEARCH_LESSONS_FETCHED',
	MY_LIBRARY_LIVE_SESSION_CODES_CLOSED: 'MY_LIBRARY/LIVE_SESSION_CODES_CLOSED',
	MY_LIBRARY_LIVE_SESSION_FAILED: 'MY_LIBRARY/LIVE_SESSION_FAILED',
	MY_LIBRARY_LTI_SESSION_FAILED: 'MY_LIBRARY/LTI_SESSION_FAILED',
	MY_LIBRARY_MOVE_FOLDER: 'MY_LIBRARY/MOVE_FOLDER',
	MY_LIBRARY_MOVE_FOLDER_FAILED: 'MY_LIBRARY/MOVE_FOLDER_FAILED',
	MY_LIBRARY_MOVE_FOLDER_SUCCESS: 'MY_LIBRARY/MOVE_FOLDER_SUCCESS',
	MY_LIBRARY_MOVE_LESSON: 'MY_LIBRARY/MOVE_LESSON',
	MY_LIBRARY_MOVE_LESSON_FAILED: 'MY_LIBRARY/MOVE_LESSON_FAILED',
	MY_LIBRARY_MOVE_LESSON_SUCCESS: 'MY_LIBRARY/MOVE_LESSON_SUCCESS',
	MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CLOSE: 'MY_LIBRARY/ONBOARDING_CREATE_LESSON_OVERLAY_CLOSE',
	MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_CONFIRM: 'MY_LIBRARY/ONBOARDING_CREATE_LESSON_OVERLAY_CONFIRM',
	MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_DISMISS: 'MY_LIBRARY/ONBOARDING_CREATE_LESSON_OVERLAY_DISMISS',
	MY_LIBRARY_ONBOARDING_CREATE_LESSON_OVERLAY_INITIALIZE: 'MY_LIBRARY/ONBOARDING_CREATE_LESSON_OVERLAY_INITIALIZE',
	MY_LIBRARY_PAYWALL_DISMISS: 'MY_LIBRARY/PAYWALL_DISMISS',
	MY_LIBRARY_PAYWALL_EXPIRED_CLOSE: 'MY_LIBRARY/PAYWALL_EXPIRED_CLOSE',
	MY_LIBRARY_PAYWALL_EXPIRED_UPGRADE: 'MY_LIBRARY/PAYWALL_EXPIRED_UPGRADE',
	MY_LIBRARY_PAYWALL_REMINDER_CLOSE: 'MY_LIBRARY/PAYWALL_REMINDER_CLOSE',
	MY_LIBRARY_PAYWALL_REMINDER_UPGRADE: 'MY_LIBRARY/PAYWALL_REMINDER_UPGRADE',
	MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_CLOSE_SELECTED: 'MY_LIBRARY/PAYWALL_STORAGE_CONFIRM/CLOSE_SELECTED',
	MY_LIBRARY_PAYWALL_STORAGE_CONFIRM_UPGRADE_SELECTED: 'MY_LIBRARY/PAYWALL_STORAGE_CONFIRM/UPGRADE_SELECTED',
	MY_LIBRARY_PAYWALL_UPGRADE_NOW: 'MY_LIBRARY/PAYWALL_UPGRADE_NOW',
	MY_LIBRARY_PENDING_LESSONS_STATUS_FETCHED: 'MY_LIBRARY/PENDING_LESSONS_STATUS_FETCHED',
	MY_LIBRARY_PREVIEW_DATA_FETCHED: 'MY_LIBRARY/PREVIEW_DATA_FETCHED',
	MY_LIBRARY_PREVIEW_DATA_FETCHED_FAILED: 'MY_LIBRARY/PREVIEW_DATA_FETCHED_FAILED',
	MY_LIBRARY_PREVIEW_EXIT: 'MY_LIBRARY/PREVIEW_EXIT',
	MY_LIBRARY_PREVIEW_INITIALIZE: 'MY_LIBRARY/PREVIEW_INITIALIZE',
	MY_LIBRARY_PREVIEW_LAUNCH_ALL_DEVICES: 'MY_LIBRARY/PREVIEW_LAUNCH_ALL_DEVICES',
	MY_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM: 'MY_LIBRARY/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM',
	MY_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED: 'MY_LIBRARY/PREVIEW_LAUNCH_STUDENT_PACED',
	MY_LIBRARY_PREVIEW_LESSON: 'MY_LIBRARY/PREVIEW_LESSON',
	MY_LIBRARY_PREVIEW_UPDATE: 'MY_LIBRARY/PREVIEW_UPDATE',
	MY_LIBRARY_REMOVE_FOLDER: 'MY_LIBRARY/REMOVE_FOLDER',
	MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER: 'MY_LIBRARY/REMOVE_LESSON_FROM_FOLDER',
	MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CANCELLED: 'MY_LIBRARY/REMOVE_LESSON_FROM_FOLDER_CANCELLED',
	MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_CONFIRMED: 'MY_LIBRARY/REMOVE_LESSON_FROM_FOLDER_CONFIRMED',
	MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_FAILED: 'MY_LIBRARY/REMOVE_LESSON_FROM_FOLDER_FAILED',
	MY_LIBRARY_REMOVE_LESSON_FROM_FOLDER_SUCCESS: 'MY_LIBRARY/REMOVE_LESSON_FROM_FOLDER_SUCCESS',
	MY_LIBRARY_RESUME_ACTIVE_LIVE_SESSION: 'MY_LIBRARY/RESUME_ACTIVE_LIVE_SESSION',
	MY_LIBRARY_ROUTE_FLAGS_UPDATE: 'MY_LIBRARY/ROUTE_FLAGS_UPDATE',
	MY_LIBRARY_ROUTE_UPDATE: 'MY_LIBRARY/ROUTE_UPDATE',
	MY_LIBRARY_SAVE_CHANGES: 'MY_LIBRARY/SAVE_CHANGES',
	MY_LIBRARY_SAVE_CHANGES_FAILED: 'MY_LIBRARY/SAVE_CHANGES_FAILED',
	MY_LIBRARY_SAVE_CHANGES_FETCHED: 'MY_LIBRARY/SAVE_CHANGES_FETCHED',
	MY_LIBRARY_SAVE_LESSON_NOTIFICATION_CLOSE: 'MY_LIBRARY/SAVE_LESSON_NOTIFICATION_CLOSE',
	MY_LIBRARY_SCHOOL_FREE_TRIAL_ONBOARDING_OVERLAY_FAILED: 'MY_LIBRARY/SCHOOL_FREE_TRIAL/ONBOARDING_OVERLAY_FAILED',
	MY_LIBRARY_SCHOOL_FREE_TRIAL_USER_ONBOARDING_OVERLAY_CONFIRM_SUCCESS: 'MY_LIBRARY/SCHOOL_FREE_TRIAL/USER_ONBOARDING_OVERLAY/CONFIRM_SUCCESS',
	MY_LIBRARY_SCHOOL_INVITE_CONFIRM_CLOSE: 'MY_LIBRARY/SCHOOL_INVITE_CONFIRM_CLOSE',
	MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NO: 'MY_LIBRARY/SCHOOL_INVITE_CONFIRM_NO',
	MY_LIBRARY_SCHOOL_INVITE_CONFIRM_NOSLOTS_CLOSE: 'MY_LIBRARY/SCHOOL_INVITE_CONFIRM_NOSLOTS_CLOSE',
	MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES: 'MY_LIBRARY/SCHOOL_INVITE_CONFIRM_YES',
	MY_LIBRARY_SCHOOL_INVITE_CONFIRM_YES_SUCCESS: 'MY_LIBRARY/SCHOOL_INVITE_CONFIRM_YES_SUCCESS',
	MY_LIBRARY_SCHOOL_JOIN_CONFIRM_CLOSE: 'MY_LIBRARY/SCHOOL_JOIN_CONFIRM_CLOSE',
	MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CLOSE: 'MY_LIBRARY/SCHOOL_TRIAL_ONBOARDING_OVERLAY_CLOSE',
	MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM: 'MY_LIBRARY/SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM',
	MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM_SUCCESS: 'MY_LIBRARY/SCHOOL_TRIAL_ONBOARDING_OVERLAY_CONFIRM_SUCCESS',
	MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_DISMISS: 'MY_LIBRARY/SCHOOL_TRIAL_ONBOARDING_OVERLAY_DISMISS',
	MY_LIBRARY_SCHOOL_TRIAL_ONBOARDING_OVERLAY_INITIALIZE: 'MY_LIBRARY/SCHOOL_TRIAL_ONBOARDING_OVERLAY_INITIALIZE',
	MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CLOSE: 'MY_LIBRARY/SCHOOL_USER_ONBOARDING_OVERLAY_CLOSE',
	MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_CONFIRM: 'MY_LIBRARY/SCHOOL_USER_ONBOARDING_OVERLAY_CONFIRM',
	MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_DISMISS: 'MY_LIBRARY/SCHOOL_USER_ONBOARDING_OVERLAY_DISMISS',
	MY_LIBRARY_SCHOOL_USER_ONBOARDING_OVERLAY_INITIALIZE: 'MY_LIBRARY/SCHOOL_USER_ONBOARDING_OVERLAY_INITIALIZE',
	MY_LIBRARY_SEARCH_LESSONS: 'MY_LIBRARY/SEARCH_LESSONS',
	MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE: 'MY_LIBRARY/SESSION_CODE_SAVE_EXPIRATION_DATE',
	MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE_FAILED: 'MY_LIBRARY/SESSION_CODE_SAVE_EXPIRATION_DATE_FAILED',
	MY_LIBRARY_SESSION_CODE_SAVE_EXPIRATION_DATE_SUCCESS: 'MY_LIBRARY/SESSION_CODE_SAVE_EXPIRATION_DATE_SUCCESS',
	MY_LIBRARY_SESSION_FETCHED: 'MY_LIBRARY/SESSION_FETCHED',
	MY_LIBRARY_SESSION_LTI_CANVAS_SAVED: 'MY_LIBRARY/SESSION_LTI_CANVAS_SAVED',
	MY_LIBRARY_SESSION_LTI_CANVAS_SAVED_ERROR: 'MY_LIBRARY_SESSION/LTI_CANVAS_SAVED_ERROR',
	MY_LIBRARY_SESSION_LTI_CANVAS_SAVED_SUCCESS: 'MY_LIBRARY_SESSION/LTI_CANVAS_SAVED_SUCCESS',
	MY_LIBRARY_SESSION_SHARED: 'MY_LIBRARY/SESSION_SHARED',
	MY_LIBRARY_SHARE_ACTIVE_STUDENT_PACED_SESSION: 'MY_LIBRARY/SHARE_ACTIVE_STUDENT_PACED_SESSION',
	MY_LIBRARY_SHARE_FOLDER: 'MY_LIBRARY/SHARE_FOLDER',
	MY_LIBRARY_SHARE_FOLDER_DATA_FAILED: 'MY_LIBRARY/SHARE_FOLDER_DATA_FAILED',
	MY_LIBRARY_SHARE_FOLDER_DATA_LOADED: 'MY_LIBRARY/SHARE_FOLDER_DATA_LOADED',
	MY_LIBRARY_SHARE_LESSON: 'MY_LIBRARY/SHARE_LESSON',
	MY_LIBRARY_STUDENT_PACED_CODES_CLOSED: 'MY_LIBRARY/STUDENT_PACED_CODES_CLOSED',
	MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS: 'MY_LIBRARY/STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS',
	MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_FAILED: 'MY_LIBRARY/STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_FAILED',
	MY_LIBRARY_STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_SUCCESS: 'MY_LIBRARY/STUDENT_PACED_TOGGLE_REQUIRED_SUBMISSIONS_SUCCESS',
	MY_LIBRARY_SUBS_OVERLAY_CLOSED: 'MY_LIBRARY/SUBS_OVERLAY_CLOSED',
	MY_LIBRARY_SUBS_OVERLAY_DISMISS: 'MY_LIBRARY/SUBS_OVERLAY_DISMISS',
	MY_LIBRARY_SUBS_OVERLAY_INITIALIZE: 'MY_LIBRARY/SUBS_OVERLAY_INITIALIZE',
	MY_LIBRARY_SUBS_OVERLAY_LEARN_MORE: 'MY_LIBRARY/SUBS_OVERLAY_LEARN_MORE',
	MY_LIBRARY_TEACH_LESSON_MODAL_CLOSE_SELECTED: 'MY_LIBRARY/TEACH_LESSON_MODAL/CLOSE_SELECTED',
	MY_LIBRARY_TEACH_LESSON_MODAL_LIVE_ACTIVE_CODES_SELECTED: 'MY_LIBRARY/TEACH_LESSON_MODAL/LIVE_ACTIVE_CODES_SELECTED',
	MY_LIBRARY_TEACH_LESSON_MODAL_SETTINGS_SELECTED: 'MY_LIBRARY/TEACH_LESSON_MODAL/SETTINGS_SELECTED',
	MY_LIBRARY_TEACH_LESSON_SELECTED: 'MY_LIBRARY/TEACH_LESSON_SELECTED',
	MY_LIBRARY_TIME_TO_CLIMB_CANCELLED: 'MY_LIBRARY/TIME_TO_CLIMB/CANCELLED',
	MY_LIBRARY_TIME_TO_CLIMB_EXPLORE: 'MY_LIBRARY/TIME_TO_CLIMB/EXPLORE',
	MY_LIBRARY_TIME_TO_CLIMB_SUCCESS: 'MY_LIBRARY/TIME_TO_CLIMB/SUCCESS',
	MY_LIBRARY_VISIT_PRIVATE_LIBRARY: 'MY_LIBRARY/VISIT_PRIVATE_LIBRARY',
	NAVIGATION_MENU_HELP_CONTACT_US_SELECTED: 'NAVIGATION_MENU/HELP/CONTACT_US/SELECTED',
	NAVIGATION_MENU_HELP_HELP_CENTER_SELECTED: 'NAVIGATION_MENU/HELP/HELP_CENTER/SELECTED',
	NAVIGATION_MENU_HELP_INITIALIZE: 'NAVIGATION_MENU/HELP/INITIALIZE',
	NAVIGATION_MENU_HELP_ONBOARDING_GUIDE_SELECTED: 'NAVIGATION_MENU/HELP/ONBOARDING_GUIDE/SELECTED',
	NAVIGATION_MENU_HELP_PERSONALIZED_NEWS_SELECTED: 'NAVIGATION_MENU/HELP/PERSONALIZED_NEWS/SELECTED',
	NAVIGATION_MENU_HELP_TEACHER_RESOURCES_SELECTED: 'NAVIGATION_MENU/HELP/TEACHER_RESOURCES/SELECTED',
	NAVIGATION_MENU_HELP_WHATS_NEW_SELECTED: 'NAVIGATION_MENU/HELP/WHATS_NEW/SELECTED',
	NAVIGATION_MENU_MAIN_ACCOUNT_METRICS_SUCCESS: 'NAVIGATION_MENU/MAIN/ACCOUNT/METRICS_SUCCESS',
	NAVIGATION_MENU_MAIN_ACCOUNT_SELECTED: 'NAVIGATION_MENU/MAIN/ACCOUNT/SELECTED',
	NAVIGATION_MENU_MAIN_LOGOUT_METRICS_SUCCESS: 'NAVIGATION_MENU/MAIN/LOGOUT_METRICS/SUCCESS',
	NAVIGATION_MENU_MAIN_LOGOUT_SELECTED: 'NAVIGATION_MENU/MAIN/LOGOUT_SELECTED',
	NAVIGATION_MENU_MAIN_MANAGE_SELECTED: 'NAVIGATION_MENU/MAIN/MANAGE/SELECTED',
	NAVIGATION_MENU_MAIN_SETTINGS_METRICS_SUCCESS: 'NAVIGATION_MENU/MAIN/SETTINGS/METRICS_SUCCESS',
	NAVIGATION_MENU_MAIN_SETTINGS_SELECTED: 'NAVIGATION_MENU/MAIN/SETTINGS/SELECTED',
	NAVIGATION_MENU_MAIN_UPDATE_PROFILE_IMAGE_SELECTED: 'NAVIGATION_MENU/MAIN/UPDATE_PROFILE_IMAGE/SELECTED',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/EMAIL_NOTIFICATION_ENABLED',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED_FAILED: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/EMAIL_NOTIFICATION_ENABLED/FAILED',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED_SUCCESS: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/EMAIL_NOTIFICATION_ENABLED/SUCCESS',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_FAILED: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/FAILED',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_FETCHED: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/FETCHED',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_INITIALIZE: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/INITIALIZE',
	NAVIGATION_MENU_NOTIFICATION_PREFERENCES_SELECTED: 'NAVIGATION_MENU/NOTIFICATION_PREFERENCES/SELECTED',
	NAVIGATION_MENU_UPGRADE_SELECTED: 'NAVIGATION_MENU/UPGRADE_SELECTED',
	NEARPOD_PICKER_GET_GOOGLE_DRIVE_DOWNLOAD_LINK: 'NEARPOD_PICKER/GET_GOOGLE_DRIVE_DOWNLOAD_LINK',
	NEW_TERMS_AND_CONDITIONS_INITIALIZE: 'NEW_TERMS_AND_CONDITIONS/INITIALIZE',
	NICKEL_TOUR_CLOSE: 'NICKEL_TOUR/CLOSE',
	NICKEL_TOUR_COMPLETED: 'NICKEL_TOUR/COMPLETED',
	NICKEL_TOUR_INITIALIZE: 'NICKEL_TOUR/INITIALIZE',
	NICKEL_TOUR_NOTIFICATION_CLOSE_FAILED: 'NICKEL_TOUR/NOTIFICATION_CLOSE/FAILED',
	NICKEL_TOUR_NOTIFICATION_COMPLETE_FAILED: 'NICKEL_TOUR/NOTIFICATION_COMPLETE/FAILED',
	NOTIFICATION_BUTTON_DISMISS_FAILED: 'NOTIFICATION/BUTTON_DISMISS_FAILED',
	OEQ_ADD_REFERENCE_MEDIA_OPEN_MENU: 'OEQ/ADD_REFERENCE_MEDIA_OPEN_MENU',
	OEQ_ADD_TIMER: 'OEQ/ADD_TIMER',
	OEQ_AUDIO_PLAYER_DELETE_CANCELLED: 'OEQ/AUDIO_PLAYER_DELETE_CANCELLED',
	OEQ_AUDIO_PLAYER_DELETE_CONFIRM: 'OEQ/AUDIO_PLAYER_DELETE_CONFIRM',
	OEQ_AUDIO_PLAYER_DELETE_CONFIRMED: 'OEQ/AUDIO_PLAYER_DELETE_CONFIRMED',
	OEQ_AUDIO_RECORDER_DELETE_CANCELLED: 'OEQ/AUDIO_RECORDER_DELETE_CANCELLED',
	OEQ_AUDIO_RECORDER_DELETE_CONFIRM: 'OEQ/AUDIO_RECORDER_DELETE_CONFIRM',
	OEQ_AUDIO_RECORDER_DELETE_CONFIRMED: 'OEQ/AUDIO_RECORDER_DELETE_CONFIRMED',
	OEQ_AUDIO_RECORDER_SELECTED: 'OEQ/AUDIO_RECORDER_SELECTED',
	OEQ_CANCEL_OEQ: 'OEQ/CANCEL_OEQ',
	OEQ_CANCEL_OEQ_CONFIRM: 'OEQ/CANCEL_OEQ_CONFIRM',
	OEQ_CANCEL_OEQ_CONFIRMED: 'OEQ/CANCEL_OEQ_CONFIRMED',
	OEQ_CANCEL_OEQ_REJECTED: 'OEQ/CANCEL_OEQ_REJECTED',
	OEQ_CANCEL_TIMER: 'OEQ/CANCEL_TIMER',
	OEQ_DELETE_REFERENCE_MEDIA: 'OEQ/DELETE_REFERENCE_MEDIA',
	OEQ_DELETE_TIMER: 'OEQ/DELETE_TIMER',
	OEQ_EDIT_SETTINGS: 'OEQ/EDIT_SETTINGS',
	OEQ_EDIT_TIMER: 'OEQ/EDIT_TIMER',
	OEQ_FINALIZE_CREATION_TOOL: 'OEQ/FINALIZE_CREATION_TOOL',
	OEQ_INITIALIZE_CREATION_TOOL: 'OEQ/INITIALIZE_CREATION_TOOL',
	OEQ_INITIALIZE_ERROR: 'OEQ/INITIALIZE_ERROR',
	OEQ_INITIALIZE_STANDALONE: 'OEQ/INITIALIZE_STANDALONE',
	OEQ_INITIALIZE_SUCCESS: 'OEQ/INITIALIZE_SUCCESS',
	OEQ_NEARPOD_PICKER_CANCEL: 'OEQ/NEARPOD_PICKER_CANCEL',
	OEQ_QUESTION_CHANGE: 'OEQ/QUESTION_CHANGE',
	OEQ_QUESTION_SAVE: 'OEQ/QUESTION_SAVE',
	OEQ_QUESTION_UPDATE_ERROR: 'OEQ/QUESTION_UPDATE_ERROR',
	OEQ_QUESTION_UPDATE_SUCCESS: 'OEQ/QUESTION_UPDATE_SUCCESS',
	OEQ_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN: 'OEQ/REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN',
	OEQ_SAVE_OEQ: 'OEQ/SAVE_OEQ',
	OEQ_SAVE_OEQ_ERROR: 'OEQ/SAVE_OEQ_ERROR',
	OEQ_SAVE_OEQ_SUCCESS: 'OEQ/SAVE_OEQ_SUCCESS',
	OEQ_SAVE_TIMER: 'OEQ/SAVE_TIMER',
	OEQ_SCREENSHOT_INITIALIZE_ROUTE: 'OEQ/SCREENSHOT_INITIALIZE_ROUTE',
	OEQ_STUDENT_RECORDING_TOGGLE: 'OEQ/TOGGLE_STUDENT_RECORDING',
	OEQ_TIMER_SAVE_ERROR: 'OEQ/TIMER_SAVE_ERROR',
	OEQ_TIMER_SAVE_SUCCESS: 'OEQ/TIMER_SAVE_SUCCESS',
	OEQ_UPLOAD_REFERENCE_MEDIA: 'OEQ/UPLOAD_REFERENCE_MEDIA',
	OEQ_UPLOAD_REFERENCE_MEDIA_ERROR: 'OEQ/UPLOAD_REFERENCE_MEDIA_ERROR',
	OEQ_UPLOAD_REQUIRE_CONFIRMATION: 'OEQ/UPLOAD_REQUIRE_CONFIRMATION',
	OEQ_UPLOADER_UPLOAD_ERROR: 'OEQ/UPLOADER_UPLOAD_ERROR',
	OEQ_UPLOADER_UPLOAD_SUCCESS: 'OEQ/UPLOADER_UPLOAD_SUCCESS',
	OEQ_UPLOADER_VALIDATE_CONTENT_ERROR: 'OEQ/UPLOADER_VALIDATE_CONTENT_ERROR',
	OEQ_UPLOADER_VALIDATE_ERROR: 'OEQ/UPLOADER_VALIDATE_ERROR',
	OEQ_UPLOADER_VALIDATE_SUCCESS: 'OEQ/UPLOADER_VALIDATE_SUCCESS',
	OEQ_VALIDATION_ERROR: 'OEQ/VALIDATION_ERROR',
	OEQ_VALIDATION_SUCCESS: 'OEQ/VALIDATION_SUCCESS',
	ONBOARDING_ACTIVITY_ADD_ACTIVITY: 'ONBOARDING_ACTIVITY/ADD_ACTIVITY',
	ONBOARDING_ACTIVITY_ADD_ACTIVITY_CANCELLED: 'ONBOARDING_ACTIVITY/ADD_ACTIVITY/CANCELLED',
	ONBOARDING_ACTIVITY_ADD_ACTIVITY_FAILED: 'ONBOARDING_ACTIVITY/ADD_ACTIVITY/FAILED',
	ONBOARDING_ACTIVITY_ADD_ACTIVITY_SUCCESS: 'ONBOARDING_ACTIVITY/ADD_ACTIVITY/SUCCESS',
	ONBOARDING_ACTIVITY_CREATE_INITIALIZE: 'ONBOARDING_ACTIVITY/CREATE/INITIALIZE',
	ONBOARDING_ACTIVITY_CREATE_LESSON_FAILED: 'ONBOARDING_ACTIVITY/CREATE_LESSON/FAILED',
	ONBOARDING_ACTIVITY_CREATE_LESSON_SUCCESS: 'ONBOARDING_ACTIVITY/CREATE_LESSON/SUCCESS',
	ONBOARDING_ACTIVITY_DEMO_CARD_POSTED: 'ONBOARDING_ACTIVITY/DEMO/CARD_POSTED',
	ONBOARDING_ACTIVITY_DEMO_COMPLETED: 'ONBOARDING_ACTIVITY/DEMO/COMPLETED',
	ONBOARDING_ACTIVITY_DEMO_INITIALIZE: 'ONBOARDING_ACTIVITY/DEMO/INITIALIZE',
	ONBOARDING_ACTIVITY_EXPLAINER_COMPLETED: 'ONBOARDING_ACTIVITY/EXPLAINER/COMPLETED',
	ONBOARDING_ACTIVITY_EXPLAINER_INITIALIZE: 'ONBOARDING_ACTIVITY/EXPLAINER/INITIALIZE',
	ONBOARDING_ACTIVITY_TRANSITION_ANIMATION_COMPLETED: 'ONBOARDING_ACTIVITY/TRANSITION/ANIMATION_COMPLETED',
	ONBOARDING_ADD_TO_LIBRARY: 'ONBOARDING/ADD_TO_LIBRARY',
	ONBOARDING_CHANGE_STEP: 'ONBOARDING/CHANGE_STEP',
	ONBOARDING_GET_LESSONS: 'ONBOARDING/GET_LESSONS',
	ONBOARDING_GRADES_SAVED: 'ONBOARDING/GRADES_SAVED',
	ONBOARDING_GRADES_UPDATED: 'ONBOARDING/GRADES_UPDATED',
	ONBOARDING_GUIDE_DATA_FAILED: 'ONBOARDING_GUIDE/DATA_FAILED',
	ONBOARDING_GUIDE_DATA_FETCHED: 'ONBOARDING_GUIDE/DATA_FETCHED',
	ONBOARDING_GUIDE_DISMISS_CANCELLED: 'ONBOARDING_GUIDE/DISMISS_CANCELLED',
	ONBOARDING_GUIDE_DISMISS_CONFIRM: 'ONBOARDING_GUIDE/DISMISS_CONFIRM',
	ONBOARDING_GUIDE_DISMISS_CONFIRMED: 'ONBOARDING_GUIDE/DISMISS_CONFIRMED',
	ONBOARDING_GUIDE_ENABLED: 'ONBOARDING_GUIDE/ENABLED',
	ONBOARDING_GUIDE_EXPLORE_LESSONS_CARD_SELECTED: 'ONBOARDING_GUIDE/EXPLORE_LESSONS_CARD_SELECTED',
	ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SELECTED: 'ONBOARDING_GUIDE/LAUNCH_TOUR_CARD_SELECTED',
	ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SUCCESS: 'ONBOARDING_GUIDE/LAUNCH_TOUR_CARD_SUCCESS',
	ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SELECTED: 'ONBOARDING_GUIDE/LESSON_BUILDER_CARD_SELECTED',
	ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SUCCESS: 'ONBOARDING_GUIDE/LESSON_BUILDER_CARD_SUCCESS',
	ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_FAILED: 'ONBOARDING_GUIDE/SESSION_PREVIEW_CARD_FAILED',
	ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SELECTED: 'ONBOARDING_GUIDE/SESSION_PREVIEW_CARD_SELECTED',
	ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SUCCESS: 'ONBOARDING_GUIDE/SESSION_PREVIEW_CARD_SUCCESS',
	ONBOARDING_INITIALIZE: 'ONBOARDING/INITIALIZE',
	ONBOARDING_LESSON_ACTIVATED: 'ONBOARDING/LESSON_ACTIVATED',
	ONBOARDING_LESSON_ASSET_LOADED: 'ONBOARDING/LESSON_ASSET_LOADED',
	ONBOARDING_LESSON_SELECTED: 'ONBOARDING/LESSON_SELECTED',
	ONBOARDING_LOADING_COMPLETE: 'ONBOARDING/LOADING_COMPLETE',
	ONBOARDING_LOOP_COMPLETE: 'ONBOARDING/LOOP_COMPLETE',
	ONBOARDING_NAVIGATE_TO_STEP: 'ONBOARDING/NAVIGATE_TO_STEP',
	ONBOARDING_PREVIEW_CLOSE: 'ONBOARDING/PREVIEW_CLOSE',
	ONBOARDING_PREVIEW_SELECTED: 'ONBOARDING/PREVIEW_SELECTED',
	ONBOARDING_RESET_STEP_TRANSITION: 'ONBOARDING/RESET_STEP_TRANSITION',
	ONBOARDING_SAVE_GRADES: 'ONBOARDING/SAVE_GRADES',
	ONBOARDING_SAVE_INTERESTS: 'ONBOARDING/SAVE_INTERESTS',
	ONBOARDING_SAVE_SUBJECTS: 'ONBOARDING/SAVE_SUBJECTS',
	ONBOARDING_SAVE_TECHNOLOGY: 'ONBOARDING/SAVE_TECHNOLOGY',
	ONBOARDING_SELECT_INTERESTS: 'ONBOARDING/SELECT_INTERESTS',
	ONBOARDING_SELECT_TECHNOLOGY: 'ONBOARDING/SELECT_TECHNOLOGY',
	ONBOARDING_SKIP: 'ONBOARDING/SKIP',
	ONBOARDING_SKIP_MIXPANEL_CALLBACK: 'ONBOARDING/SKIP_MIXPANEL_CALLBACK',
	ONBOARDING_SKIP_REDIRECT: 'ONBOARDING/SKIP_REDIRECT',
	ONBOARDING_SUBJECTS_SAVED: 'ONBOARDING/SUBJECTS_SAVED',
	ONBOARDING_SUBJECTS_UPDATED: 'ONBOARDING/SUBJECTS_UPDATED',
	ONBOARDING_SUGGESTED_CATEGORIES_FETCHED: 'ONBOARDING/SUGGESTED_CATEGORIES_FETCHED',
	ONBOARDING_SUGGESTED_LESSONS_FETCHED: 'ONBOARDING/SUGGESTED_LESSONS_FETCHED',
	ONBOARDING_TRANSITION_STEP: 'ONBOARDING/TRANSITION_STEP',
	OPEN_ALERT: 'OPEN_ALERT',
	OPEN_CENTER_INFORMATION: 'OPEN_CENTER_INFORMATION',
	OPEN_CONFIRM: 'OPEN_CONFIRM',
	OPEN_MODAL: 'OPEN_MODAL',
	OPEN_REFERENCE_MEDIA: 'OPEN_REFERENCE_MEDIA',
	OPEN_TOP_INFORMATION: 'OPEN_TOP_INFORMATION',
	OVERLAY_BUTTON_CONFIRM_FAILED: 'OVERLAY/BUTTON_CONFIRM_FAILED',
	OVERLAY_BUTTON_CONFIRM_SUCCESS: 'OVERLAY/BUTTON_CONFIRM_SUCCESS',
	OVERLAY_DISTRICT_LIBRARY_ONBOARDING_CONFIRM: 'OVERLAY_DISTRICT_LIBRARY_ONBOARDING/CONFIRM',
	OVERLAY_DISTRICT_LIBRARY_ONBOARDING_INITIALIZE: 'OVERLAY_DISTRICT_LIBRARY_ONBOARDING/INITIALIZE',
	OVERLAY_SCHOOL_LIBRARY_ONBOARDING_CONFIRM: 'OVERLAY_SCHOOL_LIBRARY_ONBOARDING/CONFIRM',
	OVERLAY_SCHOOL_LIBRARY_ONBOARDING_INITIALIZE: 'OVERLAY_SCHOOL_LIBRARY_ONBOARDING/INITIALIZE',
	PAYWALLS_ADDON_GOOGLE_SLIDES_UPGRADE: 'PAYWALLS/ADDON_GOOGLE_SLIDES_UPGRADE',
	PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED: 'PAYWALLS/CREATE_GOOGLE_SLIDES_UNAUTHORIZED',
	PAYWALLS_CREATE_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE: 'PAYWALLS/CREATE_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE',
	PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED: 'PAYWALLS/EDIT_GOOGLE_SLIDES_UNAUTHORIZED',
	PAYWALLS_EDIT_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE: 'PAYWALLS/EDIT_GOOGLE_SLIDES_UNAUTHORIZED_CLOSE',
	PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_CLOSE_SELECTED: 'PAYWALLS/NOT_ENOUGH_SPACE_CONFIRM/CLOSE_SELECTED',
	PAYWALLS_NOT_ENOUGH_SPACE_CONFIRM_UPGRADE_SELECTED: 'PAYWALLS/NOT_ENOUGH_SPACE_CONFIRM/UPGRADE_SELECTED',
	PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_ACCEPT_SELECTED: 'PAYWALLS/PRESENTATION_SIZE_EXCEEDED_CONFIRM/ACCEPT_SELECTED',
	PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_CLOSE_SELECTED: 'PAYWALLS/PRESENTATION_SIZE_EXCEEDED_CONFIRM/CLOSE_SELECTED',
	PAYWALLS_PRESENTATION_SIZE_EXCEEDED_CONFIRM_UPGRADE_SELECTED: 'PAYWALLS/PRESENTATION_SIZE_EXCEEDED_CONFIRM/UPGRADE_SELECTED',
	PICKER_APPLY_SEARCH_QUERY: 'PICKER/APPLY_SEARCH_QUERY',
	PICKER_END: 'PICKER/END',
	PICKER_LESSON_TOGGLE: 'PICKER/LESSON_TOGGLE',
	PICKER_RESET_SEARCH: 'PICKER/RESET_SEARCH',
	PICKER_TOGGLE_SHOW_ALL: 'PICKER/TOGGLE_SHOW_ALL',
	PICKER_UPDATE_SEARCH_QUERY: 'PICKER/UPDATE_SEARCH_QUERY',
	PICKER_UPDATE_SORT: 'PICKER/UPDATE_SORT',
	PLAYGROUND_NEARPOD_PICKER_CANCEL: 'PLAYGROUND/NEARPOD_PICKER_CANCEL',
	PLAYGROUND_NEARPOD_PICKER_FILE_ERROR: 'PLAYGROUND/NEARPOD_PICKER_FILE_ERROR',
	PLAYGROUND_NEARPOD_PICKER_MODAL_OPEN: 'PLAYGROUND/NEARPOD_PICKER_MODAL_OPEN',
	PLAYGROUND_NEARPOD_PICKER_PICK: 'PLAYGROUND/NEARPOD_PICKER_PICK',
	POLL_ADD_ANSWER: 'POLL/ADD_ANSWER',
	POLL_ADD_ANSWER_VALIDATION_ERROR: 'POLL/ADD_ANSWER_VALIDATION_ERROR',
	POLL_ADD_ANSWER_VALIDATION_SUCCESS: 'POLL/ADD_ANSWER_VALIDATION_SUCCESS',
	POLL_ADD_REFERENCE_MEDIA_OPEN_MENU: 'POLL/ADD_REFERENCE_MEDIA_OPEN_MENU',
	POLL_ADD_TIMER: 'POLL/ADD_TIMER',
	POLL_ANSWER_CHANGE: 'POLL/ANSWER_CHANGE',
	POLL_ANSWER_FOCUS: 'POLL/ANSWER_FOCUS',
	POLL_ANSWER_SAVE: 'POLL/ANSWER_SAVE',
	POLL_CANCEL_POLL: 'POLL/CANCEL_POLL',
	POLL_CANCEL_POLL_CONFIRM: 'POLL/CANCEL_POLL_CONFIRM',
	POLL_CANCEL_POLL_CONFIRMED: 'POLL/CANCEL_POLL_CONFIRMED',
	POLL_CANCEL_POLL_REJECTED: 'POLL/CANCEL_POLL_REJECTED',
	POLL_CANCEL_TIMER: 'POLL/CANCEL_TIMER',
	POLL_DELETE_ANSWER: 'POLL/DELETE_ANSWER',
	POLL_DELETE_ANSWER_VALIDATION_ERROR: 'POLL/DELETE_ANSWER_VALIDATION_ERROR',
	POLL_DELETE_ANSWER_VALIDATION_SUCCESS: 'POLL/DELETE_ANSWER_VALIDATION_SUCCESS',
	POLL_DELETE_QUESTION_SUCCESS: 'POLL/DELETE_QUESTION_SUCCESS',
	POLL_DELETE_REFERENCE_MEDIA: 'POLL/DELETE_REFERENCE_MEDIA',
	POLL_DELETE_REFERENCE_MEDIA_SUCCESS: 'POLL/DELETE_REFERENCE_MEDIA_SUCCESS',
	POLL_DELETE_TIMER: 'POLL/DELETE_TIMER',
	POLL_DRAG_ANSWER: 'POLL/DRAG_ANSWER',
	POLL_DROP_ANSWER: 'POLL/DROP_ANSWER',
	POLL_EDIT_SETTINGS: 'POLL/EDIT_SETTINGS',
	POLL_EDIT_TIMER: 'POLL/EDIT_TIMER',
	POLL_FINALIZE_CREATION_TOOL: 'POLL/FINALIZE_CREATION_TOOL',
	POLL_INITIALIZE_CREATION_TOOL: 'POLL/INITIALIZE_CREATION_TOOL',
	POLL_INITIALIZE_ERROR: 'POLL/INITIALIZE_ERROR',
	POLL_INITIALIZE_STANDALONE: 'POLL/INITIALIZE_STANDALONE',
	POLL_INITIALIZE_SUCCESS: 'POLL/INITIALIZE_SUCCESS',
	POLL_NEARPOD_PICKER_CANCEL: 'POLL/NEARPOD_PICKER_CANCEL',
	POLL_QUESTION_CHANGE: 'POLL/QUESTION_CHANGE',
	POLL_QUESTION_DUPLICATE_AND_DELETE: 'POLL/QUESTION_DUPLICATE_AND_DELETE',
	POLL_QUESTION_FOCUS: 'POLL/QUESTION_FOCUS',
	POLL_QUESTION_SAVE: 'POLL/QUESTION_SAVE',
	POLL_QUESTION_SAVE_ERROR: 'POLL/QUESTION_SAVE_ERROR',
	POLL_QUESTION_SAVE_SUCCESS: 'POLL/QUESTION_SAVE_SUCCESS',
	POLL_QUESTION_UPDATE_ERROR: 'POLL/QUESTION_UPDATE_ERROR',
	POLL_QUESTION_UPDATE_SUCCESS: 'POLL/QUESTION_UPDATE_SUCCESS',
	POLL_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN: 'POLL/REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN',
	POLL_SAVE_POLL: 'POLL/SAVE_POLL',
	POLL_SAVE_POLL_ERROR: 'POLL/SAVE_POLL_ERROR',
	POLL_SAVE_POLL_SUCCESS: 'POLL/SAVE_POLL_SUCCESS',
	POLL_SAVE_SETTINGS: 'POLL/SAVE_SETTINGS',
	POLL_SAVE_SETTINGS_ERROR: 'POLL/SAVE_SETTINGS_ERROR',
	POLL_SAVE_SETTINGS_SUCCESS: 'POLL/SAVE_SETTINGS_SUCCESS',
	POLL_SAVE_TIMER: 'POLL/SAVE_TIMER',
	POLL_SCREENSHOT_INITIALIZE_ROUTE: 'POLL/SCREENSHOT_INITIALIZE_ROUTE',
	POLL_TIMER_SAVE_ERROR: 'POLL/TIMER_SAVE_ERROR',
	POLL_TIMER_SAVE_SUCCESS: 'POLL/TIMER_SAVE_SUCCESS',
	POLL_UPLOAD_REFERENCE_MEDIA: 'POLL/UPLOAD_REFERENCE_MEDIA',
	POLL_UPLOAD_REFERENCE_MEDIA_ERROR: 'POLL/UPLOAD_REFERENCE_MEDIA_ERROR',
	POLL_UPLOAD_REQUIRE_CONFIRMATION: 'POLL/UPLOAD_REQUIRE_CONFIRMATION',
	POLL_UPLOADER_PROCESSING_ERROR: 'POLL/UPLOADER_PROCESSING_ERROR',
	POLL_UPLOADER_UPLOAD_ERROR: 'POLL/UPLOADER_UPLOAD_ERROR',
	POLL_UPLOADER_UPLOAD_SUCCESS: 'POLL/UPLOADER_UPLOAD_SUCCESS',
	POLL_UPLOADER_VALIDATE_CONTENT_ERROR: 'POLL/UPLOADER_VALIDATE_CONTENT_ERROR',
	POLL_UPLOADER_VALIDATE_ERROR: 'POLL/UPLOADER_VALIDATE_ERROR',
	POLL_UPLOADER_VALIDATE_SUCCESS: 'POLL/UPLOADER_VALIDATE_SUCCESS',
	POLL_VALIDATION_ERROR: 'POLL/VALIDATION_ERROR',
	POLL_VALIDATION_SUCCESS: 'POLL/VALIDATION_SUCCESS',
	PREVIEW_TOGGLE_FULL_LESSONS: 'PREVIEW/TOGGLE_FULL_LESSONS',
	PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY: 'PRIVATE_LIBRARY/ADD_TO_PRIVATE_LIBRARY',
	PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_ERROR: 'PRIVATE_LIBRARY/ADD_TO_PRIVATE_LIBRARY_ERROR',
	PRIVATE_LIBRARY_ADD_TO_PRIVATE_LIBRARY_REDIRECT: 'PRIVATE_LIBRARY/ADD_TO_PRIVATE_LIBRARY_REDIRECT',
	PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_CLICK: 'PRIVATE_LIBRARY/CHANGE_FOLDER_COLOR_CLICK',
	PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_ERROR: 'PRIVATE_LIBRARY/CHANGE_FOLDER_COLOR_ERROR',
	PRIVATE_LIBRARY_CHANGE_FOLDER_COLOR_SUCCESS: 'PRIVATE_LIBRARY/CHANGE_FOLDER_COLOR_SUCCESS',
	PRIVATE_LIBRARY_CURRENT_APPLY_REDIRECT_SEARCH: 'PRIVATE_LIBRARY/CURRENT_APPLY_REDIRECT_SEARCH',
	PRIVATE_LIBRARY_CURRENT_APPLY_SEARCH: 'PRIVATE_LIBRARY/CURRENT/APPLY_SEARCH',
	PRIVATE_LIBRARY_CURRENT_CLEAR_SEARCH: 'PRIVATE_LIBRARY/CURRENT/CLEAR_SEARCH',
	PRIVATE_LIBRARY_CURRENT_SEARCH_INPUT_CHANGE: 'PRIVATE_LIBRARY/CURRENT/SEARCH_INPUT_CHANGE',
	PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTERS_MODAL: 'PRIVATE_LIBRARY/CURRENT/TOGGLE_FILTERS_MODAL',
	PRIVATE_LIBRARY_CURRENT_TOGGLE_FILTER_SELECTION: 'PRIVATE_LIBRARY/CURRENT/TOGGLE_FILTER_SELECTION',
	PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_CANCEL: 'PRIVATE_LIBRARY/DELETE_CURRENT_FOLDER_CANCEL',
	PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_CONFIRM: 'PRIVATE_LIBRARY/DELETE_CURRENT_FOLDER_CONFIRM',
	PRIVATE_LIBRARY_DELETE_CURRENT_FOLDER_SUCCESS: 'PRIVATE_LIBRARY/DELETE_CURRENT_FOLDER_SUCCESS',
	PRIVATE_LIBRARY_DELETE_LESSON: 'PRIVATE_LIBRARY/DELETE_LESSON',
	PRIVATE_LIBRARY_DELETE_LESSON_CANCELLED: 'PRIVATE_LIBRARY/DELETE_LESSON_CANCELLED',
	PRIVATE_LIBRARY_DELETE_LESSON_CONFIRM: 'PRIVATE_LIBRARY/DELETE_LESSON_CONFIRM',
	PRIVATE_LIBRARY_DELETE_LESSON_CONFIRMED: 'PRIVATE_LIBRARY/DELETE_LESSON_CONFIRMED',
	PRIVATE_LIBRARY_DELETE_LESSON_ERROR: 'PRIVATE_LIBRARY/DELETE_LESSON_ERROR',
	PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CANCELLED: 'PRIVATE_LIBRARY/DELETE_LESSON_MULTIPLE_SCHOOLS_CANCELLED',
	PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CONFIRM: 'PRIVATE_LIBRARY/DELETE_MULTIPLE_SCHOOLS_LESSON_CONFIRM',
	PRIVATE_LIBRARY_DELETE_LESSON_MULTIPLE_SCHOOLS_CONFIRMED: 'PRIVATE_LIBRARY/DELETE_MULTIPLE_SCHOOLS_LESSON_CONFIRMED',
	PRIVATE_LIBRARY_DELETE_LESSON_SUCCESS: 'PRIVATE_LIBRARY/DELETE_LESSON_SUCCESS',
	PRIVATE_LIBRARY_EDIT_SETTINGS: 'PRIVATE_LIBRARY/EDIT_SETTINGS',
	PRIVATE_LIBRARY_FILTER_DEFINITIONS_FETCHED: 'PRIVATE_LIBRARY/FILTER_DEFINITIONS_FETCHED',
	PRIVATE_LIBRARY_FINALIZE: 'PRIVATE_LIBRARY/FINALIZE',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CANCELLED: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_CANCELLED',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CONFIRM: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_CONFIRM',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_CONFIRMED: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_CONFIRMED',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_GET_METRICS: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_GET_METRICS',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CANCELLED: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_MULTIPLE_SCHOOLS_CANCELLED',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_CONFIRMED: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_MUTIPLE_SCHOOLS_CONFIRMED',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MULTIPLE_SCHOOLS_DENIED: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_MULTIPLE_SCHOOLS_DENIED',
	PRIVATE_LIBRARY_FIND_LESSONS_ADD_LESSONS_MUTIPLE_SCHOOLS_CONFIRM: 'PRIVATE_LIBRARY/FIND_LESSONS/ADD_LESSONS_MUTIPLE_SCHOOLS_CONFIRM',
	PRIVATE_LIBRARY_FIND_LESSONS_APPLY_SEARCH: 'PRIVATE_LIBRARY/FIND_LESSONS/APPLY_SEARCH',
	PRIVATE_LIBRARY_FIND_LESSONS_CLEAR_SEARCH: 'PRIVATE_LIBRARY/FIND_LESSONS/CLEAR_SEARCH',
	PRIVATE_LIBRARY_FIND_LESSONS_ENTITIES_SAVED: 'PRIVATE_LIBRARY/FIND_LESSONS/ENTITIES_SAVED',
	PRIVATE_LIBRARY_FIND_LESSONS_MODAL_CLOSE: 'PRIVATE_LIBRARY/FIND_LESSONS_MODAL_CLOSE',
	PRIVATE_LIBRARY_FIND_LESSONS_MODAL_OPEN: 'PRIVATE_LIBRARY/FIND_LESSONS_MODAL_OPEN',
	PRIVATE_LIBRARY_FIND_LESSONS_PREVIEW: 'PRIVATE_LIBRARY/FIND_LESSONS_PREVIEW',
	PRIVATE_LIBRARY_FIND_LESSONS_SEARCH_INPUT_CHANGE: 'PRIVATE_LIBRARY/FIND_LESSONS/SEARCH_INPUT_CHANGE',
	PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTERS_MODAL: 'PRIVATE_LIBRARY/FIND_LESSONS/TOGGLE_FILTERS_MODAL',
	PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_FILTER_SELECTION: 'PRIVATE_LIBRARY/FIND_LESSONS/TOGGLE_FILTER_SELECTION',
	PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SELECT_ALL: 'PRIVATE_LIBRARY/FIND_LESSONS/TOGGLE_SELECT_ALL',
	PRIVATE_LIBRARY_FIND_LESSONS_TOGGLE_SHOW_SELECTED: 'PRIVATE_LIBRARY/FIND_LESSONS/TOGGLE_SHOW_SELECTED',
	PRIVATE_LIBRARY_FOCUS_FILTERS: 'PRIVATE_LIBRARY/FOCUS_FILTERS',
	PRIVATE_LIBRARY_FOCUS_FILTERS_CLEAR: 'PRIVATE_LIBRARY/FOCUS_FILTERS_CLEAR',
	PRIVATE_LIBRARY_FOLDER_ADD_LESSON: 'PRIVATE_LIBRARY/FOLDER_ADD_LESSON',
	PRIVATE_LIBRARY_FOLDER_ADD_LESSON_CANCEL: 'PRIVATE_LIBRARY/FOLDER_ADD_LESSON_CANCEL',
	PRIVATE_LIBRARY_FOLDER_ADD_LESSON_SUCCESS: 'PRIVATE_LIBRARY/FOLDER_ADD_LESSON_SUCCESS',
	PRIVATE_LIBRARY_FOLDER_MOVE_FOLDER_SUCCESS: 'PRIVATE_LIBRARY/FOLDER_MOVE_FOLDER_SUCCESS',
	PRIVATE_LIBRARY_FOLDER_MOVE_LESSON_SUCCESS: 'PRIVATE_LIBRARY/FOLDER_MOVE_LESSON_SUCCESS',
	PRIVATE_LIBRARY_FOLDER_PROMPT_ADD_LESSON: 'PRIVATE_LIBRARY/FOLDER_PROMPT_ADD_LESSON',
	PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON: 'PRIVATE_LIBRARY/FOLDER_REMOVE_LESSON',
	PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON_ERROR: 'PRIVATE_LIBRARY/FOLDER_REMOVE_LESSON_ERROR',
	PRIVATE_LIBRARY_FOLDER_REMOVE_LESSON_SUCCESS: 'PRIVATE_LIBRARY/FOLDER_REMOVE_LESSON_SUCCESS',
	PRIVATE_LIBRARY_FOLDER_SELECTED: 'PRIVATE_LIBRARY/FOLDER_SELECTED',
	PRIVATE_LIBRARY_FOLDERS_FETCH_FAILED: 'PRIVATE_LIBRARY/FOLDERS_FETCH_FAILED',
	PRIVATE_LIBRARY_FOLDERS_FETCH_SUCCESS: 'PRIVATE_LIBRARY/FOLDERS_FETCH_SUCCESS',
	PRIVATE_LIBRARY_FOUND_LIBRARY_LESSONS: 'PRIVATE_LIBRARY/FOUND_LIBRARY_LESSONS',
	PRIVATE_LIBRARY_GET_FILTER_DEFINITIONS: 'PRIVATE_LIBRARY/GET_FILTER_DEFINITIONS',
	PRIVATE_LIBRARY_GET_LESSONS: 'PRIVATE_LIBRARY/GET_LESSONS',
	PRIVATE_LIBRARY_INITIALIZE_CONTENT_PACKAGE: 'PRIVATE_LIBRARY/INITIALIZE_CONTENT_PACKAGE',
	PRIVATE_LIBRARY_INITIALIZE_FOLDER: 'PRIVATE_LIBRARY/INITIALIZE_FOLDER',
	PRIVATE_LIBRARY_INITIALIZE_LIBRARY_BASE: 'PRIVATE_LIBRARY/INITIALIZE_LIBRARY_BASE',
	PRIVATE_LIBRARY_INITIALIZE_PREVIEW: 'PRIVATE_LIBRARY/INITIALIZE_PREVIEW',
	PRIVATE_LIBRARY_INITIALIZE_VIDEO_PREVIEW: 'PRIVATE_LIBRARY/INITIALIZE_VIDEO_PREVIEW',
	PRIVATE_LIBRARY_LAUNCH_VIDEO_PREVIEW: 'PRIVATE_LIBRARY/LAUNCH_VIDEO_PREVIEW',
	PRIVATE_LIBRARY_PREVIEW_LAUNCH_ALL_DEVICES: 'PRIVATE_LIBRARY/PREVIEW_LAUNCH_ALL_DEVICES',
	PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM: 'PRIVATE_LIBRARY/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM',
	PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED: 'PRIVATE_LIBRARY/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED',
	PRIVATE_LIBRARY_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED: 'PRIVATE_LIBRARY/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED',
	PRIVATE_LIBRARY_PREVIEW_LAUNCH_STUDENT_PACED: 'PRIVATE_LIBRARY/PREVIEW_LAUNCH_STUDENT_PACED',
	PRIVATE_LIBRARY_LEARN_MORE_PACKAGES: 'PRIVATE_LIBRARY/LEARN_MORE_PACKAGES',
	PRIVATE_LIBRARY_LESSON_ALREADY_ADDED: 'PRIVATE_LIBRARY/LESSON_ALREADY_ADDED',
	PRIVATE_LIBRARY_LESSONS_ACCESS_DENIED: 'PRIVATE_LIBRARY/LESSONS_ACCESS_DENIED',
	PRIVATE_LIBRARY_LESSONS_FETCHED: 'PRIVATE_LIBRARY/LESSONS_FETCHED',
	PRIVATE_LIBRARY_LESSONS_FILTERS_UPDATE: 'PRIVATE_LIBRARY/LESSONS_FILTERS_UPDATE',
	PRIVATE_LIBRARY_LESSONS_NEXT_PAGE: 'PRIVATE_LIBRARY/LESSONS_NEXT_PAGE',
	PRIVATE_LIBRARY_LESSONS_PICKER_ADD_ERROR: 'PRIVATE_LIBRARY/LESSONS_PICKER/ADD_ERROR',
	PRIVATE_LIBRARY_LESSONS_PICKER_ADD_SUCCESS: 'PRIVATE_LIBRARY/LESSONS_PICKER/ADD_SUCCESS',
	PRIVATE_LIBRARY_LESSONS_PICKER_CANCEL: 'PRIVATE_LIBRARY/LESSONS_PICKER/CANCEL',
	PRIVATE_LIBRARY_LESSONS_PICKER_INIT: 'PRIVATE_LIBRARY/LESSONS_PICKER/INIT',
	PRIVATE_LIBRARY_LESSONS_PICKER_SAVE_LESSONS: 'PRIVATE_LIBRARY/LESSONS_PICKER/SAVE_LESSONS',
	PRIVATE_LIBRARY_LESSONS_PICKER_SEARCH_LESSONS: 'PRIVATE_LIBRARY/LESSONS_PICKER/SEARCH_LESSONS',
	PRIVATE_LIBRARY_LESSONS_SORT_UPDATE: 'PRIVATE_LIBRARY/LESSONS_SORT_UPDATE',
	PRIVATE_LIBRARY_MANAGE_LIBRARY_REDIRECT: 'PRIVATE_LIBRARY/MANAGE_LIBRARY_REDIRECT',
	PRIVATE_LIBRARY_MOVE_ERROR: 'PRIVATE_LIBRARY/MOVE_ERROR',
	PRIVATE_LIBRARY_MOVE_FOLDER_RELEASE: 'PRIVATE_LIBRARY/MOVE_FOLDER_RELEASE',
	PRIVATE_LIBRARY_MOVE_LESSON_RELEASE: 'PRIVATE_LIBRARY/MOVE_LESSON_RELEASE',
	PRIVATE_LIBRARY_NAME_FOLDER_CANCEL: 'PRIVATE_LIBRARY/NAME_FOLDER/CANCEL',
	PRIVATE_LIBRARY_NAME_FOLDER_ERROR: 'PRIVATE_LIBRARY/NAME_FOLDER/ERROR',
	PRIVATE_LIBRARY_NAME_FOLDER_INPUT_CHANGE: 'PRIVATE_LIBRARY/NAME_FOLDER/INPUT_CHANGE',
	PRIVATE_LIBRARY_NAME_FOLDER_SUBMIT: 'PRIVATE_LIBRARY/NAME_FOLDER/SUBMIT',
	PRIVATE_LIBRARY_NAME_FOLDER_SUCCESS: 'PRIVATE_LIBRARY/NAME_FOLDER/SUCCESS',
	PRIVATE_LIBRARY_OPEN_ADD_LESSONS_TO_FOLDER: 'PRIVATE_LIBRARY/OPEN_ADD_LESSONS_TO_FOLDER',
	PRIVATE_LIBRARY_OPEN_DELETE_CURRENT_FOLDER_CONFIRM: 'PRIVATE_LIBRARY/OPEN_DELETE_CURRENT_FOLDER_CONFIRM',
	PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL: 'PRIVATE_LIBRARY/OPEN_NEW_FOLDER_MODAL',
	PRIVATE_LIBRARY_OPEN_NEW_FOLDER_MODAL_WITH_ENTITY: 'PRIVATE_LIBRARY/OPEN_NEW_FOLDER_MODAL_WITH_ENTITY',
	PRIVATE_LIBRARY_OPEN_RENAME_FOLDER_MODAL: 'PRIVATE_LIBRARY/OPEN_RENAME_FOLDER_MODAL',
	PRIVATE_LIBRARY_PRESERVE_LIBRARY_SEARCH: 'PRIVATE_LIBRARY/PRESERVE_LIBRARY_SEARCH',
	PRIVATE_LIBRARY_PREVIEW_FETCHED: 'PRIVATE_LIBRARY/PREVIEW_FETCHED',
	PRIVATE_LIBRARY_PREVIEW_INITIALIZE_ERROR: 'PRIVATE_LIBRARY/PREVIEW_INITIALIZE_ERROR',
	PRIVATE_LIBRARY_PREVIEW_UNMOUNT: 'PRIVATE_LIBRARY/PREVIEW_UNMOUNT',
	PRIVATE_LIBRARY_REDIRECT_TO_LIBRARY: 'PRIVATE_LIBRARY/REDIRECT_TO_LIBRARY',
	PRIVATE_LIBRARY_SEARCH_FETCHED: 'PRIVATE_LIBRARY/SEARCH_FETCHED',
	PRIVATE_LIBRARY_SEARCH_FILTERS_UPDATE: 'PRIVATE_LIBRARY/SEARCH_FILTERS_UPDATE',
	PRIVATE_LIBRARY_SEARCH_NEXT_PAGE: 'PRIVATE_LIBRARY/SEARCH_NEXT_PAGE',
	PRIVATE_LIBRARY_SEARCH_QUERY_UPDATE: 'PRIVATE_LIBRARY/SEARCH_QUERY_UPDATE',
	PRIVATE_LIBRARY_SEARCH_SORT_UPDATE: 'PRIVATE_LIBRARY/SEARCH_SORT_UPDATE',
	PRIVATE_LIBRARY_SEARCH_TOGGLE_ITEM: 'PRIVATE_LIBRARY/SEARCH_TOGGLE_ITEM',
	PRIVATE_LIBRARY_SETTINGS_FETCHED: 'PRIVATE_LIBRARY/SETTINGS_FETCHED',
	PRIVATE_LIBRARY_SETTINGS_SUBMIT: 'PRIVATE_LIBRARY/SETTINGS_SUBMIT',
	PRIVATE_LIBRARY_SETTINGS_SUCCESS: 'PRIVATE_LIBRARY/SETTINGS_SUCCESS',
	PRIVATE_LIBRARY_SWITCH_LIBRARY: 'PRIVATE_LIBRARY/SWITCH_LIBRARY',
	PRIVATE_LIBRARY_TOGGLE_INFO: 'PRIVATE_LIBRARY/TOGGLE_INFO',
	PRIVATE_LIBRARY_UNLOCK_OVERLAY_OPEN: 'PRIVATE_LIBRARY/UNLOCK_OVERLAY_OPEN',
	PRIVATE_LIBRARY_UNLOCK_SAMPLE_LESSONS: 'PRIVATE_LIBRARY/UNLOCK_SAMPLE_LESSONS',
	PRIVATE_LIBRARY_VIEW_LIBRARY_REDIRECT: 'PRIVATE_LIBRARY/VIEW_LIBRARY_REDIRECT',
	PROCESSING_ICON_ERROR: 'PROCESSING/ICON_ERROR',
	PROCESSING_ICON_SUCCESS: 'PROCESSING/ICON_SUCCESS',
	PROCESSING_INITIALIZE_ERROR: 'PROCESSING/INITIALIZE_ERROR',
	PROCESSING_INITIALIZE_SUCCESS: 'PROCESSING/INITIALIZE_SUCCESS',
	QUICK_LAUNCH_CANCEL_LAUNCH: 'QUICK_LAUNCH/CANCEL_LAUNCH',
	QUICK_LAUNCH_CANCEL_TIMER: 'QUICK_LAUNCH/CANCEL_TIMER',
	QUICK_LAUNCH_COLLABORATE_CANCEL_ACTIVITY: 'QUICK_LAUNCH/COLLABORATE_CANCEL_ACTIVITY',
	QUICK_LAUNCH_COLLABORATE_CREATE: 'QUICK_LAUNCH/COLLABORATE_CREATE',
	QUICK_LAUNCH_COLLABORATE_CREATE_CANCEL: 'QUICK_LAUNCH/COLLABORATE_CREATE_CANCEL',
	QUICK_LAUNCH_COLLABORATE_CREATE_LAUNCH: 'QUICK_LAUNCH/COLLABORATE_CREATE_LAUNCH',
	QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_FAILED: 'QUICK_LAUNCH/COLLABORATE_CREATE_LESSON_FAILED',
	QUICK_LAUNCH_COLLABORATE_CREATE_LESSON_SUCCESS: 'QUICK_LAUNCH/COLLABORATE_CREATE_LESSON_SUCCESS',
	QUICK_LAUNCH_COLLABORATE_SAVE_ACTIVITY_SUCCESS: 'QUICK_LAUNCH/COLLABORATE_SAVE_ACTIVITY_SUCCESS',
	QUICK_LAUNCH_CREATE_DRAW_IT: 'QUICK_LAUNCH/CREATE_DRAW_IT',
	QUICK_LAUNCH_CREATE_OEQ: 'QUICK_LAUNCH/CREATE_OEQ',
	QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_FAILED: 'QUICK_LAUNCH/DRAW_IT_CREATE_LESSON_FAILED',
	QUICK_LAUNCH_DRAW_IT_CREATE_LESSON_SUCCESS: 'QUICK_LAUNCH/DRAW_IT_CREATE_LESSON_SUCCESS',
	QUICK_LAUNCH_DRAW_IT_FINALIZE_CREATION_TOOL: 'QUICK_LAUNCH/DRAW_IT_FINALIZE_CREATION_TOOL',
	QUICK_LAUNCH_DRAW_IT_INITIALIZE_CREATION_TOOL: 'QUICK_LAUNCH/DRAW_IT_INITIALIZE_CREATION_TOOL',
	QUICK_LAUNCH_LAUNCH_LESSON_FAILED: 'QUICK_LAUNCH/LAUNCH_LESSON_FAILED',
	QUICK_LAUNCH_LAUNCH_LESSON_SUCCESS: 'QUICK_LAUNCH/LAUNCH_LESSON_SUCCESS',
	QUICK_LAUNCH_OEQ_CREATE_LESSON_FAILED: 'QUICK_LAUNCH/OEQ_CREATE_LESSON_FAILED',
	QUICK_LAUNCH_OEQ_CREATE_LESSON_SUCCESS: 'QUICK_LAUNCH/OEQ_CREATE_LESSON_SUCCESS',
	QUICK_LAUNCH_OEQ_FINALIZE_CREATION_TOOL: 'QUICK_LAUNCH/OEQ_FINALIZE_CREATION_TOOL',
	QUICK_LAUNCH_OEQ_INITIALIZE_CREATION_TOOL: 'QUICK_LAUNCH/OEQ_INITIALIZE_CREATION_TOOL',
	QUICK_LAUNCH_RETRY_LAUNCH: 'QUICK_LAUNCH/RETRY_LAUNCH',
	QUICK_LAUNCH_TIMER_ADD_TIME: 'QUICK_LAUNCH/TIMER_ADD_TIME',
	QUICK_LAUNCH_TIMER_CANCEL_COUNTDOWN: 'QUICK_LAUNCH/TIMER_CANCEL_COUNTDOWN',
	QUICK_LAUNCH_TIMER_CANCEL_PILL: 'QUICK_LAUNCH/TIMER_CANCEL_PILL',
	QUICK_LAUNCH_TIMER_COUNTDOWN_START: 'QUICK_LAUNCH/TIMER_COUNTDOWN_START',
	QUICK_LAUNCH_TIMER_CREATE: 'QUICK_LAUNCH/TIMER_CREATE',
	QUICK_LAUNCH_TIMER_CREATE_CANCEL: 'QUICK_LAUNCH/TIMER_CREATE_CANCEL',
	QUICK_LAUNCH_TIMER_CREATE_SAVE: 'QUICK_LAUNCH/TIMER_CREATE_SAVE',
	QUICK_LAUNCH_TIMER_FINALIZE: 'QUICK_LAUNCH/QUICK_LAUNCH_TIMER_FINALIZE',
	QUICK_LAUNCH_TIMER_INITIALIZE: 'QUICK_LAUNCH/QUICK_LAUNCH_TIMER_INITIALIZE',
	QUICK_LAUNCH_TIMER_PAUSE: 'QUICK_LAUNCH/TIMER_PAUSE',
	QUICK_LAUNCH_TIMER_REMOVE_TIME: 'QUICK_LAUNCH/TIMER_REMOVE_TIME',
	QUICK_LAUNCH_TIMER_RESTART: 'QUICK_LAUNCH_TIMER_RESTART',
	QUICK_LAUNCH_TIMER_RESUME: 'QUICK_LAUNCH/TIMER_RESUME',
	QUICK_LAUNCH_TIMER_VIEW_INITIALIZE: 'QUICK_LAUNCH/TIMER_VIEW_INITIALIZE',
	QUIZ_ADD_ANSWER: 'QUIZ/ADD_ANSWER',
	QUIZ_ADD_ANSWER_VALIDATION_ERROR: 'QUIZ/ADD_ANSWER_VALIDATION_ERROR',
	QUIZ_ADD_ANSWER_VALIDATION_SUCCESS: 'QUIZ/ADD_ANSWER_VALIDATION_SUCCESS',
	QUIZ_ADD_QUESTION: 'QUIZ/ADD_QUESTION',
	QUIZ_ADD_QUESTION_VALIDATION_ERROR: 'QUIZ/ADD_QUESTION_VALIDATION_ERROR',
	QUIZ_ADD_QUESTION_VALIDATION_SUCCESS: 'QUIZ/ADD_QUESTION_VALIDATION_SUCCESS',
	QUIZ_ADD_REFERENCE_MEDIA_CLICK: 'QUIZ/ADD_REFERENCE_MEDIA_CLICK',
	QUIZ_ADD_TIMER: 'QUIZ/ADD_TIMER',
	QUIZ_ANSWER_CHANGE: 'QUIZ/ANSWER_CHANGE',
	QUIZ_ANSWER_CHECKBOX_CHANGE: 'QUIZ/ANSWER_CHECKBOX_CHANGE',
	QUIZ_ANSWER_FOCUS: 'QUIZ/ANSWER_FOCUS',
	QUIZ_ANSWER_SAVE: 'QUIZ/ANSWER_SAVE',
	QUIZ_CANCEL_QUIZ: 'QUIZ/CANCEL_QUIZ',
	QUIZ_CANCEL_QUIZ_CONFIRM: 'QUIZ/CANCEL_QUIZ_CONFIRM',
	QUIZ_CANCEL_QUIZ_CONFIRMED: 'QUIZ/CANCEL_QUIZ_CONFIRMED',
	QUIZ_CANCEL_QUIZ_REJECTED: 'QUIZ/CANCEL_QUIZ_REJECTED',
	QUIZ_CANCEL_TIMER: 'QUIZ/CANCEL_TIMER',
	QUIZ_COLLAPSE_ALL: 'QUIZ/COLLAPSE_ALL',
	QUIZ_DELETE_ANSWER: 'QUIZ/DELETE_ANSWER',
	QUIZ_DELETE_ANSWER_VALIDATION_ERROR: 'QUIZ/DELETE_ANSWER_VALIDATION_ERROR',
	QUIZ_DELETE_ANSWER_VALIDATION_SUCCESS: 'QUIZ/DELETE_ANSWER_VALIDATION_SUCCESS',
	QUIZ_DELETE_QUESTION: 'QUIZ/DELETE_QUESTION',
	QUIZ_DELETE_QUESTION_ERROR: 'QUIZ/DELETE_QUESTION_ERROR',
	QUIZ_DELETE_QUESTION_SUCCESS: 'QUIZ/DELETE_QUESTION_SUCCESS',
	QUIZ_DELETE_QUESTION_VALIDATION_ERROR: 'QUIZ/DELETE_QUESTION_VALIDATION_ERROR',
	QUIZ_DELETE_QUESTION_VALIDATION_SUCCESS: 'QUIZ/DELETE_QUESTION_VALIDATION_SUCCESS',
	QUIZ_DELETE_REFERENCE_MEDIA: 'QUIZ/DELETE_REFERENCE_MEDIA',
	QUIZ_DELETE_REFERENCE_MEDIA_SUCCESS: 'QUIZ/DELETE_REFERENCE_MEDIA_SUCCESS',
	QUIZ_DELETE_TIMER: 'QUIZ/DELETE_TIMER',
	QUIZ_DRAG_ANSWER: 'QUIZ/DRAG_ANSWER',
	QUIZ_DRAG_QUESTION: 'QUIZ_DRAG_QUESTION',
	QUIZ_DROP_ANSWER: 'QUIZ/DROP_ANSWER',
	QUIZ_DROP_QUESTION: 'QUIZ/DROP_QUESTION',
	QUIZ_DROP_QUESTION_ERROR: 'QUIZ/DROP_QUESTION_ERROR',
	QUIZ_DROP_QUESTION_SUCCESS: 'QUIZ/DROP_QUESTION_SUCCESS',
	QUIZ_DUPLICATE_QUESTION: 'QUIZ/DUPLICATE_QUESTION',
	QUIZ_DUPLICATE_QUESTION_VALIDATION_SUCCESS: 'QUIZ/DUPLICATE_QUESTION_VALIDATION_SUCCESS',
	QUIZ_EDIT_TIMER: 'QUIZ/EDIT_TIMER',
	QUIZ_EXPAND_ALL: 'QUIZ/EXPAND_ALL',
	QUIZ_FINALIZE: 'QUIZ/FINALIZE',
	QUIZ_INITIALIZE: 'QUIZ/INITIALIZE',
	QUIZ_INITIALIZE_ERROR: 'QUIZ/INITIALIZE_ERROR',
	QUIZ_INITIALIZE_STANDALONE: 'QUIZ/INITIALIZE_STANDALONE',
	QUIZ_INITIALIZE_SUCCESS: 'QUIZ/INITIALIZE_SUCCESS',
	QUIZ_NEARPOD_PICKER_CANCEL: 'QUIZ/NEARPOD_PICKER/CANCEL',
	QUIZ_QUESTION_CHANGE: 'QUIZ/QUESTION_CHANGE',
	QUIZ_QUESTION_FOCUS: 'QUIZ/QUESTION_FOCUS',
	QUIZ_QUESTION_SAVE: 'QUIZ/QUESTION_SAVE',
	QUIZ_QUESTION_SAVE_ERROR: 'QUIZ/QUESTION_SAVE_ERROR',
	QUIZ_QUESTION_SAVE_SUCCESS: 'QUIZ/QUESTION_SAVE_SUCCESS',
	QUIZ_QUESTION_UPDATE_ERROR: 'QUIZ/QUESTION_UPDATE_ERROR',
	QUIZ_QUESTION_UPDATE_SUCCESS: 'QUIZ/QUESTION_UPDATE_SUCCESS',
	QUIZ_QUESTION_TO_PLAIN_TEXT: 'QUIZ/QUESTION_TO_PLAIN_TEXT',
	QUIZ_REFERENCE_MEDIA_MENU_CLICK: 'QUIZ/REFERENCE_MEDIA_MENU/CLICK',
	QUIZ_SAVE_QUIZ: 'QUIZ/SAVE_QUIZ',
	QUIZ_SAVE_QUIZ_ERROR: 'QUIZ/SAVE_QUIZ_ERROR',
	QUIZ_SAVE_QUIZ_SUCCESS: 'QUIZ/SAVE_QUIZ_SUCCESS',
	QUIZ_SAVE_TIMER: 'QUIZ/SAVE_TIMER',
	QUIZ_SCREENSHOT_INITIALIZE_ROUTE: 'QUIZ/SCREENSHOT_INITIALIZE_ROUTE',
	QUIZ_TIMER_SAVE_ERROR: 'QUIZ/TIMER_SAVE_ERROR',
	QUIZ_TIMER_SAVE_SUCCESS: 'QUIZ/TIMER_SAVE_SUCCESS',
	QUIZ_TITLE_CHANGE: 'QUIZ/TITLE_CHANGE',
	QUIZ_TITLE_SAVE: 'QUIZ/TITLE_SAVE',
	QUIZ_TITLE_SAVE_ERROR: 'QUIZ/TITLE_SAVE_ERROR',
	QUIZ_TITLE_SAVE_SUCCESS: 'QUIZ/TITLE_SAVE_SUCCESS',
	QUIZ_TOGGLE_COLLAPSE_QUESTION: 'QUIZ/TOGGLE_COLLAPSE_QUESTION',
	QUIZ_TOOLBAR_HELP_BUTTON_CLICK: 'QUIZ/TOOLBAR/HELP_BUTTON_CLICK',
	QUIZ_UPLOADER_UPLOAD_ERROR: 'QUIZ/UPLOADER/UPLOAD_ERROR',
	QUIZ_UPLOADER_UPLOAD_SUCCESS: 'QUIZ/UPLOADER/UPLOAD_SUCCESS',
	QUIZ_UPLOADER_VALIDATE_CONTENT_ERROR: 'QUIZ/UPLOADER/VALIDATE_CONTENT_ERROR',
	QUIZ_UPLOADER_VALIDATE_ERROR: 'QUIZ/UPLOADER/VALIDATE_ERROR',
	QUIZ_UPLOADER_VALIDATE_SUCCESS: 'QUIZ/UPLOADER/VALIDATE_SUCCESS',
	QUIZ_UPLOAD_REFERENCE_MEDIA: 'QUIZ/UPLOAD_REFERENCE_MEDIA',
	QUIZ_UPLOAD_REFERENCE_MEDIA_ERROR: 'QUIZ/UPLOAD_REFERENCE_MEDIA_ERROR',
	QUIZ_UPLOAD_REQUIRE_CONFIRMATION: 'QUIZ/UPLOAD_REQUIRE_CONFIRMATION',
	QUIZ_VALIDATION_ERROR: 'QUIZ/VALIDATION_ERROR',
	QUIZ_VALIDATION_SUCCESS: 'QUIZ/VALIDATION_SUCCESS',
	READ_ONLY_NAVIGATE: 'READ_ONLY/NAVIGATE',
	ROUTES_GO_TO_CHECKOUT: 'ROUTES/GO_TO_CHECKOUT',
	ROUTES_GO_TO_MY_ACTIVITIES: 'ROUTES/GO_TO_MY_ACTIVITIES',
	ROUTES_GO_TO_MY_LIBRARY: 'ROUTES/GO_TO_MY_LIBRARY',
	ROUTES_GO_TO_PRIVATE_LIBRARY: 'ROUTES/GO_TO_PRIVATE_LIBRARY',
	ROUTES_GO_TO_PUBLIC_LIBRARY_ADMIN: 'ROUTES/GO_TO_PUBLIC_LIBRARY_ADMIN',
	ROUTES_GO_TO_REPORTS: 'ROUTES/GO_TO_REPORTS',
	ROUTES_GO_TO_STORE: 'ROUTES/GO_TO_STORE',
	ROUTES_GO_TO_SUB_PLANS: 'ROUTES/GO_TO_SUB_PLANS',
	ROUTES_GO_TO_TEACHER_RESOURCES: 'ROUTES/GO_TO_TEACHER_RESOURCES',
	SAVE_ACTIVITY_SUCCESS_REDIRECT: 'SAVE_ACTIVITY_SUCCESS_REDIRECT',
	SEND_FORM_POST: 'SEND_FORM_POST',
	SESSION_PREVIEW_EXITED: 'SESSION_PREVIEW/EXITED',
	SESSION_PREVIEW_INITIALIZE: 'SESSION_PREVIEW/INITIALIZE',
	SESSION_SETTINGS_CACOPHONY_TYPE_UPDATE: 'SESSION/SETTINGS/CACOPHONY_TYPE_UPDATE',
	SESSION_SETTINGS_HIDE_STUDENT_NAMES_UPDATE: 'SESSION/SETTINGS/HIDE_STUDENT_NAMES_UPDATE',
	SESSION_SETTINGS_STREAM_MODE_UPDATE: 'SESSION/SETTINGS/STREAM_MODE_UPDATE',
	SESSION_TEACHER_OEQ_INITIALIZE: 'SESSION/TEACHER/OEQ/INITIALIZE',
	SESSION_TEACHER_OEQ_FINALIZE: 'SESSION/TEACHER/OEQ/FINALIZE',
	SESSION_TEACHER_OEQ_STUDENT_DATA_FETCHED: 'SESSION/TEACHER/OEQ/STUDENT_DATA_FETCHED',
	SHARE_CHANGE_EMBED_TAB: 'SHARE/CHANGE_EMBED_TAB',
	SHARE_CHANGE_MAIN_TAB: 'SHARE/CHANGE_MAIN_TAB',
	SHARE_VIEW_DATA_FAILED: 'SHARE/VIEW_DATA_FAILED',
	SHARE_VIEW_DATA_LOADED: 'SHARE/VIEW_DATA_LOADED',
	SHOW_INTERCOM: 'SHOW_INTERCOM',
	SIDEBAR_GO_TO_MY_ACTIVITIES_SELECTED: 'SIDEBAR/GO_TO_MY_ACTIVITIES_SELECTED',
	SIDEBAR_GO_TO_PRIVATE_LIBRARY_SELECTED: 'SIDEBAR/GO_TO_PRIVATE_LIBRARY_SELECTED',
	SIDEBAR_GO_TO_PUBLIC_LIBRARY_ADMIN_SELECTED: 'SIDEBAR/GO_TO_PUBLIC_LIBRARY_ADMIN_SELECTED',
	SIDEBAR_GO_TO_REPORTS_SELECTED: 'SIDEBAR/GO_TO_REPORTS_SELECTED',
	SIDEBAR_GO_TO_STORE_SELECTED: 'SIDEBAR/GO_TO_STORE_SELECTED',
	SIDEBAR_GO_TO_SUB_PLANS_SELECTED: 'SIDEBAR/GO_TO_SUB_PLANS_SELECTED',
	SIDEBAR_GO_TO_TEACHER_SELECTED: 'SIDEBAR/GO_TO_TEACHER_SELECTED',
	SIDEBAR_INITIALIZE: 'SIDEBAR/INITIALIZE',
	SIDEBAR_NAVIGATE_TO_SELECTED: 'SIDEBAR/NAVIGATE_TO_SELECTED',
	SIGNUP_ASK_IF_STUDENT: 'SIGNUP/ASK_IF_STUDENT',
	SIGNUP_CHANGE_TAB: 'SIGNUP/CHANGE_TAB',
	SIGNUP_CHANGE_TAB_STUDENT: 'SIGNUP/CHANGE_TAB_STUDENT',
	SIGNUP_CHANGE_TAB_TEACHER: 'SIGNUP/CHANGE_TAB_TEACHER',
	SIGNUP_GET_PASSWORD_CONDITIONS: 'SIGNUP/GET_PASSWORD_CONDITIONS',
	SIGNUP_INITIALIZE: 'SIGNUP/INITIALIZE',
	SIGNUP_IS_TEACHER_CONFIRMATION: 'SIGNUP/IS_TEACHER_CONFIRMATION',
	SIGNUP_NAVIGATE_TO_EMAIL: 'SIGNUP/NAVIGATE_TO_EMAIL',
	SIGNUP_NAVIGATE_TO_GMAIL: 'SIGNUP/NAVIGATE_TO_GMAIL',
	SIGNUP_NAVIGATE_TO_LOGIN: 'SIGNUP/NAVIGATE_TO_LOGIN',
	SIGNUP_NAVIGATE_TO_OFFICE: 'SIGNUP/NAVIGATE_TO_OFFICE',
	SIGNUP_NAVIGATE_TO_STUDENT: 'SIGNUP/NAVIGATE_TO_STUDENT',
	SIGNUP_NAVIGATE_TO_TERMS: 'SIGNUP/NAVIGATE_TO_TERMS',
	SIGNUP_OB_LESSON_DOWNLOAD_ERROR: 'SIGNUP/OB_LESSON_DOWNLOAD_ERROR',
	SIGNUP_OB_LESSON_DOWNLOAD_SUCCESS: 'SIGNUP/OB_LESSON_DOWNLOAD_SUCCESS',
	SIGNUP_REFERRAL_ERROR: 'SIGNUP/REFERRAL/ERROR',
	SIGNUP_REFERRAL_RESET: 'SIGNUP/REFERRAL/RESET',
	SIGNUP_REFERRAL_SUCCESS: 'SIGNUP/REFERRAL/SUCCESS',
	SIGNUP_SEND_EMAIL_FORM: 'SIGNUP/SEND_EMAIL_FORM',
	SIGNUP_SEND_EMAIL_FORM_SUCCESS: 'SIGNUP/SEND_EMAIL_FORM_SUCCESS',
	SIGNUP_SEND_SSO_FORM: 'SIGNUP/SEND_SSO_FORM',
	SIGNUP_SEND_SSO_FORM_SUCCESS: 'SIGNUP/SEND_SSO_FORM_SUCCESS',
	SIGNUP_SET_PASSWORD_CONDITIONS: 'SIGNUP/SET_PASSWORD_CONDITIONS',
	SIGNUP_SHOW_REFERRAL_INPUT: 'SIGNUP/SHOW_REFERRAL_INPUT',
	SIGNUP_STUDENT_CONFIRMED: 'SIGNUP/STUDENT_CONFIRMED',
	SIGNUP_TEACHER_CONFIRMED: 'SIGNUP/TEACHER_CONFIRMED',
	SIGNUP_TEACHER_EMAIL_ALREADY_REGISTERED: 'SIGNUP/TEACHER_EMAIL_ALREADY_REGISTERED',
	SHARE_ENTITY: 'SHARE_ENTITY',
	SHARE_ENTITY_LINK: 'SHARE_ENTITY/LINK',
	SSO_SUCCESS_INITIALIZE: 'SSO_SUCCESS/INITIALIZE',
	STOREFRONT_ADD_GRADES_SUBJECT_CANCEL: 'STOREFRONT/ADD_GRADES_SUBJECT_CANCEL',
	STOREFRONT_ADD_GRADES_SUBJECT_CLOSE: 'STOREFRONT/ADD_GRADES_SUBJECT_CLOSE',
	STOREFRONT_ADD_GRADES_SUBJECT_OPEN: 'STOREFRONT/ADD_GRADES_SUBJECT_OPEN',
	STOREFRONT_ADD_GRADES_SUBJECT_SAVE: 'STOREFRONT/ADD_GRADES_SUBJECT_SAVE',
	STOREFRONT_ADD_LESSONS_SELECTED: 'STOREFRONT/ADD_LESSONS_SELECTED',
	STOREFRONT_FINALIZE: 'STOREFRONT/FINALIZE',
	STOREFRONT_FOUND_LESSONS: 'STOREFRONT/FOUND_LESSONS',
	STOREFRONT_INITIALIZE_PREVIEW: 'STOREFRONT/INITIALIZE_PREVIEW',
	STOREFRONT_INIT_SEARCH_LESSONS: 'STOREFRONT/INIT_SEARCH_LESSONS',
	STOREFRONT_LESSONS_PICKER_ADD_SUCCESS: 'STOREFRONT/LESSONS_PICKER_ADD_SUCCESS',
	STOREFRONT_LESSONS_PICKER_CANCEL: 'STOREFRONT/LESSONS_PICKER_CANCEL',
	STOREFRONT_LESSONS_PICKER_CLOSE: 'STOREFRONT/LESSONS_PICKER_CLOSE',
	STOREFRONT_LESSONS_PICKER_SAVE_LESSONS: 'STOREFRONT/LESSONS_PICKER_SAVE_LESSONS',
	STOREFRONT_LESSONS_PICKER_SEARCH_LESSONS: 'STOREFRONT/LESSONS_PICKER_SEARCH_LESSONS',
	STOREFRONT_OWNER_ALLOW_HOVER: 'STOREFRONT/OWNER_ALLOW_HOVER',
	STOREFRONT_OWNER_BIO_ERROR: 'STOREFRONT/OWNER_BIO_ERROR',
	STOREFRONT_OWNER_BIO_FORM_CHANGE: 'STOREFRONT_OWNER/BIO_FORM_CHANGE',
	STOREFRONT_OWNER_BIO_SUCCESS: 'STOREFRONT/OWNER_BIO_SUCCESS',
	STOREFRONT_OWNER_CLOSE_BIO_FORM: 'STOREFRONT_OWNER/CLOSE_BIO_FORM',
	STOREFRONT_OWNER_DATA_ERROR: 'STOREFRONT/OWNER_DATA_ERROR',
	STOREFRONT_OWNER_DATA_FETCHED: 'STOREFRONT/OWNER_DATA_FETCHED',
	STOREFRONT_OWNER_INITIALIZE: 'STOREFRONT/OWNER_INITIALIZE',
	STOREFRONT_OWNER_INITIALIZE_BIO_FORM: 'STOREFRONT_OWNER/INITIALIZE_BIO_FORM',
	STOREFRONT_OWNER_INITIALIZE_ERROR: 'STOREFRONT/OWNER_INITIALIZE_ERROR',
	STOREFRONT_OWNER_LESSONS_FETCHED: 'STOREFRONT/OWNER_LESSONS_FETCHED',
	STOREFRONT_OWNER_LOAD_NEXT_PAGE: 'STOREFRONT/OWNER_LOAD_NEXT_PAGE',
	STOREFRONT_OWNER_SEND_SUBMITTED_BIO: 'STOREFRONT/OWNER_SEND_SUBMITTED_BIO',
	STOREFRONT_OWNER_SORT_HOVER_LESSON: 'STOREFRONT/OWNER_SORT_HOVER_LESSON',
	STOREFRONT_OWNER_SORT_LESSONS_RELEASE: 'STOREFRONT/OWNER_SORT_LESSONS_RELEASE',
	STOREFRONT_OWNER_SORT_START: 'STOREFRONT/OWNER_SORT_START',
	STOREFRONT_PREVIEW_LESSON: 'STOREFRONT/PREVIEW_LESSON',
	STOREFRONT_REMOVE_LESSON: 'STOREFRONT/REMOVE_LESSON',
	STOREFRONT_REMOVE_LESSON_CANCELLED: 'STOREFRONT/REMOVE_LESSON_CANCELLED',
	STOREFRONT_REMOVE_LESSON_CONFIRM: 'STOREFRONT/REMOVE_LESSON_CONFIRM',
	STOREFRONT_REMOVE_LESSON_CONFIRMED: 'STOREFRONT/REMOVE_LESSON_CONFIRMED',
	STOREFRONT_REMOVE_LESSON_SUCCESS: 'STOREFRONT/REMOVE_LESSON_SUCCESS',
	STOREFRONT_SHARE: 'STOREFRONT/SHARE',
	STOREFRONT_VISITOR_DATA_ERROR: 'STOREFRONT/VISITOR_DATA_ERROR',
	STOREFRONT_VISITOR_DATA_FETCHED: 'STOREFRONT/VISITOR_DATA_FETCHED',
	STOREFRONT_VISITOR_FOLLOW_OWNER: 'STOREFRONT/VISITOR_FOLLOW_OWNER',
	STOREFRONT_VISITOR_FOLLOW_OWNER_ERROR: 'STOREFRONT/VISITOR_FOLLOW_OWNER_ERROR',
	STOREFRONT_VISITOR_FOLLOW_OWNER_SUCCESS: 'STOREFRONT/VISITOR_FOLLOW_OWNER_SUCCESS',
	STOREFRONT_VISITOR_INITIALIZE: 'STOREFRONT/VISITOR_INITIALIZE',
	STOREFRONT_VISITOR_INITIALIZE_ERROR: 'STOREFRONT/VISITOR_INITIALIZE_ERROR',
	STOREFRONT_VISITOR_LESSONS_FETCHED: 'STOREFRONT/VISITOR_LESSONS_FETCHED',
	STOREFRONT_VISITOR_LOAD_NEXT_PAGE: 'STOREFRONT/VISITOR_LOAD_NEXT_PAGE',
	STOREFRONT_VISITOR_UNFOLLOW_OWNER: 'STOREFRONT/VISITOR_UNFOLLOW_OWNER',
	STOREFRONT_VISITOR_UNFOLLOW_OWNER_ERROR: 'STOREFRONT/VISITOR_UNFOLLOW_OWNER_ERROR',
	STOREFRONT_VISITOR_UNFOLLOW_OWNER_SUCCESS: 'STOREFRONT/VISITOR_UNFOLLOW_OWNER_SUCCESS',
	STORE_ADD_LESSON_TO_PRIVATE_LIBRARY: 'STORE/ADD_LESSON_TO_PRIVATE_LIBRARY',
	STORE_ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS: 'STORE/ADD_LESSON_TO_PRIVATE_LIBRARY_SUCCESS',
	STORE_ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED: 'STORE/ADD_LESSON_TO_PRIVATE_LIBRARY_FAILED',
	STORE_BASE_ROUTE_INITIALIZE: 'STORE_BASE/INITIALIZE_ROUTE',
	STORE_CATALOG_GET_RESULTS_ERROR: 'STORE/CATALOG_GET_RESULTS_ERROR',
	STORE_CATALOG_GET_RESULTS_SUCCESS: 'STORE/CATALOG_GET_RESULTS_SUCCESS',
	STORE_CLEAR_SELECTED_FILTERS: 'STORE/CLEAR_SELECTED_FILTERS',
	STORE_CONNECTOR_SEARCH_INITIALIZE: 'STORE/CONNECTOR_SEARCH_INITIALIZE',
	STORE_CONNECTOR_SEARCH_UPDATE: 'STORE/CONNECTOR_SEARCH_UPDATE',
	STORE_CONNECTOR_STORE_TOPBAR_INITIALIZE: 'STORE/CONNECTOR_STORE_TOPBAR_INITIALIZE',
	STORE_CONNECTOR_STORE_TOPBAR_UPDATE: 'STORE/CONNECTOR_STORE_TOPBAR_UPDATE',
	STORE_EDIT_LESSON: 'STORE/EDIT_LESSON',
	STORE_FILTER_SELECTED: 'STORE/FILTER_SELECTED',
	STORE_FILTERS_CLEAR: 'STORE/FILTERS_CLEAR',
	STORE_FILTERS_FETCHED: 'STORE/FILTERS_FETCHED',
	STORE_FILTERS_SEARCH: 'STORE/FILTERS_SEARCH',
	STORE_FILTERS_TAB_SELECTED: 'STORE/FILTERS_TAB_SELECTED',
	STORE_FOLDER_GET_NEXT_PAGE: 'STORE/FOLDER_GET_NEXT_PAGE',
	STORE_FOLDER_GET_RESULTS_SUCCESS: 'STORE/FOLDER_GET_RESULTS_SUCCESS',
	STORE_FOLDER_INITIALIZE: 'STORE/FOLDER_INITIALIZE',
	STORE_INITIALIZE_VIDEO_PREVIEW: 'STORE/INITIALIZE_VIDEO_PREVIEW',
	STORE_LANDING_INITIALIZE: 'STORE_LANDING/INITIALIZE_ROUTE',
	STORE_LAUNCH_VIDEO_PREVIEW: 'STORE/LAUNCH_VIDEO_PREVIEW',
	STORE_PREVIEW_LAUNCH_ALL_DEVICES: 'STORE/PREVIEW_LAUNCH_ALL_DEVICES',
	STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM: 'STORE/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM',
	STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED: 'STORE/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FAILED',
	STORE_PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED: 'STORE/PREVIEW_LAUNCH_FRONT_OF_THE_CLASSROOM_SESSION_FETCHED',
	STORE_PREVIEW_LAUNCH_STUDENT_PACED: 'STORE/PREVIEW_LAUNCH_STUDENT_PACED',
	STORE_LESSON_TYPE_FILTER_SELECTED: 'STORE/LESSON_TYPE_FILTER_SELECTED',
	STORE_LOCKED_CONTENT_FINALIZE_ROUTE: 'STORE/LOCKED_CONTENT/FINALIZE_ROUTE',
	STORE_LOCKED_CONTENT_INITIALIZE_ROUTE: 'STORE/LOCKED_CONTENT/INITIALIZE_ROUTE',
	STORE_NPP_THUMBNAIL_SELECTED: 'STORE/NPP_THUMBNAIL_SELECTED',
	STORE_PREVIEW_FETCHED: 'STORE/PREVIEW_FETCHED',
	STORE_PREVIEW_INITIALIZE: 'STORE/PREVIEW_INITIALIZE',
	STORE_QUERY_INPUT_CHANGE: 'STORE/QUERY_INPUT_CHANGE',
	STORE_QUERY_SEARCH: 'STORE/QUERY_SEARCH',
	STORE_RESET: 'STORE/RESET',
	STORE_SEARCH_GET_NEXT_PAGE: 'STORE/SEARCH_GET_NEXT_PAGE',
	STORE_SEARCH_GET_RESULTS_ERROR: 'STORE/SEARCH_GET_RESULTS_ERROR',
	STORE_SEARCH_GET_RESULTS_SUCCESS: 'STORE/SEARCH_GET_RESULTS_SUCCESS',
	STORE_SEARCH_INITIALIZE: 'STORE/SEARCH_INITIALIZE',
	STORE_SEARCH_NO_RESULTS_FEEDBACK_SELECTED: 'STORE/SEARCH_NO_RESULTS/FEEDBACK_SELECTED',
	STORE_SEARCH_ROUTE_INITIALIZE: 'STORE/SEARCH_ROUTE_INITIALIZE',
	STORE_SEARCH_ROUTE_UPDATE: 'STORE/SEARCH_ROUTE_UPDATE',
	STORE_SEARCH_SHARE_LESSON: 'STORE/SEARCH_SHARE_LESSON',
	STORE_STANDARD_AND_QUERY_FILTERS_CLEAR: 'STORE/STANDARD_AND_QUERY_FILTERS_CLEAR',
	STORE_STANDARD_FETCHED: 'STORE/STANDARD_FETCHED',
	STORE_STANDARD_FILTERS_CLEAR: 'STORE/STANDARD_FILTERS_CLEAR',
	STORE_UPDATE_FILTERS: 'STORE/UPDATE_FILTERS',
	STORE_WIDGET_ITEM_SELECTED: 'STORE/WIDGET_ITEM_SELECTED',
	STUDENT_DELETE_AUDIO_OEQ_CONFIRM: 'STUDENT/DELETE_AUDIO_OEQ_CONFIRM',
	STUDENT_DELETE_AUDIO_OEQ_CONFIRMED: 'STUDENT/DELETE_AUDIO_OEQ_CONFIRMED',
	STUDENT_DELETE_AUDIO_OEQ_CONFIRM_CANCEL: 'STUDENT/DELETE_AUDIO_OEQ_CONFIRM_CANCEL',
	STUDENT_DRAW_IT_ENDED: 'STUDENT/DRAW_IT_ENDED',
	STUDENT_DRAW_IT_REVIEW_CONFIRMED: 'STUDENT/DRAW_IT_REVIEW_CONFIRMED',
	STUDENT_DRAW_IT_UNSUPPORTED_FILE_ERROR: 'STUDENT/DRAW_IT_UNSUPPORTED_FILE_ERROR',
	STUDENT_INITIALIZE_DRAW_IT: 'STUDENT/INITIALIZE_DRAW_IT',
	STUDENT_INITIALIZE_DRAW_IT_WITH_DATA: 'STUDENT/INITIALIZE_DRAW_IT_WITH_DATA',
	STUDENT_INITIALIZE_LEAD: 'STUDENT/INITIALIZE_LEAD',
	STUDENT_INITIALIZE_LEAD_FAILED: 'STUDENT/INITIALIZE_LEAD_FAILED',
	STUDENT_INITIALIZE_LEAD_WITH_DATA: 'STUDENT/INITIALIZE_LEAD_WITH_DATA',
	STUDENT_INITIALIZE_OEQ: 'STUDENT/INITIALIZE_OEQ',
	STUDENT_INITIALIZE_OEQ_WITH_DATA: 'STUDENT/INITIALIZE_OEQ_WITH_DATA',
	STUDENT_INITIALIZE_POLL: 'STUDENT/INITIALIZE_POLL',
	STUDENT_INITIALIZE_POLL_WITH_DATA: 'STUDENT/INITIALIZE_POLL_WITH_DATA',
	STUDENT_INITIALIZE_QUIZ: 'STUDENT/INITIALIZE_QUIZ',
	STUDENT_INITIALIZE_QUIZ_WITH_DATA: 'STUDENT/INITIALIZE_QUIZ_WITH_DATA',
	STUDENT_INITIALIZE_READ_ONLY: 'STUDENT/INITIALIZE_READ_ONLY',
	STUDENT_JOIN_INITIALIZE: 'STUDENT_JOIN/INITIALIZE',
	STUDENT_LEAD_ENDED: 'STUDENT/LEAD_ENDED',
	STUDENT_LEAD_FIELD_CHANGE: 'STUDENT/LEAD_FIELD_CHANGE',
	STUDENT_LEAD_GOOGLE_GET_NAME_FAILED: 'STUDENT/LEAD_GOOGLE_GET_NAME_FAILED',
	STUDENT_LEAD_GOOGLE_GET_NAME_SUCCESS: 'STUDENT/LEAD_GOOGLE_GET_NAME_SUCCESS',
	STUDENT_LEAD_GOOGLE_LOGIN_FAILED: 'STUDENT/LEAD_GOOGLE_LOGIN_FAILED',
	STUDENT_LEAD_GOOGLE_LOGIN_SUCCESS: 'STUDENT/LEAD_GOOGLE_LOGIN_SUCCESS',
	STUDENT_LEAD_OFFICE_365_GET_NAME_FAILED: 'STUDENT/LEAD_OFFICE_365_GET_NAME_FAILED',
	STUDENT_LEAD_OFFICE_365_GET_NAME_SUCCESS: 'STUDENT/LEAD_OFFICE_365_GET_NAME_SUCCESS',
	STUDENT_LEAD_OFFICE_365_LOGIN_FAILED: 'STUDENT/LEAD_OFFICE_365_LOGIN_FAILED',
	STUDENT_LEAD_OFFICE_365_LOGIN_SUCCESS: 'STUDENT/LEAD_OFFICE_365_LOGIN_SUCCESS',
	STUDENT_LEAD_SUBMIT: 'STUDENT/LEAD_SUBMIT',
	STUDENT_LEAD_SUBMIT_FAILED: 'STUDENT/LEAD_SUBMIT_FAILED',
	STUDENT_LEAD_SUBMIT_SUCCESS: 'STUDENT/LEAD_SUBMIT_SUCCESS',
	STUDENT_REQUEST_MIC_PERMISSION: 'STUDENT/REQUEST_MIC_PERMISSION',
	STUDENT_REQUEST_MIC_PERMISSION_CANCEL: 'STUDENT/REQUEST_MIC_PERMISSION_CANCEL',
	STUDENT_OEQ_ENDED: 'STUDENT/OEQ_ENDED',
	STUDENT_OEQ_RECORDING_DELETE: 'STUDENT/OEQ/RECORDING_DELETE',
	STUDENT_OEQ_RECORDING_END: 'STUDENT/OEQ/RECORDING_END',
	STUDENT_OEQ_RECORDING_START: 'STUDENT/OEQ/RECORDING_START',
	STUDENT_OEQ_RECORDING_UPDATE: 'STUDENT/OEQ/RECORDING_UPDATE',
	STUDENT_OEQ_RECORDING_SUBMISSION_FAILED: 'STUDENT/OEQ/RECORDING_SUBMISSION_FAILED',
	STUDENT_OEQ_RECORDING_SUBMISSION_SUCCESS: 'STUDENT/OEQ/RECORDING_SUBMISSION_SUCCESS',
	STUDENT_POLL_ENDED: 'STUDENT/POLL_ENDED',
	STUDENT_QUIZ_CHANGE_SLIDE: 'STUDENT/QUIZ_CHANGE_SLIDE',
	STUDENT_QUIZ_ENDED: 'STUDENT/QUIZ_ENDED',
	STUDENT_QUIZ_FIRST_SLIDE_REACHED: 'STUDENT/QUIZ_FIRST_SLIDE_REACHED',
	STUDENT_SKIP_QUIZ: 'STUDENT/QUIZ_SKIP_ACTIVITY',
	STUDENT_QUIZ_SUBMIT_QUIZ: 'STUDENT/QUIZ_SUBMIT_QUIZ',
	STUDENT_QUIZ_UPDATE_ANSWERS: 'STUDENT/QUIZ_UPDATE_ANSWERS',
	STUDENT_SAVE_RECORDED_AUDIO_OEQ: 'STUDENT/SAVE_RECORDED_AUDIO_OEQ',
	STUDENT_SLIDE_CHECK_READY: 'STUDENT/SLIDE_CHECK_READY',
	STUDENT_STATUS_UPDATED: 'STUDENT/STATUS_UPDATED',
	STUDENT_SUBMIT_DRAWIT_ANSWER: 'STUDENT/SUBMIT_DRAWIT_ANSWER',
	STUDENT_SUBMIT_DRAWIT_CONFIRMED: 'STUDENT/SUBMIT_DRAWIT_CONFIRMED',
	STUDENT_SUBMIT_DRAWIT_EDIT: 'STUDENT/SUBMIT_DRAWIT_EDIT',
	STUDENT_SUBMIT_FAILED: 'STUDENT/SUBMIT_FAILED',
	STUDENT_SUBMIT_FAILED_GOT_IT: 'STUDENT/SUBMIT_FAILED_GOT_IT',
	STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_FAILED: 'STUDENT/SUBMIT_LEAD_GOOGLE_TOKEN_FAILED',
	STUDENT_SUBMIT_LEAD_GOOGLE_TOKEN_SUCCESS: 'STUDENT/SUBMIT_LEAD_GOOGLE_TOKEN_SUCCESS',
	STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_FAILED: 'STUDENT/SUBMIT_LEAD_OFFICE_365_TOKEN_FAILED',
	STUDENT_SUBMIT_LEAD_OFFICE_365_TOKEN_SUCCESS: 'STUDENT/SUBMIT_LEAD_OFFICE_365_TOKEN_SUCCESS',
	STUDENT_SUBMIT_OEQ_ANSWER: 'STUDENT/SUBMIT_OEQ_ANSWER',
	STUDENT_SUBMIT_OEQ_CANCEL: 'STUDENT/SUBMIT_OEQ_CANCEL',
	STUDENT_SUBMIT_OEQ_CONFIRMED: 'STUDENT/SUBMIT_OEQ_CONFIRMED',
	STUDENT_SUBMIT_OEQ_EDIT: 'STUDENT/SUBMIT_OEQ_EDIT',
	STUDENT_SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM: 'STUDENT/SUBMIT_OEQ_EMPTY_ANSWER_CONFIRM',
	STUDENT_SUBMIT_OEQ_REVIEW: 'STUDENT/SUBMIT_OEQ_REVIEW',
	STUDENT_SUBMIT_POLL_ANSWERS: 'STUDENT/SUBMIT_POLL_ANSWERS',
	STUDENT_SUBMIT_POLL_CANCEL: 'STUDENT/SUBMIT_POLL_CANCEL',
	STUDENT_SUBMIT_POLL_CONFIRM: 'STUDENT/SUBMIT_POLL_CONFIRM',
	STUDENT_SUBMIT_POLL_CONFIRMED: 'STUDENT/SUBMIT_POLL_CONFIRMED',
	STUDENT_SUBMIT_POLL_EDIT: 'STUDENT/SUBMIT_POLL_EDIT',
	STUDENT_POLL_NAVIGATE_BACK: 'STUDENT/POLL_NAVIGATE_BACK',
	STUDENT_SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM: 'STUDENT/SUBMIT_POLL_EMPTY_ANSWERS_CONFIRM',
	STUDENT_SUBMIT_POLL_REVIEW: 'STUDENT/SUBMIT_POLL_REVIEW',
	STUDENT_SUBMIT_QUIZ_ANSWERS: 'STUDENT/SUBMIT_QUIZ_ANSWERS',
	STUDENT_SUBMIT_QUIZ_CANCEL: 'STUDENT/SUBMIT_QUIZ_CANCEL',
	STUDENT_SUBMIT_QUIZ_CONFIRMED: 'STUDENT/SUBMIT_QUIZ_CONFIRMED',
	STUDENT_SUBMIT_QUIZ_EDIT: 'STUDENT/SUBMIT_QUIZ_EDIT',
	STUDENT_OEQ_NAVIGATE_BACK: 'STUDENT/OEQ_NAVIGATE_BACK',
	STUDENT_SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM: 'STUDENT/SUBMIT_QUIZ_EMPTY_ANSWERS_CONFIRM',
	STUDENT_SUBMIT_QUIZ_REVIEW: 'STUDENT/SUBMIT_QUIZ_REVIEW',
	STUDENT_SUBMIT_SKIPPED: 'STUDENT/SUBMIT_SKIPPED',
	STUDENT_TIMER_DRAW_IT_ENDED: 'STUDENT/TIMER_DRAW_IT_ENDED',
	STUDENT_TIMER_OEQ_ENDED: 'STUDENT/TIMER_OEQ_ENDED',
	STUDENT_TIMER_POLL_ENDED: 'STUDENT/TIMER_POLL_ENDED',
	STUDENT_TIMER_QUIZ_ENDED: 'STUDENT/TIMER_QUIZ_ENDED',
	STUDENT_TIMER_STARTED: 'STUDENT/TIMER_STARTED',
	STUDENT_TIMER_UPDATED: 'STUDENT/TIMER_UPDATED',
	STUDENT_UPDATE_DRAW_IT_ANSWERS: 'STUDENT/UPDATE_DRAW_IT_ANSWERS',
	STUDENT_UPDATE_OEQ_ANSWER: 'STUDENT/UPDATE_OEQ_ANSWER',
	STUDENT_UPDATE_POLL_ANSWERS: 'STUDENT/UPDATE_POLL_ANSWERS',
	STUDENT_UPDATE_QUIZ_ANSWERS: 'STUDENT/UPDATE_QUIZ_ANSWERS',
	SYNC_UNCAUGHT_ERROR: 'SYNC/UNCAUGHT_ERROR',
	TEACHER_PRIVATE_LIBRARY_ROUTE_INITIALIZE: 'TEACHER_PRIVATE_LIBRARY/PRIVATE_LIBRARY_ROUTE_INITIALIZE',
	THEMES_CHANGE: 'THEMES/CHANGE',
	THEMES_CHANGE_PAYWALL: 'THEMES/CHANGE_PAYWALL',
	THEMES_CHANGE_SUCCESS: 'THEMES/CHANGE_SUCCESS',
	THEMES_INITIALIZE: 'THEMES/INITIALIZE',
	THEMES_SET_ALL: 'THEMES/SET_ALL',
	THEMES_TOGGLE_MENU: 'THEMES/TOGGLE_MENU',
	TOGGLE_SIDEBAR: 'TOGGLE_SIDEBAR',
	TOPBAR_REDIRECT: 'TOPBAR/REDIRECT',
	TOPBAR_SIGN_IN: 'TOPBAR/SIGN_IN',
	TOPBAR_SIGN_UP: 'TOPBAR/SIGN_UP',
	UI_WINDOW_RESIZE: 'UI/WINDOW_RESIZE',
	USER_ACCEPT_TERMS_AND_CONDITIONS: 'USER/ACCEPT_TERMS_AND_CONDITIONS',
	USER_ACCEPT_TERMS_AND_CONDITIONS_ERROR: 'USER/ACCEPT_TERMS_AND_CONDITIONS_ERROR',
	USER_ACCEPT_TERMS_AND_CONDITIONS_SUCCESS: 'USER/ACCEPT_TERMS_AND_CONDITIONS_SUCCESS',
	USER_CANNY_IDENTIFY_ERROR: 'USER/CANNY/IDENTIFY_ERROR',
	USER_CANNY_IDENTIFY_SUCCESS: 'USER/CANNY/IDENTIFY_SUCCESS',
	USER_COMPLEMENTARY_DATA_FETCHED: 'USER/COMPLEMENTARY_DATA_FETCHED',
	USER_COOKIE_BLOCKED_FAILED: 'USER/COOKIE_BLOCKED/FAILED',
	USER_COOKIE_BLOCKED_LEARN_MORE: 'USER/COOKIE_BLOCKED_LEARN_MORE',
	USER_COOKIE_BLOCKED_RETRY: 'USER/COOKIE_BLOCKED/RETRY',
	USER_DATA_FETCHED: 'USER/DATA_FETCHED',
	USER_EXTRA_DATA: 'USER/EXTRA_DATA',
	USER_GET_DATA: 'USER/GET_DATA',
	USER_GET_TOOLTIPS: 'USER/GET_TOOLTIPS',
	USER_IDENTIFY_SUCCESS: 'USER/IDENTIFY_SUCCESS',
	USER_IS_AUTOLOGGED: 'USER/IS_AUTOLOGGED',
	USER_IS_LOGGED: 'USER/IS_LOGGED',
	USER_IS_NOT_LOGGED: 'USER/IS_NOT_LOGGED',
	USER_NOT_LOGGED_IN_CONFIRM: 'USER/NOT_LOGGED_IN_CONFIRM',
	USER_PERMISSIONS_FETCH_FAILED: 'USER/PERMISSIONS/FETCH_FAILED',
	USER_PERMISSIONS_FETCH_SUCCESS: 'USER/PERMISSIONS/FETCH_SUCCESS',
	USER_RESET_EXTRA_DATA: 'USER/RESET_EXTRA_DATA',
	USER_SCHOOL_PROFILE_INITIALIZE: 'USER_SCHOOL_PROFILE/INITIALIZE',
	USER_SCHOOL_PROFILE_SAVE: 'USER_SCHOOL_PROFILE/SAVE',
	USER_SCHOOL_PROFILE_SAVE_FAILED: 'USER_SCHOOL_PROFILE/SAVE_FAILED',
	USER_SCHOOL_PROFILE_SAVE_SUCCESS: 'USER_SCHOOL_PROFILE/SAVE_SUCCESS',
	USER_SEND_SUGGESTIONS_BUTTON_SELECTED: 'USER_SEND_SUGGESTIONS_BUTTON_SELECTED',
	USER_TOOLTIP_INITIALIZE: 'USER/TOOLTIP/INITIALIZE',
	USER_UPDATE_TOOLTIP: 'USER/UPDATE_TOOLTIP',
	USER_UPDATE_TOOLTIP_ERROR: 'USER/UPDATE_TOOLTIP_ERROR',
	USER_UPGRADE_ACTION_SELECTED: 'USER/UPGRADE_ACTION_SELECTED',
	USER_UPGRADE_MESSAGE: 'USER/UPGRADE_MESSAGE',
	VFT_PLACE_CHANGE: 'VFT/PLACE_CHANGE',
	VFT_QUESTION_CHANGE: 'VFT/QUESTION_CHANGE',
	VIDEO_CANCEL: 'VIDEO/CANCEL',
	VIDEO_CANCEL_CONFIRMED: 'VIDEO/CANCEL_CONFIRMED',
	VIDEO_CANCEL_REJECTED: 'VIDEO/CANCEL_REJECTED',
	VIDEO_COPY_FAILED: 'VIDEO/COPY_FAILED',
	VIDEO_CREATION_MCQ_INITIALIZE: 'VIDEO_CREATION/MCQ/INITIALIZE',
	VIDEO_CREATION_OEQ_INITIALIZE: 'VIDEO_CREATION/OEQ/INITIALIZE',
	VIDEO_HANDOUT_SELECTED: 'VIDEO/HANDOUT_SELECTED',
	VIDEO_INITIALIZE_CREATION_TOOL_BASE: 'VIDEO/INITIALIZE_CREATION_TOOL_BASE',
	VIDEO_INITIALIZE_EDIT_ROUTE: 'VIDEO/INITIALIZE_EDIT_ROUTE',
	VIDEO_INITIALIZE_PICKER_ROUTE: 'VIDEO/INITIALIZE_PICKER_ROUTE',
	VIDEO_MY_VIDEOS_GET_LESSONS_NEXT_PAGE: 'VIDEO/MY_VIDEOS/GET_LESSONS_NEXT_PAGE',
	VIDEO_MY_VIDEOS_LESSON_SELECTED: 'VIDEO/MY_VIDEOS/LESSON_SELECTED',
	VIDEO_MY_VIDEOS_PICKER_FINALIZED: 'VIDEO/MY_VIDEOS_PICKER/FINALIZED',
	VIDEO_MY_VIDEOS_PICKER_INITIALIZED: 'VIDEO/MY_VIDEOS_PICKER/INITIALIZED',
	VIDEO_MY_VIDEOS_PICKER_QUERY_SEARCH: 'VIDEO/MY_VIDEOS_PICKER/QUERY_SEARCH',
	VIDEO_PICKER_TAB_SELECTED: 'VIDEO/PICKER_TAB_SELECTED',
	VIDEO_SAVE: 'VIDEO/SAVE',
	VIDEO_SAVE_FAILED: 'VIDEO/SAVE_FAILED',
	VIDEO_SAVE_SUCCESS: 'VIDEO/SAVE_SUCCESS',
	VIDEO_STANDALONE_INITIALIZE_BASE: 'VIDEO/STANDALONE/INITIALIZE_BASE',
	VIDEO_STANDALONE_INITIALIZE_EDIT_ROUTE: 'VIDEO/STANDALONE_INITIALIZE_EDIT_ROUTE',
	VIDEO_STANDALONE_INITIALIZE_PICKER_ROUTE: 'VIDEO/STANDALONE_INITIALIZE_PICKER_ROUTE',
	VIDEO_STANDALONE_MCQ_FINALIZE: 'VIDEO/STANDALONE/MCQ_FINALIZE',
	VIDEO_STANDALONE_MCQ_INITIALIZE: 'VIDEO/STANDALONE/MCQ_INITIALIZE',
	VIDEO_STANDALONE_OEQ_FINALIZE: 'VIDEO/STANDALONE/OEQ_FINALIZE',
	VIDEO_STANDALONE_OEQ_INITIALIZE: 'VIDEO/STANDALONE/OEQ_INITIALIZE',
	VIDEO_STANDALONE_UPDATE_PICKER_ROUTE: 'VIDEO/STANDALONE_UPDATE_PICKER_ROUTE',
	VIDEO_STORE_LESSON_COPIED_FAILED: 'VIDEO/STORE_LESSON_COPIED_FAILED',
	VIDEO_STORE_LESSON_COPIED_SUCCESS: 'VIDEO/STORE_LESSON_COPIED_SUCCESS',
	VIDEO_STORE_LESSON_SELECTED: 'VIDEO/STORE_LESSON_SELECTED',
	VIDEO_STORE_PICKER_INITIALIZED: 'VIDEO/STORE_PICKER_INITIALIZED',
	VIDEO_STORE_PICKER_UPDATED: 'VIDEO/STORE_PICKER_UPDATED',
	VIDEO_UPDATE_PICKER_ROUTE: 'VIDEO/UPDATE_PICKER_ROUTE',
	WHITEBOARD_ACTIONS_CHANGED: 'WHITEBOARD/ACTIONS_CHANGED',
	WHITEBOARD_ACTIONS_RECEIVED: 'WHITEBOARD/ACTIONS_RECEIVED',
	WHITEBOARD_DISABLE: 'WHITEBOARD/DISABLE',
	WHITEBOARD_DISABLED: 'WHITEBOARD/DISABLED',
	WHITEBOARD_DISCONNECTED: 'WHITEBOARD/DISCONNECTED',
	WHITEBOARD_DRAWING_FETCHED: 'WHITEBOARD/DRAWING_FETCHED',
	WHITEBOARD_ENABLE: 'WHITEBOARD/ENABLE',
	WHITEBOARD_ENABLED: 'WHITEBOARD/ENABLED',
	WHITEBOARD_FETCHED: 'WHITEBOARD/FETCHED',
	WHITEBOARD_INITIALIZATION_FAILED: 'WHITEBOARD/INITIALIZATION_FAILED',
	WHITEBOARD_MOUNTED: 'WHITEBOARD/MOUNTED',
	WHITEBOARD_SET_BACKGROUND: 'WHITEBOARD/SET_BACKGROUND',
	WHITEBOARD_TOGGLE_BACKGROUND: 'WHITEBOARD/TOGGLE_BACKGROUND',
	WHITEBOARD_UNMOUNTED: 'WHITEBOARD/UNMOUNTED',
	WHITEBOARD_UPDATED: 'WHITEBOARD/UPDATED',
	YOUTUBE_PICKER_UPDATE_SEARCH: 'YOUTUBE_PICKER/UPDATE_SEARCH',
}


export default actionTypes
